webpackJsonp([1],{

/***/ 121:
/***/ (function(module, exports) {

/* eslint-disable */

(function () {
	L.Control.FullScreen = L.Control.extend({
		options: {
			position: 'topleft',
			title: 'Full Screen',
			titleCancel: 'Exit Full Screen',
			forceSeparateButton: false,
			forcePseudoFullscreen: false,
			fullscreenElement: false
		},

		onAdd: function onAdd(map) {
			var className = 'leaflet-control-zoom-fullscreen',
			    container,
			    content = '';

			if (map.zoomControl && !this.options.forceSeparateButton) {
				container = map.zoomControl._container;
			} else {
				container = L.DomUtil.create('div', 'leaflet-bar');
			}

			if (this.options.content) {
				content = this.options.content;
			} else {
				className += ' fullscreen-icon';
			}

			this._createButton(this.options.title, className, content, container, this.toggleFullScreen, this);

			this._map.on('enterFullscreen exitFullscreen', this._toggleTitle, this);

			return container;
		},

		_createButton: function _createButton(title, className, content, container, fn, context) {
			this.link = L.DomUtil.create('a', className, container);
			this.link.href = '#';
			this.link.title = title;
			this.link.innerHTML = content;

			L.DomEvent.addListener(this.link, 'click', L.DomEvent.stopPropagation).addListener(this.link, 'click', L.DomEvent.preventDefault).addListener(this.link, 'click', fn, context);

			L.DomEvent.addListener(container, fullScreenApi.fullScreenEventName, L.DomEvent.stopPropagation).addListener(container, fullScreenApi.fullScreenEventName, L.DomEvent.preventDefault).addListener(container, fullScreenApi.fullScreenEventName, this._handleEscKey, context);

			L.DomEvent.addListener(document, fullScreenApi.fullScreenEventName, L.DomEvent.stopPropagation).addListener(document, fullScreenApi.fullScreenEventName, L.DomEvent.preventDefault).addListener(document, fullScreenApi.fullScreenEventName, this._handleEscKey, context);

			return this.link;
		},

		toggleFullScreen: function toggleFullScreen() {
			var map = this._map;
			map._exitFired = false;
			if (map._isFullscreen) {
				if (fullScreenApi.supportsFullScreen && !this.options.forcePseudoFullscreen) {
					fullScreenApi.cancelFullScreen(this.options.fullscreenElement ? this.options.fullscreenElement : map._container);
				} else {
					L.DomUtil.removeClass(map._container, 'leaflet-pseudo-fullscreen');
				}
				map.invalidateSize();
				map.fire('exitFullscreen');
				map._exitFired = true;
				map._isFullscreen = false;
			} else {
				if (fullScreenApi.supportsFullScreen && !this.options.forcePseudoFullscreen) {
					fullScreenApi.requestFullScreen(this.options.fullscreenElement ? this.options.fullscreenElement : map._container);
				} else {
					L.DomUtil.addClass(map._container, 'leaflet-pseudo-fullscreen');
				}
				map.invalidateSize();
				map.fire('enterFullscreen');
				map._isFullscreen = true;
			}
		},

		_toggleTitle: function _toggleTitle() {
			this.link.title = this._map._isFullscreen ? this.options.title : this.options.titleCancel;
		},

		_handleEscKey: function _handleEscKey() {
			var map = this._map;
			if (!fullScreenApi.isFullScreen(map) && !map._exitFired) {
				map.fire('exitFullscreen');
				map._exitFired = true;
				map._isFullscreen = false;
			}
		}
	});

	L.Map.addInitHook(function () {
		if (this.options.fullscreenControl) {
			this.fullscreenControl = L.control.fullscreen(this.options.fullscreenControlOptions);
			this.addControl(this.fullscreenControl);
		}
	});

	L.control.fullscreen = function (options) {
		return new L.Control.FullScreen(options);
	};

	/*
 Native FullScreen JavaScript API
 -------------
 Assumes Mozilla naming conventions instead of W3C for now
 source : http://johndyer.name/native-fullscreen-javascript-api-plus-jquery-plugin/
 */

	var fullScreenApi = {
		supportsFullScreen: false,
		isFullScreen: function isFullScreen() {
			return false;
		},
		requestFullScreen: function requestFullScreen() {},
		cancelFullScreen: function cancelFullScreen() {},
		fullScreenEventName: '',
		prefix: ''
	},
	    browserPrefixes = 'webkit moz o ms khtml'.split(' ');

	// check for native support
	if (typeof document.exitFullscreen !== 'undefined') {
		fullScreenApi.supportsFullScreen = true;
	} else {
		// check for fullscreen support by vendor prefix
		for (var i = 0, il = browserPrefixes.length; i < il; i++) {
			fullScreenApi.prefix = browserPrefixes[i];
			if (typeof document[fullScreenApi.prefix + 'CancelFullScreen'] !== 'undefined') {
				fullScreenApi.supportsFullScreen = true;
				break;
			}
		}
		if (typeof document['msExitFullscreen'] !== 'undefined') {
			fullScreenApi.prefix = 'ms';
			fullScreenApi.supportsFullScreen = true;
		}
	}

	// update methods to do something useful
	if (fullScreenApi.supportsFullScreen) {
		if (fullScreenApi.prefix === 'ms') {
			fullScreenApi.fullScreenEventName = 'MSFullscreenChange';
		} else {
			fullScreenApi.fullScreenEventName = fullScreenApi.prefix + 'fullscreenchange';
		}
		fullScreenApi.isFullScreen = function () {
			switch (this.prefix) {
				case '':
					return document.fullscreen;
				case 'webkit':
					return document.webkitIsFullScreen;
				case 'ms':
					return document.msFullscreenElement;
				default:
					return document[this.prefix + 'FullScreen'];
			}
		};
		fullScreenApi.requestFullScreen = function (el) {
			switch (this.prefix) {
				case '':
					return el.requestFullscreen();
				case 'ms':
					return el.msRequestFullscreen();
				default:
					return el[this.prefix + 'RequestFullScreen']();
			}
		};
		fullScreenApi.cancelFullScreen = function () {
			switch (this.prefix) {
				case '':
					return document.exitFullscreen();
				case 'ms':
					return document.msExitFullscreen();
				default:
					return document[this.prefix + 'CancelFullScreen']();
			}
		};
	}

	// jQuery plugin
	if (typeof jQuery !== 'undefined') {
		jQuery.fn.requestFullScreen = function () {
			return this.each(function () {
				var el = jQuery(this);
				if (fullScreenApi.supportsFullScreen) {
					fullScreenApi.requestFullScreen(el);
				}
			});
		};
	}

	// export api
	window.fullScreenApi = fullScreenApi;
})();
'filehash 4hUCMccDRCJu9bkWvh+YL8eMrW4=';

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* eslint-disable */

(function (root, factory) {
	if (typeof define === 'function' && __webpack_require__(259)) {
		// AMD. Register as an anonymous module.
		define(['leaflet'], factory);
	} else if ((typeof modules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(modules)) === 'object' && module.exports) {
		// define a Common JS module that relies on 'leaflet'
		module.exports = factory(__webpack_require__(253));
	} else {
		// Assume Leaflet is loaded into global object L already
		factory(L);
	}
})(this, function (L) {
	'use strict';

	L.TileLayer.Provider = L.TileLayer.extend({
		initialize: function initialize(arg, options) {
			var providers = L.TileLayer.Provider.providers;

			var parts = arg.split('.');

			var providerName = parts[0];
			var variantName = parts[1];

			if (!providers[providerName]) {
				throw 'No such provider (' + providerName + ')';
			}

			var provider = {
				url: providers[providerName].url,
				options: providers[providerName].options
			};

			// overwrite values in provider from variant.
			if (variantName && 'variants' in providers[providerName]) {
				if (!(variantName in providers[providerName].variants)) {
					throw 'No such variant of ' + providerName + ' (' + variantName + ')';
				}
				var variant = providers[providerName].variants[variantName];
				var variantOptions;
				if (typeof variant === 'string') {
					variantOptions = {
						variant: variant
					};
				} else {
					variantOptions = variant.options;
				}
				provider = {
					url: variant.url || provider.url,
					options: L.Util.extend({}, provider.options, variantOptions)
				};
			}

			// If retina option is set
			if (provider.options.retina) {
				// Check retina screen
				if (options.detectRetina && L.Browser.retina) {
					// The retina option will be active now
					// But we need to prevent Leaflet retina mode
					options.detectRetina = false;
				} else {
					// No retina, remove option
					provider.options.retina = '';
				}
			}

			// replace attribution placeholders with their values from toplevel provider attribution,
			// recursively
			var attributionReplacer = function attributionReplacer(attr) {
				if (attr.indexOf('{attribution.') === -1) {
					return attr;
				}
				return attr.replace(/\{attribution.(\w*)\}/, function (match, attributionName) {
					return attributionReplacer(providers[attributionName].options.attribution);
				});
			};
			provider.options.attribution = attributionReplacer(provider.options.attribution);

			// Compute final options combining provider options with any user overrides
			var layerOpts = L.Util.extend({}, provider.options, options);
			L.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
		}
	});

	/**
  * Definition of providers.
  * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
  */

	L.TileLayer.Provider.providers = {
		OpenStreetMap: {
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			options: {
				maxZoom: 19,
				attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			},
			variants: {
				Mapnik: {},
				BlackAndWhite: {
					url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
					options: {
						maxZoom: 18
					}
				},
				DE: {
					url: 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png',
					options: {
						maxZoom: 18
					}
				},
				France: {
					url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
					options: {
						maxZoom: 20,
						attribution: '&copy; Openstreetmap France | {attribution.OpenStreetMap}'
					}
				},
				HOT: {
					url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
					options: {
						attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
					}
				},
				BZH: {
					url: 'http://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
					options: {
						attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
						bounds: [[46.2, -5.5], [50, 0.7]]
					}
				}
			}
		},
		OpenSeaMap: {
			url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
			options: {
				attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
			}
		},
		OpenTopoMap: {
			url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
			options: {
				maxZoom: 17,
				attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
			}
		},
		/*
  Thunderforest: {
  url: 'https://{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
  options: {
  attribution:
  	'&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
  variant: 'cycle',
  apikey: '<insert your api key here>',
  maxZoom: 22
  },
  variants: {
  OpenCycleMap: 'cycle',
  Transport: {
  	options: {
  		variant: 'transport'
  	}
  },
  TransportDark: {
  	options: {
  		variant: 'transport-dark'
  	}
  },
  SpinalMap: {
  	options: {
  		variant: 'spinal-map'
  	}
  },
  Landscape: 'landscape',
  Outdoors: 'outdoors',
  Pioneer: 'pioneer'
  }
  },
  */
		OpenMapSurfer: {
			url: 'https://korona.geog.uni-heidelberg.de/tiles/{variant}/x={x}&y={y}&z={z}',
			options: {
				maxZoom: 20,
				variant: 'roads',
				attribution: 'Imagery from <a href="http://giscience.uni-hd.de/">GIScience Research Group @ University of Heidelberg</a> &mdash; Map data {attribution.OpenStreetMap}'
			},
			variants: {
				Roads: 'roads',
				AdminBounds: {
					options: {
						variant: 'adminb',
						maxZoom: 19
					}
				},
				Grayscale: {
					options: {
						variant: 'roadsg',
						maxZoom: 19
					}
				}
			}
		},
		Hydda: {
			url: 'https://{s}.tile.openstreetmap.se/hydda/{variant}/{z}/{x}/{y}.png',
			options: {
				maxZoom: 18,
				variant: 'full',
				attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data {attribution.OpenStreetMap}'
			},
			variants: {
				Full: 'full',
				Base: 'base',
				RoadsAndLabels: 'roads_and_labels'
			}
		},
		MapBox: {
			url: 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				subdomains: 'abcd',
				id: 'streets',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		RedPins: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cj8a5r73162xj2sr3g8ajtn0v/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Map designed by Alto.Photo. Imagery from Mapbox',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		TownBoundaries: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cj84l42cs0sto2rkscn16kr7w/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Map designed by Alto.Photo. Imagery from Mapbox',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		TownAndCountry: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cj89zxu1j5w742rk7t1x8vvvv/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		BasicMapbox: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cja75t6cv53ha2smw8klm7h9k/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		Satellite: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cja75y07p540k2spn6tfoh42k/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		SatelliteStreets: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cja7691sd53vs2so222ytty85/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		Outdoors: {
			url: 'https://api.mapbox.com/styles/v1/altophoto/cja75wqs453kd2so2720o3bpe/tiles/256/{z}/{x}/{y}?access_token={accessToken}',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		Pirates: {
			url: 'http://api.mapbox.com/v4/mapbox.pirates.html?access_token={accessToken}#3/0.00/0.00',
			options: {
				attribution: 'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				accessToken: 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'
			}
		},
		Stamen: {
			url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}',
			options: {
				attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, ' + '<a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; ' + 'Map data {attribution.OpenStreetMap}',
				subdomains: 'abcd',
				minZoom: 0,
				maxZoom: 20,
				variant: 'toner',
				ext: 'png'
			},
			variants: {
				Toner: 'toner',
				TonerBackground: 'toner-background',
				TonerHybrid: 'toner-hybrid',
				TonerLines: 'toner-lines',
				TonerLabels: 'toner-labels',
				TonerLite: 'toner-lite',
				Watercolor: {
					options: {
						variant: 'watercolor',
						minZoom: 1,
						maxZoom: 22
					}
				},
				Terrain: {
					options: {
						variant: 'terrain',
						minZoom: 0,
						maxZoom: 18
					}
				},
				TerrainBackground: {
					options: {
						variant: 'terrain-background',
						minZoom: 0,
						maxZoom: 18
					}
				},
				TopOSMRelief: {
					options: {
						variant: 'toposm-color-relief',
						ext: 'jpg',
						bounds: [[22, -132], [51, -56]]
					}
				},
				TopOSMFeatures: {
					options: {
						variant: 'toposm-features',
						bounds: [[22, -132], [51, -56]],
						opacity: 0.9
					}
				}
			}
		},
		Esri: {
			url: 'https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
			options: {
				variant: 'World_Street_Map',
				attribution: 'Tiles &copy; Esri'
			},
			variants: {
				WorldStreetMap: {
					options: {
						attribution: '{attribution.Esri} &mdash; ' + 'Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
					}
				},
				DeLorme: {
					options: {
						variant: 'Specialty/DeLorme_World_Base_Map',
						minZoom: 1,
						maxZoom: 11,
						attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
					}
				},
				WorldTopoMap: {
					options: {
						variant: 'World_Topo_Map',
						attribution: '{attribution.Esri} &mdash; ' + 'Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
					}
				},
				WorldImagery: {
					options: {
						variant: 'World_Imagery',
						attribution: '{attribution.Esri} &mdash; ' + 'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
					}
				},
				WorldTerrain: {
					options: {
						variant: 'World_Terrain_Base',
						maxZoom: 13,
						attribution: '{attribution.Esri} &mdash; ' + 'Source: USGS, Esri, TANA, DeLorme, and NPS'
					}
				},
				WorldShadedRelief: {
					options: {
						variant: 'World_Shaded_Relief',
						maxZoom: 13,
						attribution: '{attribution.Esri} &mdash; Source: Esri'
					}
				},
				WorldPhysical: {
					options: {
						variant: 'World_Physical_Map',
						maxZoom: 8,
						attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
					}
				},
				OceanBasemap: {
					options: {
						variant: 'Ocean_Basemap',
						maxZoom: 13,
						attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
					}
				},
				NatGeoWorldMap: {
					options: {
						variant: 'NatGeo_World_Map',
						maxZoom: 16,
						attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
					}
				},
				WorldGrayCanvas: {
					options: {
						variant: 'Canvas/World_Light_Gray_Base',
						maxZoom: 16,
						attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
					}
				}
			}
		},
		OpenWeatherMap: {
			url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png?appid={apiKey}',
			options: {
				maxZoom: 19,
				attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
				apiKey: '<insert your api key here>',
				opacity: 0.5
			},
			variants: {
				Clouds: 'clouds',
				CloudsClassic: 'clouds_cls',
				Precipitation: 'precipitation',
				PrecipitationClassic: 'precipitation_cls',
				Rain: 'rain',
				RainClassic: 'rain_cls',
				Pressure: 'pressure',
				PressureContour: 'pressure_cntr',
				Wind: 'wind',
				Temperature: 'temp',
				Snow: 'snow'
			}
		},
		HERE: {
			/*
    * HERE maps, formerly Nokia maps.
    * These basemaps are free, but you need an API key. Please sign up at
    * http://developer.here.com/getting-started
    *
    * Note that the base urls contain '.cit' whichs is HERE's
    * 'Customer Integration Testing' environment. Please remove for production
    * envirionments.
    */
			url: 'https://{s}.{base}.maps.cit.api.here.com/maptile/2.1/' + '{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' + 'app_id={app_id}&app_code={app_code}&lg={language}',
			options: {
				attribution: 'Map &copy; 1987-2014 <a href="http://developer.here.com">HERE</a>',
				subdomains: '1234',
				mapID: 'newest',
				'app_id': '<insert your app_id here>',
				'app_code': '<insert your app_code here>',
				base: 'base',
				variant: 'normal.day',
				maxZoom: 20,
				type: 'maptile',
				language: 'eng',
				format: 'png8',
				size: '256'
			},
			variants: {
				normalDay: 'normal.day',
				normalDayCustom: 'normal.day.custom',
				normalDayGrey: 'normal.day.grey',
				normalDayMobile: 'normal.day.mobile',
				normalDayGreyMobile: 'normal.day.grey.mobile',
				normalDayTransit: 'normal.day.transit',
				normalDayTransitMobile: 'normal.day.transit.mobile',
				normalNight: 'normal.night',
				normalNightMobile: 'normal.night.mobile',
				normalNightGrey: 'normal.night.grey',
				normalNightGreyMobile: 'normal.night.grey.mobile',

				basicMap: {
					options: {
						type: 'basetile'
					}
				},
				mapLabels: {
					options: {
						type: 'labeltile',
						format: 'png'
					}
				},
				trafficFlow: {
					options: {
						base: 'traffic',
						type: 'flowtile'
					}
				},
				carnavDayGrey: 'carnav.day.grey',
				hybridDay: {
					options: {
						base: 'aerial',
						variant: 'hybrid.day'
					}
				},
				hybridDayMobile: {
					options: {
						base: 'aerial',
						variant: 'hybrid.day.mobile'
					}
				},
				pedestrianDay: 'pedestrian.day',
				pedestrianNight: 'pedestrian.night',
				satelliteDay: {
					options: {
						base: 'aerial',
						variant: 'satellite.day'
					}
				},
				terrainDay: {
					options: {
						base: 'aerial',
						variant: 'terrain.day'
					}
				},
				terrainDayMobile: {
					options: {
						base: 'aerial',
						variant: 'terrain.day.mobile'
					}
				}
			}
		},
		FreeMapSK: {
			url: 'http://t{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
			options: {
				minZoom: 8,
				maxZoom: 16,
				subdomains: '1234',
				bounds: [[47.204642, 15.996093], [49.830896, 22.576904]],
				attribution: '{attribution.OpenStreetMap}, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
			}
		},
		MtbMap: {
			url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
			options: {
				attribution: '{attribution.OpenStreetMap} &amp; USGS'
			}
		},
		CartoDB: {
			url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/{variant}/{z}/{x}/{y}.png',
			options: {
				attribution: '{attribution.OpenStreetMap} &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
				subdomains: 'abcd',
				maxZoom: 19,
				variant: 'light_all'
			},
			variants: {
				Positron: 'light_all',
				PositronNoLabels: 'light_nolabels',
				PositronOnlyLabels: 'light_only_labels',
				DarkMatter: 'dark_all',
				DarkMatterNoLabels: 'dark_nolabels',
				DarkMatterOnlyLabels: 'dark_only_labels'
			}
		},
		HikeBike: {
			url: 'http://{s}.tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
			options: {
				maxZoom: 19,
				attribution: '{attribution.OpenStreetMap}',
				variant: 'hikebike'
			},
			variants: {
				HikeBike: {},
				HillShading: {
					options: {
						maxZoom: 15,
						variant: 'hillshading'
					}
				}
			}
		},
		BasemapAT: {
			url: 'https://maps{s}.wien.gv.at/basemap/{variant}/normal/google3857/{z}/{y}/{x}.{format}',
			options: {
				maxZoom: 19,
				attribution: 'Datenquelle: <a href="www.basemap.at">basemap.at</a>',
				subdomains: ['', '1', '2', '3', '4'],
				format: 'png',
				bounds: [[46.358770, 8.782379], [49.037872, 17.189532]],
				variant: 'geolandbasemap'
			},
			variants: {
				basemap: {
					options: {
						maxZoom: 20, // currently only in Vienna
						variant: 'geolandbasemap'
					}
				},
				grau: 'bmapgrau',
				overlay: 'bmapoverlay',
				highdpi: {
					options: {
						variant: 'bmaphidpi',
						format: 'jpeg'
					}
				},
				orthofoto: {
					options: {
						maxZoom: 20, // currently only in Vienna
						variant: 'bmaporthofoto30cm',
						format: 'jpeg'
					}
				}
			}
		},
		nlmaps: {
			url: 'https://geodata.nationaalgeoregister.nl/tiles/service/wmts/{variant}/EPSG:3857/{z}/{x}/{y}.png',
			options: {
				minZoom: 6,
				maxZoom: 19,
				bounds: [[50.5, 3.25], [54, 7.6]],
				attribution: 'Kaartgegevens &copy; <a href="kadaster.nl">Kadaster</a>'
			},
			variants: {
				'standaard': 'brtachtergrondkaart',
				'pastel': 'brtachtergrondkaartpastel',
				'grijs': 'brtachtergrondkaartgrijs',
				'luchtfoto': {
					'url': 'https://geodata.nationaalgeoregister.nl/luchtfoto/rgb/wmts/1.0.0/2016_ortho25/EPSG:3857/{z}/{x}/{y}.png'
				}
			}
		},
		NASAGIBS: {
			url: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
			options: {
				attribution: 'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System ' + '(<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
				bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
				minZoom: 1,
				maxZoom: 9,
				format: 'jpg',
				time: '',
				tilematrixset: 'GoogleMapsCompatible_Level'
			},
			variants: {
				ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
				ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
				ViirsEarthAtNight2012: {
					options: {
						variant: 'VIIRS_CityLights_2012',
						maxZoom: 8
					}
				},
				ModisTerraLSTDay: {
					options: {
						variant: 'MODIS_Terra_Land_Surface_Temp_Day',
						format: 'png',
						maxZoom: 7,
						opacity: 0.75
					}
				},
				ModisTerraSnowCover: {
					options: {
						variant: 'MODIS_Terra_Snow_Cover',
						format: 'png',
						maxZoom: 8,
						opacity: 0.75
					}
				},
				ModisTerraAOD: {
					options: {
						variant: 'MODIS_Terra_Aerosol',
						format: 'png',
						maxZoom: 6,
						opacity: 0.75
					}
				},
				ModisTerraChlorophyll: {
					options: {
						variant: 'MODIS_Terra_Chlorophyll_A',
						format: 'png',
						maxZoom: 7,
						opacity: 0.75
					}
				}
			}
		},
		NLS: {
			// NLS maps are copyright National library of Scotland.
			// http://maps.nls.uk/projects/api/index.html
			// Please contact NLS for anything other than non-commercial low volume usage
			//
			// Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
			//   z0-9  - 1:1m
			//  z10-11 - quarter inch (1:253440)
			//  z12-18 - one inch (1:63360)
			url: 'https://nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
			options: {
				attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
				bounds: [[49.6, -12], [61.7, 3]],
				minZoom: 1,
				maxZoom: 18,
				subdomains: '0123'
			}
		},
		JusticeMap: {
			// Justice Map (http://www.justicemap.org/)
			// Visualize race and income data for your community, county and country.
			// Includes tools for data journalists, bloggers and community activists.
			url: 'http://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
			options: {
				attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
				// one of 'county', 'tract', 'block'
				size: 'county',
				// Bounds for USA, including Alaska and Hawaii
				bounds: [[14, -180], [72, -56]]
			},
			variants: {
				income: 'income',
				americanIndian: 'indian',
				asian: 'asian',
				black: 'black',
				hispanic: 'hispanic',
				multi: 'multi',
				nonWhite: 'nonwhite',
				white: 'white',
				plurality: 'plural'
			}
		}
	};

	L.tileLayer.provider = function (provider, options) {
		return new L.TileLayer.Provider(provider, options);
	};

	return L;
});
'filehash Wnw2KDrOLPM6k98r8rjsImlylGY=';
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(260)(module)))

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pixelPicker_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42370dc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pixelPicker_vue__ = __webpack_require__(651);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pixelPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42370dc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pixelPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schoolIndex_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeb622e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_schoolIndex_vue__ = __webpack_require__(663);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schoolIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeb622e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_schoolIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timePicker_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d7af334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timePicker_vue__ = __webpack_require__(655);
function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d7af334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* eslint-disable */

/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/
(function (factory, window) {
    // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
    // for details on how to structure a leaflet plugin.

    // define an AMD module that relies on 'leaflet'
    if (typeof define === 'function' && __webpack_require__(259)) {
        define(['leaflet'], factory);

        // define a Common JS module that relies on 'leaflet'
    } else if ((typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) === 'object') {
        if (typeof window !== 'undefined' && window.L) {
            module.exports = factory(L);
        } else {
            module.exports = factory(__webpack_require__(253));
        }
    }

    // attach your plugin to the global 'L' variable
    if (typeof window !== 'undefined' && window.L) {
        window.L.Control.Locate = factory(L);
    }
})(function (L) {
    var LDomUtilApplyClassesMethod = function LDomUtilApplyClassesMethod(method, element, classNames) {
        classNames = classNames.split(' ');
        classNames.forEach(function (className) {
            L.DomUtil[method].call(this, element, className);
        });
    };

    var addClasses = function addClasses(el, names) {
        LDomUtilApplyClassesMethod('addClass', el, names);
    };
    var removeClasses = function removeClasses(el, names) {
        LDomUtilApplyClassesMethod('removeClass', el, names);
    };

    var LocateControl = L.Control.extend({
        options: {
            /** Position of the control */
            position: 'topleft',
            /** The layer that the user's location should be drawn on. By default creates a new layer. */
            layer: undefined,
            /**
             * Automatically sets the map view (zoom and pan) to the user's location as it updates.
             * While the map is following the user's location, the control is in the `following` state,
             * which changes the style of the control and the circle marker.
             *
             * Possible values:
             *  - false: never updates the map view when location changes.
             *  - 'once': set the view when the location is first determined
             *  - 'always': always updates the map view when location changes.
             *              The map view follows the users location.
             *  - 'untilPan': (default) like 'always', except stops updating the
             *                view if the user has manually panned the map.
             *                The map view follows the users location until she pans.
             */
            setView: 'untilPan',
            /** Keep the current map zoom level when setting the view and only pan. */
            keepCurrentZoomLevel: false,
            /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */
            flyTo: false,
            /**
             * The user location can be inside and outside the current view when the user clicks on the
             * control that is already active. Both cases can be configures separately.
             * Possible values are:
             *  - 'setView': zoom and pan to the current location
             *  - 'stop': stop locating and remove the location marker
             */
            clickBehavior: {
                /** What should happen if the user clicks on the control while the location is within the current view. */
                inView: 'stop',
                /** What should happen if the user clicks on the control while the location is outside the current view. */
                outOfView: 'setView'
            },
            /**
             * If set, save the map bounds just before centering to the user's
             * location. When control is disabled, set the view back to the
             * bounds that were saved.
             */
            returnToPrevBounds: false,
            /**
             * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
             * until the locate API returns a new location before they see where they are again.
             */
            cacheLocation: true,
            /** If set, a circle that shows the location accuracy is drawn. */
            drawCircle: true,
            /** If set, the marker at the users' location is drawn. */
            drawMarker: true,
            /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */
            markerClass: L.CircleMarker,
            /** Accuracy circle style properties. */
            circleStyle: {
                color: '#136AEC',
                fillColor: '#136AEC',
                fillOpacity: 0.15,
                weight: 2,
                opacity: 0.5
            },
            /** Inner marker style properties. Only works if your marker class supports `setStyle`. */
            markerStyle: {
                color: '#136AEC',
                fillColor: '#2A93EE',
                fillOpacity: 0.7,
                weight: 2,
                opacity: 0.9,
                radius: 5
            },
            /**
             * Changes to accuracy circle and inner marker while following.
             * It is only necessary to provide the properties that should change.
             */
            followCircleStyle: {},
            followMarkerStyle: {
                // color: '#FFA500',
                // fillColor: '#FFB000'
            },
            /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */
            icon: 'fa fa-map-marker',
            iconLoading: 'fa fa-spinner fa-spin',
            /** The element to be created for icons. For example span or i */
            iconElementTag: 'span',
            /** Padding around the accuracy circle. */
            circlePadding: [0, 0],
            /** Use metric units. */
            metric: true,
            /**
             * This callback can be used in case you would like to override button creation behavior.
             * This is useful for DOM manipulation frameworks such as angular etc.
             * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
             */
            createButtonCallback: function createButtonCallback(container, options) {
                var link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', container);
                link.title = options.strings.title;
                var icon = L.DomUtil.create(options.iconElementTag, options.icon, link);
                return { link: link, icon: icon };
            },
            /** This event is called in case of any location error that is not a time out error. */
            onLocationError: function onLocationError(err, control) {
                alert(err.message);
            },
            /**
             * This even is called when the user's location is outside the bounds set on the map.
             * The event is called repeatedly when the location changes.
             */
            onLocationOutsideMapBounds: function onLocationOutsideMapBounds(control) {
                control.stop();
                alert(control.options.strings.outsideMapBoundsMsg);
            },
            /** Display a pop-up when the user click on the inner marker. */
            showPopup: true,
            strings: {
                title: "Show me where I am",
                metersUnit: "meters",
                feetUnit: "feet",
                popup: "You are within {distance} {unit} from this point",
                outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
            },
            /** The default options passed to leaflets locate method. */
            locateOptions: {
                maxZoom: Infinity,
                watch: true, // if you overwrite this, visualization cannot be updated
                setView: false // have to set this to false because we have to
                // do setView manually
            }
        },

        initialize: function initialize(options) {
            // set default options if nothing is set (merge one step deep)
            for (var i in options) {
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.options[i]) === 'object') {
                    L.extend(this.options[i], options[i]);
                } else {
                    this.options[i] = options[i];
                }
            }

            // extend the follow marker style and circle from the normal style
            this.options.followMarkerStyle = L.extend({}, this.options.markerStyle, this.options.followMarkerStyle);
            this.options.followCircleStyle = L.extend({}, this.options.circleStyle, this.options.followCircleStyle);
        },

        /**
         * Add control to map. Returns the container for the control.
         */
        onAdd: function onAdd(map) {
            var container = L.DomUtil.create('div', 'leaflet-control-locate leaflet-bar leaflet-control');

            this._layer = this.options.layer || new L.LayerGroup();
            this._layer.addTo(map);
            this._event = undefined;
            this._prevBounds = null;

            var linkAndIcon = this.options.createButtonCallback(container, this.options);
            this._link = linkAndIcon.link;
            this._icon = linkAndIcon.icon;

            L.DomEvent.on(this._link, 'click', L.DomEvent.stopPropagation).on(this._link, 'click', L.DomEvent.preventDefault).on(this._link, 'click', this._onClick, this).on(this._link, 'dblclick', L.DomEvent.stopPropagation);

            this._resetVariables();

            this._map.on('unload', this._unload, this);

            return container;
        },

        /**
         * This method is called when the user clicks on the control.
         */
        _onClick: function _onClick() {
            this._justClicked = true;
            this._userPanned = false;

            if (this._active && !this._event) {
                // click while requesting
                this.stop();
            } else if (this._active && this._event !== undefined) {
                var behavior = this._map.getBounds().contains(this._event.latlng) ? this.options.clickBehavior.inView : this.options.clickBehavior.outOfView;
                switch (behavior) {
                    case 'setView':
                        this.setView();
                        break;
                    case 'stop':
                        this.stop();
                        if (this.options.returnToPrevBounds) {
                            var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                            f.bind(this._map)(this._prevBounds);
                        }
                        break;
                }
            } else {
                if (this.options.returnToPrevBounds) {
                    this._prevBounds = this._map.getBounds();
                }
                this.start();
            }

            this._updateContainerStyle();
        },

        /**
         * Starts the plugin:
         * - activates the engine
         * - draws the marker (if coordinates available)
         */
        start: function start() {
            this._activate();

            if (this._event) {
                this._drawMarker(this._map);

                // if we already have a location but the user clicked on the control
                if (this.options.setView) {
                    this.setView();
                }
            }
            this._updateContainerStyle();
        },

        /**
         * Stops the plugin:
         * - deactivates the engine
         * - reinitializes the button
         * - removes the marker
         */
        stop: function stop() {
            this._deactivate();

            this._cleanClasses();
            this._resetVariables();

            this._removeMarker();
        },

        /**
         * This method launches the location engine.
         * It is called before the marker is updated,
         * event if it does not mean that the event will be ready.
         *
         * Override it if you want to add more functionalities.
         * It should set the this._active to true and do nothing if
         * this._active is true.
         */
        _activate: function _activate() {
            if (!this._active) {
                this._map.locate(this.options.locateOptions);
                this._active = true;

                // bind event listeners
                this._map.on('locationfound', this._onLocationFound, this);
                this._map.on('locationerror', this._onLocationError, this);
                this._map.on('dragstart', this._onDrag, this);
            }
        },

        /**
         * Called to stop the location engine.
         *
         * Override it to shutdown any functionalities you added on start.
         */
        _deactivate: function _deactivate() {
            this._map.stopLocate();
            this._active = false;

            if (!this.options.cacheLocation) {
                this._event = undefined;
            }

            // unbind event listeners
            this._map.off('locationfound', this._onLocationFound, this);
            this._map.off('locationerror', this._onLocationError, this);
            this._map.off('dragstart', this._onDrag, this);
        },

        /**
         * Zoom (unless we should keep the zoom level) and an to the current view.
         */
        setView: function setView() {
            this._drawMarker();
            if (this._isOutsideMapBounds()) {
                this._event = undefined; // clear the current location so we can get back into the bounds
                this.options.onLocationOutsideMapBounds(this);
            } else {
                if (this.options.keepCurrentZoomLevel) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
                    f.bind(this._map)([this._event.latitude, this._event.longitude]);
                } else {
                    var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                    f.bind(this._map)(this._event.bounds, {
                        padding: this.options.circlePadding,
                        maxZoom: this.options.locateOptions.maxZoom
                    });
                }
            }
        },

        /**
         * Draw the marker and accuracy circle on the map.
         *
         * Uses the event retrieved from onLocationFound from the map.
         */
        _drawMarker: function _drawMarker() {
            if (this._event.accuracy === undefined) {
                this._event.accuracy = 0;
            }

            var radius = this._event.accuracy;
            var latlng = this._event.latlng;

            // circle with the radius of the location's accuracy
            if (this.options.drawCircle) {
                var style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;

                if (!this._circle) {
                    this._circle = L.circle(latlng, radius, style).addTo(this._layer);
                } else {
                    this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
                }
            }

            var distance, unit;
            if (this.options.metric) {
                distance = radius.toFixed(0);
                unit = this.options.strings.metersUnit;
            } else {
                distance = (radius * 3.2808399).toFixed(0);
                unit = this.options.strings.feetUnit;
            }

            // small inner marker
            if (this.options.drawMarker) {
                var mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
                if (!this._marker) {
                    this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
                } else {
                    this._marker.setLatLng(latlng);
                    // If the markerClass can be updated with setStyle, update it.
                    if (this._marker.setStyle) {
                        this._marker.setStyle(mStyle);
                    }
                }
            }

            var t = this.options.strings.popup;
            if (this.options.showPopup && t && this._marker) {
                this._marker.bindPopup(L.Util.template(t, { distance: distance, unit: unit }))._popup.setLatLng(latlng);
            }
        },

        /**
         * Remove the marker from map.
         */
        _removeMarker: function _removeMarker() {
            this._layer.clearLayers();
            this._marker = undefined;
            this._circle = undefined;
        },

        /**
         * Unload the plugin and all event listeners.
         * Kind of the opposite of onAdd.
         */
        _unload: function _unload() {
            this.stop();
            this._map.off('unload', this._unload, this);
        },

        /**
         * Calls deactivate and dispatches an error.
         */
        _onLocationError: function _onLocationError(err) {
            // ignore time out error if the location is watched
            if (err.code == 3 && this.options.locateOptions.watch) {
                return;
            }

            this.stop();
            this.options.onLocationError(err, this);
        },

        /**
         * Stores the received event and updates the marker.
         */
        _onLocationFound: function _onLocationFound(e) {
            // no need to do anything if the location has not changed
            if (this._event && this._event.latlng.lat === e.latlng.lat && this._event.latlng.lng === e.latlng.lng && this._event.accuracy === e.accuracy) {
                return;
            }

            if (!this._active) {
                // we may have a stray event
                return;
            }

            this._event = e;

            this._drawMarker();
            this._updateContainerStyle();

            switch (this.options.setView) {
                case 'once':
                    if (this._justClicked) {
                        this.setView();
                    }
                    break;
                case 'untilPan':
                    if (!this._userPanned) {
                        this.setView();
                    }
                    break;
                case 'always':
                    this.setView();
                    break;
                case false:
                    // don't set the view
                    break;
            }

            this._justClicked = false;
        },

        /**
         * When the user drags. Need a separate even so we can bind and unbind even listeners.
         */
        _onDrag: function _onDrag() {
            // only react to drags once we have a location
            if (this._event) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },

        /**
         * Compute whether the map is following the user location with pan and zoom.
         */
        _isFollowing: function _isFollowing() {
            if (!this._active) {
                return false;
            }

            if (this.options.setView === 'always') {
                return true;
            } else if (this.options.setView === 'untilPan') {
                return !this._userPanned;
            }
        },

        /**
         * Check if location is in map bounds
         */
        _isOutsideMapBounds: function _isOutsideMapBounds() {
            if (this._event === undefined) {
                return false;
            }
            return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
        },

        /**
         * Toggles button class between following and active.
         */
        _updateContainerStyle: function _updateContainerStyle() {
            if (!this._container) {
                return;
            }

            if (this._active && !this._event) {
                // active but don't have a location yet
                this._setClasses('requesting');
            } else if (this._isFollowing()) {
                this._setClasses('following');
            } else if (this._active) {
                this._setClasses('active');
            } else {
                this._cleanClasses();
            }
        },

        /**
         * Sets the CSS classes for the state.
         */
        _setClasses: function _setClasses(state) {
            if (state == 'requesting') {
                removeClasses(this._container, "active following");
                addClasses(this._container, "requesting");

                removeClasses(this._icon, this.options.icon);
                addClasses(this._icon, this.options.iconLoading);
            } else if (state == 'active') {
                removeClasses(this._container, "requesting following");
                addClasses(this._container, "active");

                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            } else if (state == 'following') {
                removeClasses(this._container, "requesting");
                addClasses(this._container, "active following");

                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            }
        },

        /**
         * Removes all classes from button.
         */
        _cleanClasses: function _cleanClasses() {
            L.DomUtil.removeClass(this._container, "requesting");
            L.DomUtil.removeClass(this._container, "active");
            L.DomUtil.removeClass(this._container, "following");

            removeClasses(this._icon, this.options.iconLoading);
            addClasses(this._icon, this.options.icon);
        },

        /**
         * Reinitializes state variables.
         */
        _resetVariables: function _resetVariables() {
            // whether locate is active or not
            this._active = false;

            // true if the control was clicked for the first time
            // we need this so we can pan and zoom once we have the location
            this._justClicked = false;

            // true if the user has panned the map after clicking the control
            this._userPanned = false;
        }
    });

    L.control.locate = function (options) {
        return new L.Control.Locate(options);
    };

    return LocateControl;
}, window);
'filehash kAcb++s6E+s9vaU++9V5OFmentA=';
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(260)(module)))

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f82abda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(648);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f82abda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f82abda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mB3_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87b3f77c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mB3_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87b3f77c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mB3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87b3f77c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mB3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapBoard_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e786590_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapBoard_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e786590"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e786590_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_styl__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_toolBox_mapBoard__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Home__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_toolBox_mB3__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_toolBox_schoolIndex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_toolBox_pixelPicker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_toolBox_timePicker__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shared_Alert_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_User_notSignedIn__ = __webpack_require__(630);




// import firebaseui from 'firebaseui'






// import mB2 from '@/components/toolBox/mB2'





// import fireUI from './components/User/fireUI'
// import './components/Shared/config'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    five: '#7fa995', // 5
    ten: '#96c79d', // 10
    fifteen: '#b7ce98', // 15
    twenty: '#e2ba8b', // 20
    twentyfive: '#dfa38d', // 25
    thirty: '#cc8f91', // 30
    thirtyfive: '#7f7f7f',
    info: '#F0E9D8',
    deco: '#3388ff' // iconblue
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('not-signedin', __WEBPACK_IMPORTED_MODULE_14__components_User_notSignedIn__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Home', __WEBPACK_IMPORTED_MODULE_8__components_Home__["a" /* default */]);
// Vue.component('fire-ui', fireUI)
// Vue.component('sign-up', () => import('./components/User/Signup.vue'))
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('school-index', function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 164));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-alert', __WEBPACK_IMPORTED_MODULE_13__components_Shared_Alert_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pixel-picker', function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 163));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('time-picker', function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 165));
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('map-board', __WEBPACK_IMPORTED_MODULE_7__components_toolBox_mapBoard__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('m-b3', __WEBPACK_IMPORTED_MODULE_9__components_toolBox_mB3__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_firebase__["initializeApp"]({
      apiKey: 'AIzaSyAMJTglwuIkeEdzOzQjZEOXUHkqeTWJFi0',
      authDomain: 'micropodvt.firebaseapp.com',
      databaseURL: 'https://micropodvt.firebaseio.com',
      projectId: 'micropodvt',
      storageBucket: 'micropodvt.appspot.com',
      messagingSenderId: '553621790602'
    });
    __WEBPACK_IMPORTED_MODULE_3_firebase__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
        // this.$store.dispatch('fetchUserData')
      }
    });
    // this.$store.dispatch('loadCutouts')
  }
});
'filehash GeGHTJyVmq8XwcyBa0eO8UgUdEE=';

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* eslint-disable */

(function (exports) {

    /*
     * tile.stamen.js v1.3.0
     */

    var SUBDOMAINS = "a. b. c. d.".split(" "),
        MAKE_PROVIDER = function MAKE_PROVIDER(layer, type, minZoom, maxZoom) {
        return {
            "url": ["http://{S}tile.stamen.com/", layer, "/{Z}/{X}/{Y}.", type].join(""),
            "type": type,
            "subdomains": SUBDOMAINS.slice(),
            "minZoom": minZoom,
            "maxZoom": maxZoom,
            "attribution": ['Map tiles by <a href="http://stamen.com/">Stamen Design</a>, ', 'under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. ', 'Data by <a href="http://openstreetmap.org/">OpenStreetMap</a>, ', 'under <a href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>.'].join("")
        };
    },
        PROVIDERS = {
        "toner": MAKE_PROVIDER("toner", "png", 0, 20),
        "terrain": MAKE_PROVIDER("terrain", "png", 0, 18),
        "terrain-classic": MAKE_PROVIDER("terrain-classic", "png", 0, 18),
        "watercolor": MAKE_PROVIDER("watercolor", "jpg", 1, 18),
        "trees-cabs-crime": {
            "url": "http://{S}.tiles.mapbox.com/v3/stamen.trees-cabs-crime/{Z}/{X}/{Y}.png",
            "type": "png",
            "subdomains": "a b c d".split(" "),
            "minZoom": 11,
            "maxZoom": 18,
            "extent": [{ "lat": 37.853, "lon": -122.577 }, { "lat": 37.684, "lon": -122.313 }],
            "attribution": ['Design by Shawn Allen at <a href="http://stamen.com/">Stamen</a>.', 'Data courtesy of <a href="http://fuf.net/">FuF</a>,', '<a href="http://www.yellowcabsf.com/">Yellow Cab</a>', '&amp; <a href="http://sf-police.org/">SFPD</a>.'].join(" ")
        }
    };

    PROVIDERS["terrain-classic"].url = "http://{S}tile.stamen.com/terrain/{Z}/{X}/{Y}.png";

    // set up toner and terrain flavors
    setupFlavors("toner", ["hybrid", "labels", "lines", "background", "lite"]);
    setupFlavors("terrain", ["background", "labels", "lines"]);

    // toner 2010
    deprecate("toner", ["2010"]);

    // toner 2011 flavors
    deprecate("toner", ["2011", "2011-lines", "2011-labels", "2011-lite"]);

    var odbl = ["toner", "toner-hybrid", "toner-labels", "toner-lines", "toner-background", "toner-lite", "terrain", "terrain-background", "terrain-lines", "terrain-labels", "terrain-classic"];

    for (var i = 0; i < odbl.length; i++) {
        var key = odbl[i];

        PROVIDERS[key].retina = true;
        PROVIDERS[key].attribution = ['Map tiles by <a href="http://stamen.com/">Stamen Design</a>, ', 'under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. ', 'Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, ', 'under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.'].join("");
    }

    /*
     * Export stamen.tile to the provided namespace.
     */
    exports.stamen = exports.stamen || {};
    exports.stamen.tile = exports.stamen.tile || {};
    exports.stamen.tile.providers = PROVIDERS;
    exports.stamen.tile.getProvider = getProvider;

    function deprecate(base, flavors) {
        var provider = getProvider(base);

        for (var i = 0; i < flavors.length; i++) {
            var flavor = [base, flavors[i]].join("-");
            PROVIDERS[flavor] = MAKE_PROVIDER(flavor, provider.type, provider.minZoom, provider.maxZoom);
            PROVIDERS[flavor].deprecated = true;
        }
    };

    /*
     * A shortcut for specifying "flavors" of a style, which are assumed to have the
     * same type and zoom range.
     */
    function setupFlavors(base, flavors, type) {
        var provider = getProvider(base);
        for (var i = 0; i < flavors.length; i++) {
            var flavor = [base, flavors[i]].join("-");
            PROVIDERS[flavor] = MAKE_PROVIDER(flavor, type || provider.type, provider.minZoom, provider.maxZoom);
        }
    }

    /*
     * Get the named provider, or throw an exception if it doesn't exist.
     */
    function getProvider(name) {
        if (name in PROVIDERS) {
            var provider = PROVIDERS[name];

            if (provider.deprecated && console && console.warn) {
                console.warn(name + " is a deprecated style; it will be redirected to its replacement. For performance improvements, please change your reference.");
            }

            return provider;
        } else {
            throw 'No such provider (' + name + ')';
        }
    }

    /*
     * StamenTileLayer for modestmaps-js
     * <https://github.com/modestmaps/modestmaps-js/>
     *
     * Works with both 1.x and 2.x by checking for the existence of MM.Template.
     */
    if ((typeof MM === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(MM)) === "object") {
        var ModestTemplate = typeof MM.Template === "function" ? MM.Template : MM.TemplatedMapProvider;
        MM.StamenTileLayer = function (name) {
            var provider = getProvider(name);
            this._provider = provider;
            MM.Layer.call(this, new ModestTemplate(provider.url, provider.subdomains));
            this.provider.setZoomRange(provider.minZoom, provider.maxZoom);
            this.attribution = provider.attribution;
        };

        MM.StamenTileLayer.prototype = {
            setCoordLimits: function setCoordLimits(map) {
                var provider = this._provider;
                if (provider.extent) {
                    map.coordLimits = [map.locationCoordinate(provider.extent[0]).zoomTo(provider.minZoom), map.locationCoordinate(provider.extent[1]).zoomTo(provider.maxZoom)];
                    return true;
                } else {
                    return false;
                }
            }
        };

        MM.extend(MM.StamenTileLayer, MM.Layer);
    }

    /*
     * StamenTileLayer for Leaflet
     * <http://leaflet.cloudmade.com/>
     *
     * Tested with version 0.3 and 0.4, but should work on all 0.x releases.
     */
    if ((typeof L === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(L)) === "object") {
        L.StamenTileLayer = L.TileLayer.extend({
            initialize: function initialize(name, options) {
                var provider = getProvider(name),
                    url = provider.url.replace(/({[A-Z]})/g, function (s) {
                    return s.toLowerCase();
                }),
                    opts = L.Util.extend({}, options, {
                    "minZoom": provider.minZoom,
                    "maxZoom": provider.maxZoom,
                    "subdomains": provider.subdomains,
                    "scheme": "xyz",
                    "attribution": provider.attribution,
                    sa_id: name
                });
                L.TileLayer.prototype.initialize.call(this, url, opts);
            }
        });

        /*
         * Factory function for consistency with Leaflet conventions
         */
        L.stamenTileLayer = function (options, source) {
            return new L.StamenTileLayer(options, source);
        };
    }

    /*
     * StamenTileLayer for OpenLayers
     * <http://openlayers.org/>
     *
     * Tested with v2.1x.
     */
    if ((typeof OpenLayers === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(OpenLayers)) === "object") {
        // make a tile URL template OpenLayers-compatible
        var openlayerize = function openlayerize(url) {
            return url.replace(/({.})/g, function (v) {
                return "$" + v.toLowerCase();
            });
        };

        // based on http://www.bostongis.com/PrinterFriendly.aspx?content_name=using_custom_osm_tiles


        OpenLayers.Layer.Stamen = OpenLayers.Class(OpenLayers.Layer.OSM, {
            initialize: function initialize(name, options) {
                var provider = getProvider(name),
                    url = provider.url,
                    subdomains = provider.subdomains,
                    hosts = [];
                if (url.indexOf("{S}") > -1) {
                    for (var i = 0; i < subdomains.length; i++) {
                        hosts.push(openlayerize(url.replace("{S}", subdomains[i])));
                    }
                } else {
                    hosts.push(openlayerize(url));
                }
                options = OpenLayers.Util.extend({
                    "numZoomLevels": provider.maxZoom,
                    "buffer": 0,
                    "transitionEffect": "resize",
                    // see: <http://dev.openlayers.org/apidocs/files/OpenLayers/Layer/OSM-js.html#OpenLayers.Layer.OSM.tileOptions>
                    // and: <http://dev.openlayers.org/apidocs/files/OpenLayers/Tile/Image-js.html#OpenLayers.Tile.Image.crossOriginKeyword>
                    "tileOptions": {
                        "crossOriginKeyword": null
                    },
                    "attribution": provider.attribution
                }, options);
                return OpenLayers.Layer.OSM.prototype.initialize.call(this, name, hosts, options);
            }
        });
    }

    /*
     * StamenMapType for Google Maps API V3
     * <https://developers.google.com/maps/documentation/javascript/>
     */
    if ((typeof google === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(google)) === "object" && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(google.maps) === "object") {

        // Extending Google class based on a post by Bogart Salzberg of Portland Webworks,
        // http://www.portlandwebworks.com/blog/extending-googlemapsmap-object
        google.maps.ImageMapType = function (_constructor) {
            var f = function f() {
                if (!arguments.length) {
                    return;
                }
                _constructor.apply(this, arguments);
            };
            f.prototype = _constructor.prototype;
            return f;
        }(google.maps.ImageMapType);

        google.maps.StamenMapType = function (name) {
            var provider = getProvider(name),
                subdomains = provider.subdomains;
            return google.maps.ImageMapType.call(this, {
                "getTileUrl": function getTileUrl(coord, zoom) {
                    var numTiles = 1 << zoom,
                        wx = coord.x % numTiles,
                        x = wx < 0 ? wx + numTiles : wx,
                        y = coord.y,
                        index = (zoom + x + y) % subdomains.length;
                    return provider.url.replace("{S}", subdomains[index]).replace("{Z}", zoom).replace("{X}", x).replace("{Y}", y);
                },
                "tileSize": new google.maps.Size(256, 256),
                "name": name,
                "minZoom": provider.minZoom,
                "maxZoom": provider.maxZoom
            });
        };

        // FIXME: is there a better way to extend classes in Google land?
        // Possibly fixed, see above ^^^ | SC
        google.maps.StamenMapType.prototype = new google.maps.ImageMapType();
    }
})(typeof exports === "undefined" ? this : exports);
"filehash C4owTkkZiT6SzIr7hJA6Kc1V6to=";

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/signin');
  }
});
'filehash ciHHid9s+p07+2zKcd3BWfwLXo8=';

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(92);


/* unused harmony default export */ var _unused_webpack_default_export = (function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].dispatch('idFrom', 'mb3');
  next();
});
'filehash XEDu/Buc1Vc0HDfNQ3dY4V9HMaU=';

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(92);


/* unused harmony default export */ var _unused_webpack_default_export = (function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].dispatch('idFrom', 'mapboard');
  next();
});
'filehash D+WElvFd7CHaJdCVmgorZHWvW1c=';

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_User_Signup__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_User_Signin__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_User_Profile__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_User_About__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_toolBox_mapBoard__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_toolBox_mB1__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_toolBox_mB2__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_toolBox_mB3__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_toolBox_schoolIndex__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_toolBox_selectorIndex__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_toolBox_poiIndex__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_toolBox_pixelPicker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_toolBox_basepicker__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_toolBox_timePicker__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_toolBox_typePicker__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_toolBox_inverter__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_toolBox_cluster__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_order_complete__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_order_order__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_order_product__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Home__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Cutout_Cutout__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_User_Introduction_Introduction__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__auth_guard__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__idMb3__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__idMboard__ = __webpack_require__(339);

























// import Introduction from '@/components/User/Introduction/Introduction'

// const Signup = () => import('@/components/User/Signup')
// onst Signin = () => import('@/components/User/Signin')
// const schoolIndex = () => import('@/components/toolBox/schoolIndex')
// const mapBoard = () => import('@/components/toolBox/mapBoard')





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/mB3',
    name: 'mB3',
    component: __WEBPACK_IMPORTED_MODULE_9__components_toolBox_mB3__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__auth_guard__["a" /* default */]
    // beforeRouteLeave: idMb3
  }, {
    path: '/basepicker',
    name: 'basepicker',
    component: __WEBPACK_IMPORTED_MODULE_14__components_toolBox_basepicker__["a" /* default */]
  }, {
    path: '/',
    name: 'mapBoard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_toolBox_mapBoard__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__auth_guard__["a" /* default */]
  }, {
    path: '/typepicker',
    name: 'typePicker',
    component: __WEBPACK_IMPORTED_MODULE_16__components_toolBox_typePicker__["a" /* default */]
  }, {
    path: '/introduction',
    name: 'Introduction',
    component: __WEBPACK_IMPORTED_MODULE_24__components_User_Introduction_Introduction__["a" /* default */]
  }, {
    path: '/mapboard',
    name: 'mapBoard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_toolBox_mapBoard__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__auth_guard__["a" /* default */]
    // beforeRouteLeave: idMboard
    // beforeRouteEnter: DrawerOpen,
    // beforeRouteLeave: DrawerClose
  }, {
    path: '/mb1',
    name: 'mB1',
    component: __WEBPACK_IMPORTED_MODULE_7__components_toolBox_mB1__["a" /* default */]
  },
  /*
  {
    path: '/fireui',
    name: 'fireui',
    component: fireui
  },
  */
  {
    path: '/cutouts/:id',
    name: 'Cutout',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_23__components_Cutout_Cutout__["a" /* default */]
  }, {
    path: '/inverter',
    name: 'inverter',
    component: __WEBPACK_IMPORTED_MODULE_17__components_toolBox_inverter__["a" /* default */]
  }, {
    path: '/selectorindex',
    name: 'selectorIndex',
    component: __WEBPACK_IMPORTED_MODULE_11__components_toolBox_selectorIndex__["a" /* default */]
  }, {
    path: '/poiindex',
    name: 'poiIndex',
    component: __WEBPACK_IMPORTED_MODULE_12__components_toolBox_poiIndex__["a" /* default */]
  }, {
    path: '/order',
    name: 'order',
    component: __WEBPACK_IMPORTED_MODULE_20__components_order_order__["a" /* default */]
  }, {
    path: '/complete',
    name: 'complete',
    component: __WEBPACK_IMPORTED_MODULE_19__components_order_complete__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_2__components_User_Signup__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_User_Signin__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__components_User_About__["a" /* default */]
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_4__components_User_Profile__["a" /* default */]
  }, {
    path: '/schoolindex',
    name: 'schoolIndex',
    component: __WEBPACK_IMPORTED_MODULE_10__components_toolBox_schoolIndex__["default"]
  }, {
    path: '/pixelpicker',
    name: 'pixelPicker',
    component: __WEBPACK_IMPORTED_MODULE_13__components_toolBox_pixelPicker__["default"]
  }, {
    path: '/timepicker',
    name: 'timePicker',
    component: __WEBPACK_IMPORTED_MODULE_15__components_toolBox_timePicker__["default"]
  }],
  mode: 'history'
}));
'filehash W/ZjOshKR78Nu0Q6Rk+G2btLFBo=';

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleMap: false,
      space: '  ',
      info: '#F0E9D8',
      sideNav: false,
      rightNav: false
      /*
      Funky: ['Vintage', 'Ice Cream', 'Desert planet', 'whaam!'],
      Slick: ['Standard', 'North Star', 'Scenic', 'Town and Country', 'Basic Vector'],
      Techno: ['Decimal', 'Terminal'],
      Vermont: ['VT Town Boundaries', 'Red Pins'],
      Outdoors: ['Outdoors Vector', 'Satellite Vector', 'Satellite Streets Vector'],
      Leaflet: ['Hydda', 'Toner', 'Watercolor']
      */
    };
  },

  computed: {
    pickedBaseMap: function pickedBaseMap() {
      return this.$store.getters.baseOption;
    },
    type: function type() {
      return this.$store.getters.type;
    },
    typeIcon: function typeIcon() {
      return this.$store.getters.typeIcon;
    },
    minuteA: function minuteA() {
      return this.$store.getters.minuteA;
    },
    minuteB: function minuteB() {
      return this.$store.getters.minuteB;
    },
    minuteC: function minuteC() {
      return this.$store.getters.minuteC;
    },
    colorA: function colorA() {
      return this.$store.getters.colorA;
    },
    colorB: function colorB() {
      return this.$store.getters.colorB;
    },
    colorC: function colorC() {
      return this.$store.getters.colorC;
    },
    version: function version() {
      return 'v.1.0.14';
    },
    longTitle: function longTitle() {
      return 'decaPodVT a.k.a alto.photo ' + this.version + ' ~ \xA9 Sebastian Noah Frank, Nov. 30 ' + new Date().getFullYear();
    },
    shortTitle: function shortTitle() {
      return this.version + ' \xA9 ' + new Date().getFullYear() + ' alto.photo';
    },
    invertStatus: function invertStatus() {
      return this.$store.getters.inverse;
    },
    clusterStatus: function clusterStatus() {
      return this.$store.getters.cluster;
    },
    minute5: function minute5() {
      return this.$store.getters.minutes[0];
    },
    minute10: function minute10() {
      return this.$store.getters.minutes[1];
    },
    minute15: function minute15() {
      return this.$store.getters.minutes[2];
    },
    minute20: function minute20() {
      return this.$store.getters.minutes[3];
    },
    minute25: function minute25() {
      return this.$store.getters.minutes[4];
    },
    minute30: function minute30() {
      return this.$store.getters.minutes[5];
    },
    minute35: function minute35() {
      return this.$store.getters.minutes[6];
    },
    schTitle: function schTitle() {
      return this.$store.getters.schoolName;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    setPixel: function setPixel() {
      return this.$store.getters.pixel;
    }
  },
  methods: {
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
    },
    pickBase: function pickBase(payload) {
      this.$store.dispatch('pickBase', payload);
      // this.$router.push('/')
    }
  }
});
'filehash U8b1vREetShDD00yQXvs18Sjrko=';

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  computed: {
    cutout: function cutout() {
      return this.$store.getters.loadedCutout(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.cutout.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }
});
'filehash rDHX/RxPYHpJgzmphk4kVRWmHQY=';

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolBox_leaflet_providers__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toolBox_locate_control__ = __webpack_require__(205);

//
//
//
//

/* eslint-disable */

// import './toolBox/Control.FullScreen'



/* harmony default export */ __webpack_exports__["a"] = ({
  updated: function updated() {
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';
  },
  mounted: function mounted() {
    var _L$circleMarker;

    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var lat = this.$store.getters.lat;
    var lng = this.$store.getters.lng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var inverse = this.$store.getters.inverse;
    var sTbM = this.$store.getters.baseOption;
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';

    var basemaps = r360.basemaps('N2T7JHHPOTJAWSFQ7YOMJYH');

    // var map = L.mapbox.map('map').setView(latlng, zoom)
    var map = L.map('map', {
      // fullscreenControl: true,
      zoomControl: false,
      boxZoom: true
    }).setView(latlng, zoom);

    var marker = L.circleMarker(latlng, (_L$circleMarker = {
      'draggable': false,
      radius: 8
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$circleMarker, 'draggable', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$circleMarker, 'title', name), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$circleMarker, 'riseOnHover', true), _L$circleMarker));
    map.addLayer(marker);

    var place1 = L.divIcon({
      html: tN1,
      className: 'place-div-icon',
      'draggable': true,
      iconSize: [300, 40],
      iconAnchor: [380, 270],
      popupAnchor: [0, 0]
    });
    var markerP1 = L.marker(latlng, {
      icon: place1
    });
    map.addLayer(markerP1);
    // var marker = L.marker((latlon), { draggable: true }).addTo(map)

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>";
    L.mapbox.accessToken = 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A';

    // start leaflet providers
    var defaultLayer = new L.StamenTileLayer(sTbM).addTo(map);
    var baseLayers = {
      // Techno
      'Decimal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'),
      'Terminal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'),
      // Vermont
      'VT Town Boundaries': L.mapbox.styleLayer('mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'),
      'Red Pins': L.mapbox.styleLayer('mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'),
      // Open Street Map
      'OpenStreetMap Default': L.tileLayer.provider('OpenStreetMap.Mapnik'),
      'OpenStreetMap German Style': L.tileLayer.provider('OpenStreetMap.DE'),
      'OpenStreetMap Black and White': L.tileLayer.provider('OpenStreetMap.BlackAndWhite'),
      'OpenStreetMap H.O.T.': L.tileLayer.provider('OpenStreetMap.HOT'),
      // Raster
      'Red Pins-Raster': L.tileLayer.provider('RedPins'),
      'VT Town Boundaries-Raster': L.tileLayer.provider('TownBoundaries'),
      'Town and Country-Raster': L.tileLayer.provider('TownAndCountry'),
      'Outdoors-Raster': L.tileLayer.provider('Outdoors'),
      'Raster Satellite': L.tileLayer.provider('Satellite'),
      'Satellite Streets': L.tileLayer.provider('SatelliteStreets'),
      // Slick
      'Hydda': L.tileLayer.provider('Hydda.Full'),
      'Basic Mapbox': L.tileLayer.provider('BasicMapbox'),
      'Basic Vector': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'),
      'Scenic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'),
      'Town and Country': L.mapbox.styleLayer('mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'),
      'Standard': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw705a3qzw2rpjx6t079ds'),
      'North Star': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'),
      // Funky
      'Toner': L.tileLayer.provider('Stamen.Toner'),
      'Watercolor': L.tileLayer.provider('Stamen.Watercolor'),
      'Vintage': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6nax3sgf2sntkany1okv'),
      'Ice Cream': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'),
      'Desert planet': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'),
      'whaam!': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'),
      // Outdoors
      'Terrain': L.tileLayer.provider('Stamen.Terrain'),
      '(vector) Satellite': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'),
      '(vector) Satellite Streets': L.mapbox.styleLayer('mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'),
      'Outdoors': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'),
      // Esri
      'Esri WorldStreetMap': L.tileLayer.provider('Esri.WorldStreetMap'),
      'Esri DeLorme': L.tileLayer.provider('Esri.DeLorme'),
      'Esri WorldTopoMap': L.tileLayer.provider('Esri.WorldTopoMap'),
      'Esri WorldImagery': L.tileLayer.provider('Esri.WorldImagery'),
      'Esri WorldTerrain': L.tileLayer.provider('Esri.WorldTerrain'),
      'Esri WorldShadedRelief': L.tileLayer.provider('Esri.WorldShadedRelief'),
      'Esri WorldPhysical': L.tileLayer.provider('Esri.WorldPhysical'),
      'Esri OceanBasemap': L.tileLayer.provider('Esri.OceanBasemap'),
      'Esri NatGeoWorldMap': L.tileLayer.provider('Esri.NatGeoWorldMap'),
      'Esri WorldGrayCanvas': L.tileLayer.provider('Esri.WorldGrayCanvas')
    };
    var overlayLayers = {
      'OpenSeaMap': L.tileLayer.provider('OpenSeaMap'),
      'OpenWeatherMap Clouds': L.tileLayer.provider('OpenWeatherMap.Clouds'),
      'OpenWeatherMap CloudsClassic': L.tileLayer.provider('OpenWeatherMap.CloudsClassic'),
      'OpenWeatherMap Precipitation': L.tileLayer.provider('OpenWeatherMap.Precipitation'),
      'OpenWeatherMap PrecipitationClassic': L.tileLayer.provider('OpenWeatherMap.PrecipitationClassic'),
      'OpenWeatherMap Rain': L.tileLayer.provider('OpenWeatherMap.Rain'),
      'OpenWeatherMap RainClassic': L.tileLayer.provider('OpenWeatherMap.RainClassic'),
      'OpenWeatherMap Pressure': L.tileLayer.provider('OpenWeatherMap.Pressure'),
      'OpenWeatherMap PressureContour': L.tileLayer.provider('OpenWeatherMap.PressureContour'),
      'OpenWeatherMap Wind': L.tileLayer.provider('OpenWeatherMap.Wind'),
      'OpenWeatherMap Temperature': L.tileLayer.provider('OpenWeatherMap.Temperature'),
      'OpenWeatherMap Snow': L.tileLayer.provider('OpenWeatherMap.Snow')
      // resize layers control to fit into view.
    };function resizeLayerControl() {
      var layerControlHeight = document.body.clientHeight - (10 + 50);
      var layerControl = document.getElementsByClassName('leaflet-control-layers-expanded')[0];
      // layerControl.style.overflowY = 'auto'
      // layerControl.style.maxHeight = layerControlHeight + 'px'
    }
    map.on('resize', resizeLayerControl);
    resizeLayerControl();
    // end leaflet providers
    L.control.locate().addTo(map);
    // L.control.zoom({ position: 'bottomleft' }).addTo(map)

    var opacity = 100;
    var polygonLayer = r360.leafletPolygonLayer({ inverse: inverse });
    map.addLayer(polygonLayer);

    var travelOptions = r360.travelOptions();
    travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH');
    travelOptions.setServiceUrl('https://service.route360.net/na_northeast/');
    travelOptions.addSource(marker);
    travelOptions.setTravelTimes(seconds);
    travelOptions.setTravelType(type);
    if (inverse === true) {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.setColors([{ 'time': seconds[0], 'opacity': opacity / 100 }, { 'time': seconds[1], 'opacity': opacity / 100 - 0.1 }, { 'time': seconds[2], 'opacity': opacity / 100 - 0.2 }]);
        polygonLayer.clearAndAddLayers(polygons, false);
      });
    } else {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.clearAndAddLayers(polygons, true);
      });
    }

    // L.control.layers(baseLayers, basemaps, {collapsed: false}).addTo(map)
    // L.control.layers(basemaps).addTo(map)
    L.control.layers(baseLayers).addTo(map);
    // L.control.scale().addTo(map)
    // L.control.zoom().addTo(map)
  },
  created: function created() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var sTbM = this.$store.getters.baseOption;
  }
});
'filehash TegUgglq4HpUlpXNS08VuYj6bbs=';

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});
'filehash YPuGjuuGGKevKyWCoV1nBIBaFP0=';

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});
"filehash cMvToI2EnFg9HDAL3tx+PMrcs7c=";

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      dialog2: false,
      dialog3: true
    };
  },

  computed: {
    punchlist: function punchlist() {
      return this.$store.getters.punchlist;
    }
  }
});
"filehash ht7GkkmtaJ1BvjdUBBtrwL6JBjU=";

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});
"filehash cMvToI2EnFg9HDAL3tx+PMrcs7c=";

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
      this.$router.push('/');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});
'filehash IH2rxh/4K/ASiwbXzHryEyombOQ=';

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : '';
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignup: function onSignup() {
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});
'filehash Br0TKFoXwJ20fPfImehSqgPehyU=';

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: true
    };
  },

  computed: {
    invertStatus: function invertStatus() {
      return this.$store.getters.inverse;
    },
    minute5to60: function minute5to60() {
      return this.$store.getters.minutes;
    },

    /*
    minute5 () {
      return this.$store.getters.minutes[0]
    },
    minute10 () {
      return this.$store.getters.minutes[1]
    },
    minute15 () {
      return this.$store.getters.minutes[2]
    },
    minute20 () {
      return this.$store.getters.minutes[3]
    },
    minute25 () {
      return this.$store.getters.minutes[4]
    },
    minute30 () {
      return this.$store.getters.minutes[5]
    },
    minute35 () {
      return this.$store.getters.minutes[6]
    },
    */
    schTitle: function schTitle() {
      return this.$store.getters.schoolName;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    setPixel: function setPixel() {
      return this.$store.getters.pixel;
    }
  },
  methods: {
    Dsignin: function Dsignin() {
      this.dialog = false;
      this.$router.push('/signin');
    },

    /*
    Gsignin () {
      this.dialog = false
      this.$router.push('/fireui')
    },
    */
    Dsignup: function Dsignup() {
      this.dialog = false;
      this.$router.push('/signup');
    }
  }
});
'filehash IRJv7C7c6A3Kmy09K8BJtnAvz6c=';

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    options: function options() {
      return this.$store.getters.stamenBaseOptions;
    }
  },
  methods: {
    basePicker: function basePicker(payload) {
      this.$store.dispatch('pickBase', payload);
      this.$router.push('/');
    }
  }
});
'filehash R+K7Hcf8L/+oPyAMg5AQzD2zyGQ=';

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: true
    };
  },

  computed: {
    setPixel: function setPixel() {
      return this.$store.getters.pixel;
    }
  },
  methods: {
    twoTone: function twoTone(payload) {
      this.$store.dispatch('twoTone', payload);
      this.$router.push('/');
    }
  }
});
'filehash nZwBmkbrzp89LMRcASD1izblkBs=';

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Control_FullScreen__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Control_FullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Control_FullScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__leaflet_providers__ = __webpack_require__(122);
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  updated: function updated() {
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';
    var tT0 = [this.$store.getters.fancyMinuteZero] + ' minutes';
    var tT1 = [this.$store.getters.fancyMinuteOne] + ' minutes';
    var tT2 = [this.$store.getters.fancyMinuteTwo] + ' minutes';
  },
  mounted: function mounted() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var lat = this.$store.getters.lat;
    var lng = this.$store.getters.lng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type[0];
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var inverse = this.$store.getters.inverse;
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';
    var tT0 = [this.$store.getters.fancyMinuteZero] + ' minutes';
    var tT1 = [this.$store.getters.fancyMinuteOne] + ' minutes';
    var tT2 = [this.$store.getters.fancyMinuteTwo] + ' minutes';
    L.mapbox.accessToken = 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A';
    var basemaps = r360.basemaps('N2T7JHHPOTJAWSFQ7YOMJYH');

    var map = L.mapbox.map('map').setView(latlng, zoom);
    var marker = L.circleMarker(latlng, {
      'draggable': false,
      radius: 1,
      title: name,
      riseOnHover: true
    });
    map.addLayer(marker);

    var defaultStyleLayer = L.mapbox.styleLayer('mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v').addTo(map);
    var baseLayers = {
      'Vector 1': defaultStyleLayer,
      'Vector 2': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k')

      /*
      var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>"
       // start leaflet providers
      var defaultLayer = L.tileLayer.provider('TownBoundaries').addTo(map)
      var baseLayers = {
        'OpenStreetMap Default': L.tileLayer.provider('OpenStreetMap.Mapnik'),
        'OpenStreetMap German Style': L.tileLayer.provider('OpenStreetMap.DE'),
        'OpenStreetMap Black and White': L.tileLayer.provider('OpenStreetMap.BlackAndWhite'),
        'OpenStreetMap H.O.T.': L.tileLayer.provider('OpenStreetMap.HOT'),
        'Red Pins': L.tileLayer.provider('RedPins'),
        'VT Town Boundaries': defaultLayer,
        'Town and Country': L.tileLayer.provider('TownAndCountry'),
        'Basic Mapbox': L.tileLayer.provider('BasicMapbox'),
        'Outdoors': L.tileLayer.provider('Outdoors'),
        'Satellite': L.tileLayer.provider('Satellite'),
        'Satellite Streets': L.tileLayer.provider('SatelliteStreets'),
        /*
        'Thunderforest OpenCycleMap': L.tileLayer.provider('Thunderforest.OpenCycleMap'),
        'Thunderforest Transport': L.tileLayer.provider('Thunderforest.Transport'),
        'Thunderforest Landscape': L.tileLayer.provider('Thunderforest.Landscape'),
        */
      /*
      'Hydda Full': L.tileLayer.provider('Hydda.Full'),
      'Stamen Toner': L.tileLayer.provider('Stamen.Toner'),
      'Stamen Terrain': L.tileLayer.provider('Stamen.Terrain'),
      'Stamen Watercolor': L.tileLayer.provider('Stamen.Watercolor'),
      'Esri WorldStreetMap': L.tileLayer.provider('Esri.WorldStreetMap'),
      'Esri DeLorme': L.tileLayer.provider('Esri.DeLorme'),
      'Esri WorldTopoMap': L.tileLayer.provider('Esri.WorldTopoMap'),
      'Esri WorldImagery': L.tileLayer.provider('Esri.WorldImagery'),
      'Esri WorldTerrain': L.tileLayer.provider('Esri.WorldTerrain'),
      'Esri WorldShadedRelief': L.tileLayer.provider('Esri.WorldShadedRelief'),
      'Esri WorldPhysical': L.tileLayer.provider('Esri.WorldPhysical'),
      'Esri OceanBasemap': L.tileLayer.provider('Esri.OceanBasemap'),
      'Esri NatGeoWorldMap': L.tileLayer.provider('Esri.NatGeoWorldMap'),
      'Esri WorldGrayCanvas': L.tileLayer.provider('Esri.WorldGrayCanvas')
      }
      var overlayLayers = {
      'OpenSeaMap': L.tileLayer.provider('OpenSeaMap'),
      'OpenWeatherMap Clouds': L.tileLayer.provider('OpenWeatherMap.Clouds'),
      'OpenWeatherMap CloudsClassic': L.tileLayer.provider('OpenWeatherMap.CloudsClassic'),
      'OpenWeatherMap Precipitation': L.tileLayer.provider('OpenWeatherMap.Precipitation'),
      'OpenWeatherMap PrecipitationClassic': L.tileLayer.provider('OpenWeatherMap.PrecipitationClassic'),
      'OpenWeatherMap Rain': L.tileLayer.provider('OpenWeatherMap.Rain'),
      'OpenWeatherMap RainClassic': L.tileLayer.provider('OpenWeatherMap.RainClassic'),
      'OpenWeatherMap Pressure': L.tileLayer.provider('OpenWeatherMap.Pressure'),
      'OpenWeatherMap PressureContour': L.tileLayer.provider('OpenWeatherMap.PressureContour'),
      'OpenWeatherMap Wind': L.tileLayer.provider('OpenWeatherMap.Wind'),
      'OpenWeatherMap Temperature': L.tileLayer.provider('OpenWeatherMap.Temperature'),
      'OpenWeatherMap Snow': L.tileLayer.provider('OpenWeatherMap.Snow')
      }
      // resize layers control to fit into view.
      function resizeLayerControl () {
      var layerControlHeight = document.body.clientHeight - (10 + 50)
      var layerControl = document.getElementsByClassName('leaflet-control-layers-expanded')[0]
      // layerControl.style.overflowY = 'auto'
      // layerControl.style.maxHeight = layerControlHeight + 'px'
      }
      map.on('resize', resizeLayerControl)
      resizeLayerControl()
      // end leaflet providers
      */
    };var opacity = 100;
    var polygonLayer = r360.leafletPolygonLayer({ inverse: inverse });
    map.addLayer(polygonLayer);

    var travelOptions = r360.travelOptions();
    travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH');
    travelOptions.setServiceUrl('https://service.route360.net/na_northeast/');
    travelOptions.addSource(marker);
    travelOptions.setTravelTimes(seconds);
    travelOptions.setTravelType(type);
    if (inverse === true) {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.setColors([{ 'time': seconds[0], 'opacity': opacity / 100 }, { 'time': seconds[1], 'opacity': opacity / 100 - 0.1 }, { 'time': seconds[2], 'opacity': opacity / 100 - 0.2 }]);
        polygonLayer.clearAndAddLayers(polygons, false);
      });
    } else {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.clearAndAddLayers(polygons, true);
      });
    }
    // L.control.layers(baseLayers, {collapsed: false}).addTo(map)

    // L.control.layers(baseLayers, basemaps, {collapsed: false}).addTo(map)
    // L.control.layers(basemaps).addTo(map)
    // L.control.scale().addTo(map)
    // L.control.zoom().addTo(map)
  },
  created: function created() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
  }
});
'filehash 7IrFnAcCoB/lB6AC8/jtLFlwwJM=';

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Control_FullScreen__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Control_FullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Control_FullScreen__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var lat = this.$store.getters.lat;
    var lng = this.$store.getters.lng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type[0];
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;

    var basemaps = r360.basemaps('N2T7JHHPOTJAWSFQ7YOMJYH');

    var map = L.map('map', {
      fullscreenControl: true,
      zoomControl: false,
      boxZoom: true
    }).setView(latlng, zoom);

    var marker = L.circleMarker(latlng, {
      'draggable': false,
      radius: 1,
      title: name,
      riseOnHover: true
    });
    map.addLayer(marker);

    var marker2 = L.circleMarker(latlng, {
      'draggable': false,
      radius: 5,
      title: name,
      riseOnHover: true
    });
    // map.addLayer(marker2)

    var marker3 = L.circleMarker(latlng, {
      'draggable': false,
      radius: 10,
      title: name,
      riseOnHover: true
    });
    map.addLayer(marker3);

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>";

    var polygonLayer = r360.leafletPolygonLayer();
    map.addLayer(polygonLayer);
    L.control.layers(basemaps).addTo(map);
    L.control.scale().addTo(map);
    L.control.zoom({
      // zoomDelta: 0.01
    }).addTo(map);

    var travelOptions = r360.travelOptions();
    travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH');
    travelOptions.setServiceUrl('https://service.route360.net/na_northeast/');
    travelOptions.addSource(marker);
    travelOptions.setTravelTimes(seconds);
    travelOptions.setTravelType(type);
    r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
      polygonLayer.setStrokeWidth(pixel);
      polygonLayer.clearAndAddLayers(polygons, true);
    });
  },
  created: function created() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
  }
});
'filehash ZzpWT7u+dXQtnpjSN5sWD0XexCk=';

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stamen__ = __webpack_require__(336);

//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
  updated: function updated() {
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';
  },
  mounted: function mounted() {
    var _L$circleMarker;

    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var lat = this.$store.getters.lat;
    var lng = this.$store.getters.lng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var inverse = this.$store.getters.inverse;
    var sTbM = this.$store.getters.baseOption;
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';

    var layer = new L.StamenTileLayer(sTbM);
    var map = L.map('map', {
      zoomControl: false,
      boxZoom: true
    }).setView(latlng, zoom);
    map.addLayer(layer);

    var marker = L.circleMarker(latlng, (_L$circleMarker = {
      'draggable': false,
      radius: 8
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$circleMarker, 'draggable', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$circleMarker, 'title', name), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$circleMarker, 'riseOnHover', true), _L$circleMarker));
    // map.addLayer(marker)

    var place1 = L.divIcon({
      url: '../../../static/img/ic_gps_fixed_black_24dp_2x',
      // className: 'place-div-icon',
      'draggable': true,
      iconSize: [10, 10],
      iconAnchor: [0, 0],
      popupAnchor: [0, 0]
    });
    var markerP1 = L.marker(latlng, {
      icon: place1
    });
    map.addLayer(markerP1);
    // var marker = L.marker((latlon), { draggable: true }).addTo(map)

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>";

    // end leaflet providers
    // L.control.locate().addTo(map);
    // L.control.zoom({ position: 'bottomleft' }).addTo(map)

    var opacity = 80;
    var polygonLayer = r360.leafletPolygonLayer({ inverse: true }).addTo(map);

    var getPolygons = function getPolygons() {
      polygonLayer.setColors([{ 'time': seconds[0], 'opacity': opacity / 100 }, { 'time': seconds[1], 'opacity': opacity / 100 - 0.1 }, { 'time': seconds[2], 'opacity': opacity / 100 - 0.2 }]);
      var travelOptions = r360.travelOptions();
      travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH');
      travelOptions.setServiceUrl('https://service.route360.net/na_northeast/');
      travelOptions.addSource(marker);
      travelOptions.setTravelTimes(seconds);
      travelOptions.setTravelType(type);
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.clearAndAddLayers(polygons, true);
      });
    };
    if (inverse === true) {
      getPolygons();
      marker.on('dragend', getPolygons());
    } else {
      var polygonLayer = r360.leafletPolygonLayer({ inverse: inverse });
      map.addLayer(polygonLayer);
      var travelOptions = r360.travelOptions();
      travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH');
      travelOptions.setServiceUrl('https://service.route360.net/na_northeast/');
      travelOptions.addSource(marker);
      travelOptions.setTravelTimes(seconds);
      travelOptions.setTravelType(type);
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.clearAndAddLayers(polygons, true);
      });
    }
    L.control.scale().addTo(map);
  },
  created: function created() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var sTbM = this.$store.getters.baseOption;
  }
});
'filehash wxgGIoZXdITdkTbMJ2qPPNLKKv4=';

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Control_FullScreen__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Control_FullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Control_FullScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__leaflet_providers__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locate_control__ = __webpack_require__(205);

//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  updated: function updated() {
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';
  },
  mounted: function mounted() {
    var _L$map;

    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var lat = this.$store.getters.lat;
    var lng = this.$store.getters.lng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var inverse = this.$store.getters.inverse;
    var sTbM = this.$store.getters.baseOption;
    var tN1 = '<div id="bigFont">' + [this.$store.getters.schoolName] + '</div>';

    var basemaps = r360.basemaps('N2T7JHHPOTJAWSFQ7YOMJYH');

    // var map = L.mapbox.map('map').setView(latlng, zoom)
    var map = L.map('map', (_L$map = {
      // fullscreenControl: true,
      zoomControl: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$map, 'zoomControl', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_L$map, 'boxZoom', true), _L$map)).setView(latlng, zoom);

    /*
    var marker = L.circleMarker(latlng, {
      'draggable': false,
      radius: 8,
      draggable: true,
      title: name,
      riseOnHover: true
    })
    map.addLayer(marker)
     var place1 = L.divIcon({
      html: tN1,
      className: 'place-div-icon',
      'draggable': true,
      iconSize: [300, 40],
      iconAnchor: [380, 270],
      popupAnchor: [0, 0]
    })
    var markerP1 = L.marker(latlng, {
      icon: place1
    })
    // map.addLayer(markerP1)
    */
    var myIcon = L.icon({
      iconUrl: '../../../static/img/ic_place_black_24dp_1x.png',
      iconSize: [0, 0],
      iconAnchor: [0, 0],
      popupAnchor: [0, 0],
      shadowUrl: '../../../static/img/marker-shadow.png',
      shadowSize: [0, 0],
      shadowAnchor: [22, 94]
    });
    var marker = L.marker(latlng, {
      icon: myIcon,
      draggable: true
    });
    map.addLayer(marker);

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>";
    L.mapbox.accessToken = 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A';

    // start leaflet providers
    var defaultLayer = L.mapbox.styleLayer('mapbox://styles/altophoto/cjamqc49sdvba2rl8fvle4rrk').addTo(map);
    var baseLayers = {
      // Techno
      'VT Winter Dev': defaultLayer,
      'VT Winter Gothic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjain2glsa1fo2roavo9wowrw'),
      'VT Techno Gothic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjaif6yjx8x2k2rkaayihh77s'),
      'Okemo': L.mapbox.styleLayer('mapbox://styles/altophoto/cjahchwrq8tdr2rpem2iwerrb'),
      'Decimal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'),
      'Terminal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'),
      // Vermont
      'VT Town Boundaries': L.mapbox.styleLayer('mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'),
      'Red Pins': L.mapbox.styleLayer('mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'),
      // Open Street Map
      'OpenStreetMap Default': L.tileLayer.provider('OpenStreetMap.Mapnik'),
      'OpenStreetMap German Style': L.tileLayer.provider('OpenStreetMap.DE'),
      'OpenStreetMap Black and White': L.tileLayer.provider('OpenStreetMap.BlackAndWhite'),
      'OpenStreetMap H.O.T.': L.tileLayer.provider('OpenStreetMap.HOT'),
      // Raster
      'Red Pins-Raster': L.tileLayer.provider('RedPins'),
      'VT Town Boundaries-Raster': L.tileLayer.provider('TownBoundaries'),
      'Town and Country-Raster': L.tileLayer.provider('TownAndCountry'),
      'Outdoors-Raster': L.tileLayer.provider('Outdoors'),
      'Raster Satellite': L.tileLayer.provider('Satellite'),
      'Satellite Streets': L.tileLayer.provider('SatelliteStreets'),
      // Slick
      'Hydda': L.tileLayer.provider('Hydda.Full'),
      'Basic Mapbox': L.tileLayer.provider('BasicMapbox'),
      'Basic Vector': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'),
      'Scenic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'),
      'Town and Country': L.mapbox.styleLayer('mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'),
      'Standard': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw705a3qzw2rpjx6t079ds'),
      'North Star': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'),
      // Funky
      'Toner': L.tileLayer.provider('Stamen.Toner'),
      'Watercolor': L.tileLayer.provider('Stamen.Watercolor'),
      'Vintage': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6nax3sgf2sntkany1okv'),
      'Ice Cream': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'),
      'Desert planet': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'),
      'whaam!': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'),
      // Outdoors
      'Terrain': L.tileLayer.provider('Stamen.Terrain'),
      '(vector) Satellite': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'),
      '(vector) Satellite Streets': L.mapbox.styleLayer('mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'),
      'Outdoors': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'),
      // Esri
      'Esri WorldStreetMap': L.tileLayer.provider('Esri.WorldStreetMap'),
      'Esri DeLorme': L.tileLayer.provider('Esri.DeLorme'),
      'Esri WorldTopoMap': L.tileLayer.provider('Esri.WorldTopoMap'),
      'Esri WorldImagery': L.tileLayer.provider('Esri.WorldImagery'),
      'Esri WorldTerrain': L.tileLayer.provider('Esri.WorldTerrain'),
      'Esri WorldShadedRelief': L.tileLayer.provider('Esri.WorldShadedRelief'),
      'Esri WorldPhysical': L.tileLayer.provider('Esri.WorldPhysical'),
      'Esri OceanBasemap': L.tileLayer.provider('Esri.OceanBasemap'),
      'Esri NatGeoWorldMap': L.tileLayer.provider('Esri.NatGeoWorldMap'),
      'Esri WorldGrayCanvas': L.tileLayer.provider('Esri.WorldGrayCanvas')
    };
    var overlayLayers = {
      'OpenSeaMap': L.tileLayer.provider('OpenSeaMap'),
      'OpenWeatherMap Clouds': L.tileLayer.provider('OpenWeatherMap.Clouds'),
      'OpenWeatherMap CloudsClassic': L.tileLayer.provider('OpenWeatherMap.CloudsClassic'),
      'OpenWeatherMap Precipitation': L.tileLayer.provider('OpenWeatherMap.Precipitation'),
      'OpenWeatherMap PrecipitationClassic': L.tileLayer.provider('OpenWeatherMap.PrecipitationClassic'),
      'OpenWeatherMap Rain': L.tileLayer.provider('OpenWeatherMap.Rain'),
      'OpenWeatherMap RainClassic': L.tileLayer.provider('OpenWeatherMap.RainClassic'),
      'OpenWeatherMap Pressure': L.tileLayer.provider('OpenWeatherMap.Pressure'),
      'OpenWeatherMap PressureContour': L.tileLayer.provider('OpenWeatherMap.PressureContour'),
      'OpenWeatherMap Wind': L.tileLayer.provider('OpenWeatherMap.Wind'),
      'OpenWeatherMap Temperature': L.tileLayer.provider('OpenWeatherMap.Temperature'),
      'OpenWeatherMap Snow': L.tileLayer.provider('OpenWeatherMap.Snow')
      // resize layers control to fit into view.
    };function resizeLayerControl() {
      var layerControlHeight = document.body.clientHeight - (10 + 50);
      var layerControl = document.getElementsByClassName('leaflet-control-layers-expanded')[0];
      // layerControl.style.overflowY = 'auto'
      // layerControl.style.maxHeight = layerControlHeight + 'px'
    }
    map.on('resize', resizeLayerControl);
    resizeLayerControl();
    // end leaflet providers
    // L.control.locate().addTo(map);
    L.control.zoom({ position: 'bottomright' }).addTo(map);

    var opacity = 100;
    var polygonLayer = r360.leafletPolygonLayer({ inverse: inverse });
    map.addLayer(polygonLayer);

    var travelOptions = r360.travelOptions();
    travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH');
    travelOptions.setServiceUrl('https://service.route360.net/na_northeast/');
    travelOptions.addSource(marker);
    travelOptions.setTravelTimes(seconds);
    travelOptions.setTravelType(type);
    if (inverse === true) {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.setColors([{ 'time': seconds[0], 'opacity': opacity / 100 }, { 'time': seconds[1], 'opacity': opacity / 100 - 0.1 }, { 'time': seconds[2], 'opacity': opacity / 100 - 0.2 }]);
        polygonLayer.clearAndAddLayers(polygons, true);
      });
    } else {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel);
        polygonLayer.clearAndAddLayers(polygons, true);
      });
    }

    L.control.layers(baseLayers, basemaps, { collapsed: true }).addTo(map);
    // L.control.layers(basemaps).addTo(map)
    // L.control.layers(baseLayers, {collapsed: false}).addTo(map)
    L.control.scale().addTo(map);
    // L.control.zoom().addTo(map)
  },
  created: function created() {
    var pixel = this.$store.getters.pixel;
    var latlng = this.$store.getters.latlng;
    var zoom = this.$store.getters.zoom;
    var type = this.$store.getters.type;
    var seconds = this.$store.getters.seconds;
    var name = this.$store.getters.schoolName;
    var sTbM = this.$store.getters.baseOption;
  }
});
'filehash TBG7BvqEAwKgjCJjzlOkdWohkPs=';

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: true
    };
  },

  computed: {
    setPixel: function setPixel() {
      return this.$store.getters.pixel;
    }
  },
  methods: {
    onPixel: function onPixel(n) {
      this.$store.dispatch('pickPixels', n);
      this.$router.push('/');
    }
  }
});
'filehash TGO/0FCxo165C5EbCVjW6dB0BdU=';

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      tmp: '',
      search: '',
      pagination: {
        sortBy: 'town'
      },
      selected: [],
      headers: [{
        text: 'Points of Interest',
        align: 'left',
        value: 'name'
      }, { text: 'Town', value: 'town' }]
    };
  },
  /*
  firebase: {
    items = vtSchoolsRef
  },
  */
  computed: {
    items: function items() {
      return this.$store.getters.verPois;
    }
  },
  methods: {
    openDetails: function openDetails(item) {
      var details = this.items.find(function (i) {
        return i === item;
      });
      if (!details) return console.log('Not found');
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(details));
      this.$store.dispatch('pickPoi', details);
      this.zoom = 11;
      this.$router.push('/');
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  }
});
'filehash 9Pr0j25JKoP0OPGSTSajqo3Zsz8=';

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      tmp: '',
      search: '',
      pagination: {
        sortBy: 'name'
      },
      selected: [],
      headers: [{
        text: 'Schools',
        align: 'left',
        value: 'name'
      }, { text: 'Town', value: 'townam' }, { text: 'District', value: 'schdis' }, { text: 'Type', value: 'schcat' }, { text: 'Grades', value: 'grades' }, { text: 'Size (est.)', value: 'estsiz' }]
    };
  },
  /*
  firebase: {
    items = vtSchoolsRef
  },
  */
  computed: {
    items: function items() {
      return this.$store.getters.verSch;
    }
  },
  methods: {
    openDetails: function openDetails(item) {
      var details = this.items.find(function (i) {
        return i === item;
      });
      if (!details) return console.log('Not found');
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(details));
      this.$store.dispatch('pickSchool', details);
      this.zoom = 11;
      this.$router.push('/');
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    editRow: function editRow(rowData) {
      var rar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(rowData);
      // alert('You clicked edit on' + JSON.stringify(rowData))
      this.$store.dispatch('pickSchool'(rar));
      // this.zoom = 11
      this.$router.push('/');
    }
  }
});
'filehash j8xhUkDajswoa+x4XpTrwIEe84c=';

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: true
    };
  },

  computed: {
    setPixel: function setPixel() {
      return this.$store.getters.pixel;
    }
  },
  methods: {
    twoTone: function twoTone(payload) {
      this.$store.dispatch('twoTone', payload);
      this.$router.push('/');
    }
  }
});
'filehash HvrXOQVQKOgu3TV3CJrBfevYh1E=';

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      dialog2: false,
      dialog3: false
    };
  },

  computed: {
    minute1: function minute1() {
      return this.$store.getters.minutes[0];
    },
    minute2: function minute2() {
      return this.$store.getters.minutes[1];
    },
    minute3: function minute3() {
      return this.$store.getters.minutes[2];
    },
    travelClocks: function travelClocks() {
      return this.$store.getters.travelTimes;
    },
    singleClocks: function singleClocks() {
      return this.$store.getters.singleTimes;
    }
  },
  methods: {
    microMinute: function microMinute(payload) {
      var nock = payload * 60;
      var sock = [nock, 0, 0];
      var mock = [payload, '', '', '', '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10: function onClock5D10() {
      var sock = [300, 600];
      var mock = [5, 10, '', '', '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 10, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D15: function onClock5D15() {
      var sock = [300, 900];
      var mock = [5, '', 15, '', '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 15, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D20: function onClock5D20() {
      var sock = [300, 1200];
      var mock = [5, '', '', 20, '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 20, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D25: function onClock5D25() {
      var sock = [300, 1500];
      var mock = [5, '', '', '', 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 25, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D30: function onClock5D30() {
      var sock = [300, 1800];
      var mock = [5, '', '', '', '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 30, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D35: function onClock5D35() {
      var sock = [300, 2100];
      var mock = [5, '', '', '', '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 35, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D40: function onClock5D40() {
      var sock = [300, 2400];
      var mock = [5, '', '', '', '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 40, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D45: function onClock5D45() {
      var sock = [300, 2700];
      var mock = [5, '', '', '', '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 45, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D50: function onClock5D50() {
      var sock = [300, 3000];
      var mock = [5, '', '', '', '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 50, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D55: function onClock5D55() {
      var sock = [300, 3300];
      var mock = [5, '', '', '', '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 55, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock5D60: function onClock5D60() {
      var sock = [300, 3600];
      var mock = [5, '', '', '', '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 60, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D15: function onClock10D15() {
      var sock = [600, 900];
      var mock = ['', 10, 15, '', '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 15, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D20: function onClock10D20() {
      var sock = [600, 1200];
      var mock = ['', 10, '', 20, '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 20, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D25: function onClock10D25() {
      var sock = [600, 1500];
      var mock = ['', 10, '', '', 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 25, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D30: function onClock10D30() {
      var sock = [600, 1800];
      var mock = ['', 10, '', '', '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 30, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D35: function onClock10D35() {
      var sock = [600, 2100];
      var mock = ['', 10, '', '', '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 35, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D40: function onClock10D40() {
      var sock = [600, 2400];
      var mock = ['', 10, '', '', '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 40, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D45: function onClock10D45() {
      var sock = [600, 2700];
      var mock = ['', 10, '', '', '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 45, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D50: function onClock10D50() {
      var sock = [600, 3000];
      var mock = ['', 10, '', '', '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 50, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D55: function onClock10D55() {
      var sock = [600, 3300];
      var mock = ['', 10, '', '', '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 55, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock10D60: function onClock10D60() {
      var sock = [600, 3600];
      var mock = ['', 10, '', '', '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 60, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock15D20: function onClock15D20() {
      var sock = [900, 1200];
      var mock = ['', '', 15, 20, '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D25: function onClock15D25() {
      var sock = [900, 1500];
      var mock = ['', '', 15, '', 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D30: function onClock15D30() {
      var sock = [900, 1800];
      var mock = ['', '', 15, '', '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D35: function onClock15D35() {
      var sock = [900, 2100];
      var mock = ['', '', 15, '', '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D40: function onClock15D40() {
      var sock = [900, 2400];
      var mock = ['', '', 15, '', '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D45: function onClock15D45() {
      var sock = [900, 2700];
      var mock = ['', '', 15, '', '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D50: function onClock15D50() {
      var sock = [900, 3000];
      var mock = ['', '', 15, '', '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D55: function onClock15D55() {
      var sock = [900, 3300];
      var mock = ['', '', 15, '', '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D60: function onClock15D60() {
      var sock = [900, 3600];
      var mock = ['', '', 15, '', '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D25: function onClock20D25() {
      var sock = [1200, 1500];
      var mock = ['', '', '', 20, 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30: function onClock20D30() {
      var sock = [1200, 1800];
      var mock = ['', '', '', 20, '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D35: function onClock20D35() {
      var sock = [1200, 2100];
      var mock = ['', '', '', 20, '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D40: function onClock20D40() {
      var sock = [1200, 2400];
      var mock = ['', '', '', 20, '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D45: function onClock20D45() {
      var sock = [1200, 2700];
      var mock = ['', '', '', 20, '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D50: function onClock20D50() {
      var sock = [1200, 3000];
      var mock = ['', '', '', 20, '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D55: function onClock20D55() {
      var sock = [1200, 3300];
      var mock = ['', '', '', 20, '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D60: function onClock20D60() {
      var sock = [1200, 3600];
      var mock = ['', '', '', 20, '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30: function onClock25D30() {
      var sock = [1500, 1800];
      var mock = ['', '', '', '', 25, 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D35: function onClock25D35() {
      var sock = [1500, 2100];
      var mock = ['', '', '', '', 25, '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D40: function onClock25D40() {
      var sock = [1500, 2400];
      var mock = ['', '', '', '', 25, '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D45: function onClock25D45() {
      var sock = [1500, 2700];
      var mock = ['', '', '', '', 25, '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D50: function onClock25D50() {
      var sock = [1500, 3000];
      var mock = ['', '', '', '', 25, '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D55: function onClock25D55() {
      var sock = [1500, 3300];
      var mock = ['', '', '', '', 25, '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D60: function onClock25D60() {
      var sock = [1500, 3600];
      var mock = ['', '', '', '', 25, '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock30D35: function onClock30D35() {
      var sock = [1800, 2100];
      var mock = ['', '', '', '', '', 30, 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock30D40: function onClock30D40() {
      var sock = [1800, 2400];
      var mock = ['', '', '', '', '', 30, 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock30D45: function onClock30D45() {
      var sock = [1800, 2700];
      var mock = ['', '', '', '', '', 30, 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock30D50: function onClock30D50() {
      var sock = [1800, 3000];
      var mock = ['', '', '', '', '', 30, 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock30D55: function onClock30D55() {
      var sock = [1800, 3300];
      var mock = ['', '', '', '', '', 30, 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock30D60: function onClock30D60() {
      var sock = [1800, 3600];
      var mock = ['', '', '', '', '', 30, 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D15: function onClock5D10D15() {
      var sock = [300, 600, 900];
      var mock = [5, 10, 15, '', '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D20: function onClock5D10D20() {
      var sock = [300, 600, 1200];
      var mock = [5, 10, '', 20, '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D25: function onClock5D10D25() {
      var sock = [300, 600, 1500];
      var mock = [5, 10, '', '', 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D30: function onClock5D10D30() {
      var sock = [300, 600, 1800];
      var mock = [5, 10, '', '', '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D35: function onClock5D10D35() {
      var sock = [300, 600, 2100];
      var mock = [5, 10, '', '', '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D40: function onClock5D10D40() {
      var sock = [300, 600, 2400];
      var mock = [5, 10, '', '', '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D45: function onClock5D10D45() {
      var sock = [300, 600, 2700];
      var mock = [5, 10, '', '', '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D50: function onClock5D10D50() {
      var sock = [300, 600, 3000];
      var mock = [5, 10, '', '', '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D55: function onClock5D10D55() {
      var sock = [300, 600, 3300];
      var mock = [5, 10, '', '', '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D10D60: function onClock5D10D60() {
      var sock = [300, 600, 3600];
      var mock = [5, 10, '', '', '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D20: function onClock5D15D20() {
      var sock = [300, 900, 1200];
      var mock = [5, '', 15, 20, '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D25: function onClock5D15D25() {
      var sock = [300, 900, 1500];
      var mock = [5, '', 15, '', 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D30: function onClock5D15D30() {
      var sock = [300, 900, 1800];
      var mock = [5, '', 15, '', '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D35: function onClock5D15D35() {
      var sock = [300, 900, 2100];
      var mock = [5, '', 15, '', '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D40: function onClock5D15D40() {
      var sock = [300, 900, 2400];
      var mock = [5, '', 15, '', '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D45: function onClock5D15D45() {
      var sock = [300, 900, 2700];
      var mock = [5, '', 15, '', '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D50: function onClock5D15D50() {
      var sock = [300, 900, 3000];
      var mock = [5, '', 15, '', '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D55: function onClock5D15D55() {
      var sock = [300, 900, 3300];
      var mock = [5, '', 15, '', '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D15D60: function onClock5D15D60() {
      var sock = [300, 900, 3600];
      var mock = [5, '', 15, '', '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D25: function onClock5D20D25() {
      var sock = [300, 1200, 1500];
      var mock = [5, '', '', 20, 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D30: function onClock5D20D30() {
      var sock = [300, 1200, 1800];
      var mock = [5, '', '', 20, '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D35: function onClock5D20D35() {
      var sock = [300, 1200, 2100];
      var mock = [5, '', '', 20, '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D40: function onClock5D20D40() {
      var sock = [300, 1200, 2400];
      var mock = [5, '', '', 20, '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D45: function onClock5D20D45() {
      var sock = [300, 1200, 2700];
      var mock = [5, '', '', 20, '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D50: function onClock5D20D50() {
      var sock = [300, 1200, 3000];
      var mock = [5, '', '', 20, '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D55: function onClock5D20D55() {
      var sock = [300, 1200, 3300];
      var mock = [5, '', '', 20, '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D20D60: function onClock5D20D60() {
      var sock = [300, 1200, 3600];
      var mock = [5, '', '', 20, '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D30: function onClock5D25D30() {
      var sock = [300, 1500, 1800];
      var mock = [5, '', '', '', 25, 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D35: function onClock5D25D35() {
      var sock = [300, 1500, 2100];
      var mock = [5, '', '', '', 25, '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D40: function onClock5D25D40() {
      var sock = [300, 1500, 2400];
      var mock = [5, '', '', '', 25, '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D45: function onClock5D25D45() {
      var sock = [300, 1500, 2700];
      var mock = [5, '', '', '', 25, '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D50: function onClock5D25D50() {
      var sock = [300, 1500, 3000];
      var mock = [5, '', '', '', 25, '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D55: function onClock5D25D55() {
      var sock = [300, 1500, 3300];
      var mock = [5, '', '', '', 25, '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D25D60: function onClock5D25D60() {
      var sock = [300, 1500, 3600];
      var mock = [5, '', '', '', 25, '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D30D35: function onClock5D30D35() {
      var sock = [300, 1800, 2100];
      var mock = [5, '', '', '', '', 30, 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D30D40: function onClock5D30D40() {
      var sock = [300, 1800, 2400];
      var mock = [5, '', '', '', '', 30, 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D30D45: function onClock5D30D45() {
      var sock = [300, 1800, 2700];
      var mock = [5, '', '', '', '', 30, 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D30D50: function onClock5D30D50() {
      var sock = [300, 1800, 3000];
      var mock = [5, '', '', '', '', 30, 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D30D55: function onClock5D30D55() {
      var sock = [300, 1800, 3300];
      var mock = [5, '', '', '', '', 30, 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock5D30D60: function onClock5D30D60() {
      var sock = [300, 1800, 3600];
      var mock = [5, '', '', '', '', 30, 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D25D30: function onClock20D25D30() {
      var sock = [1200, 1500, 1800];
      var mock = ['', '', '', 20, 25, 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D25D30: function onClock15D25D30() {
      var sock = [900, 1500, 1800];
      var mock = ['', '', 15, '', 25, 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D30D35: function onClock15D30D35() {
      var sock = [900, 1800, 2100];
      var mock = ['', '', 15, '', '', 30, 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock15D20D25: function onClock15D20D25() {
      var sock = [900, 1200, 1500];
      var mock = ['', '', 15, 20, 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30D35: function onClock20D30D35() {
      var sock = [1200, 1800, 2100];
      var mock = ['', '', '', 20, '', 30, 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30D40: function onClock20D30D40() {
      var sock = [1200, 1800, 2400];
      var mock = ['', '', '', 20, '', 30, 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30D45: function onClock20D30D45() {
      var sock = [1200, 1800, 2700];
      var mock = ['', '', '', 20, '', 30, 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30D50: function onClock20D30D50() {
      var sock = [1200, 1800, 3000];
      var mock = ['', '', '', 20, '', 30, 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30D55: function onClock20D30D55() {
      var sock = [1200, 1800, 3300];
      var mock = ['', '', '', 20, '', 30, 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock20D30D60: function onClock20D30D60() {
      var sock = [1200, 1800, 3600];
      var mock = ['', '', '', 20, '', 30, 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30D35: function onClock25D30D35() {
      var sock = [1500, 1800, 2100];
      var mock = ['', '', '', '', 25, 30, 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30D40: function onClock25D30D40() {
      var sock = [1500, 1800, 2400];
      var mock = ['', '', '', '', 25, 30, 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30D45: function onClock25D30D45() {
      var sock = [1500, 1800, 2700];
      var mock = ['', '', '', '', 25, 30, 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30D50: function onClock25D30D50() {
      var sock = [1500, 1800, 3000];
      var mock = ['', '', '', '', 25, 30, 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30D55: function onClock25D30D55() {
      var sock = [1500, 1800, 3300];
      var mock = ['', '', '', '', 25, 30, 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock25D30D60: function onClock25D30D60() {
      var sock = [1500, 1800, 3600];
      var mock = ['', '', '', '', 25, 30, 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D30D35: function onClock10D30D35() {
      var sock = [600, 1800, 2100];
      var mock = ['', 10, '', '', '', 30, 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D30D40: function onClock10D30D40() {
      var sock = [600, 1800, 2400];
      var mock = ['', 10, '', '', '', 30, 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D30D45: function onClock10D30D45() {
      var sock = [600, 1800, 2700];
      var mock = ['', 10, '', '', '', 30, 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D30D50: function onClock10D30D50() {
      var sock = [600, 1800, 3000];
      var mock = ['', 10, '', '', '', 30, 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D30D55: function onClock10D30D55() {
      var sock = [600, 1800, 3300];
      var mock = ['', 10, '', '', '', 30, 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D30D60: function onClock10D30D60() {
      var sock = [600, 1800, 3600];
      var mock = ['', 10, '', '', '', 30, 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D15D20: function onClock10D15D20() {
      var sock = [600, 900, 1200];
      var mock = ['', 10, 15, 20, '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D20D25: function onClock10D20D25() {
      var sock = [600, 1200, 1500];
      var mock = ['', 10, '', 20, 25, '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D20D30: function onClock10D20D30() {
      var sock = [600, 1200, 1800];
      var mock = ['', 10, '', 20, '', 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    onClock10D25D30: function onClock10D25D30() {
      var sock = [600, 1500, 1800];
      var mock = ['', 10, '', '', 25, 30, ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    },
    soloClock5: function soloClock5() {
      var sock = [300];
      var mock = [5];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [5, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock10: function soloClock10() {
      var sock = [600];
      var mock = ['', 10];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [10, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock15: function soloClock15() {
      var sock = [900];
      var mock = ['', '', 15];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [15, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock20: function soloClock20() {
      var sock = [1200];
      var mock = ['', '', '', 20];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [20, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock25: function soloClock25() {
      var sock = [1500];
      var mock = ['', '', '', '', 25];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [25, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock30: function soloClock30() {
      var sock = [1800];
      var mock = ['', '', '', '', '', 30];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [30, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock35: function soloClock35() {
      var sock = [2100];
      var mock = ['', '', '', '', '', '', 35];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [35, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock40: function soloClock40() {
      var sock = [2400];
      var mock = ['', '', '', '', '', '', 40];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [40, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock45: function soloClock45() {
      var sock = [2700];
      var mock = ['', '', '', '', '', '', 45];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [45, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock50: function soloClock50() {
      var sock = [3000];
      var mock = ['', '', '', '', '', '', 50];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [50, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock55: function soloClock55() {
      var sock = [3300];
      var mock = ['', '', '', '', '', '', 55];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [55, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    soloClock60: function soloClock60() {
      var sock = [3600];
      var mock = ['', '', '', '', '', '', 60];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      var dock = [60, 0, 0];
      this.$store.dispatch('colorFancyMins', dock);
      this.$router.push('/');
    },
    onClock51015: function onClock51015() {
      var sock = [300, 600, 900];
      var mock = [5, 10, 15, '', '', '', '', '', '', '', '', ''];
      this.$store.dispatch('pickSecs', sock);
      this.$store.dispatch('pickMins', mock);
      this.$router.push('/');
    }
  }
});
'filehash oQ3Cgcm9jX3p3mQO2Nhfx5Vvmms=';

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    travelTypePickerWalk: function travelTypePickerWalk() {
      this.$store.dispatch('pickType', 'walk');
      this.$router.push('/');
    },
    travelTypePickerBike: function travelTypePickerBike() {
      this.$store.dispatch('pickType', 'bike');
      this.$router.push('/');
    },
    travelTypePickerCar: function travelTypePickerCar() {
      this.$store.dispatch('pickType', 'car');
      this.$router.push('/');
    }
  }
});
'filehash D4b7c8/p68eYnxQQhdH0/hPyee4=';

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71209d22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71209d22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cutout_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fcbede4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cutout_vue__ = __webpack_require__(654);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cutout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fcbede4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cutout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b2b70b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(646);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b2b70b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117163ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(643);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117163ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Introduction_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_700107a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Introduction_vue__ = __webpack_require__(656);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Introduction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_700107a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Introduction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117163ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(644);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117163ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a79344c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(647);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a79344c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41160df1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(650);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41160df1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notSignedIn_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470d4343_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notSignedIn_vue__ = __webpack_require__(652);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notSignedIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470d4343_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notSignedIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basepicker_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b62bcc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basepicker_vue__ = __webpack_require__(660);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b62bcc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inverter_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df85251_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inverter_vue__ = __webpack_require__(653);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inverter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df85251_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inverter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mB1_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1047a57a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mB1_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mB1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1047a57a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mB1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mB2_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6358ba6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mB2_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6358ba6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mB2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6358ba6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mB2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poiIndex_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_747374dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poiIndex_vue__ = __webpack_require__(658);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poiIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_747374dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poiIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectorIndex_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d4b971_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectorIndex_vue__ = __webpack_require__(645);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectorIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d4b971_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectorIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typePicker_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d17dd062_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typePicker_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d17dd062_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-space-between":"","text-xs-center":""}},[_c('v-card',{attrs:{"dark":"","height":"300px","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Nothing to see here yet.\n                ")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-space-between":"","text-xs-center":""}},[_c('v-card',{attrs:{"dark":"","height":"300px","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Nothing to see here yet.\n                ")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Select Index")]),_vm._v(" "),_c('div',[_vm._v("currently available: schools, points of interest")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-list',[_c('v-btn',{attrs:{"large":"","dark":"","color":"indigo","to":'/poiindex'}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mood")]),_vm._v("Points of Interest\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"large":"","color":"red","to":'/schoolIndex'}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("school")]),_vm._v("Schools\n          ")],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignin($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("\n                    Sign in\n                     "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignup($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","rules":[_vm.comparePasswords]},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("\n                    Sign up\n                     "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"dark":"","height":"300px","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Select the Pixel Grain")]),_vm._v(" "),_c('div',[_vm._v("One is ultra-sharp; Thirty is blob-like")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-list',_vm._l((30),function(n){return _c('v-btn',{key:n,attrs:{"dark":"","fab":"","color":"deco"},on:{"click":function($event){_vm.onPixel(n)}}},[_vm._v("\n            "+_vm._s(n)+"\n          ")])}))],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"790"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("To use microDecaPodVT you must Sign In")]),_vm._v(" "),_c('v-card-text',[_vm._v("Signing up transfers no rights or responsibilities: signing-up/in incurs no contract, commitment, tracking, advertising, spyware, adware, gelocation data scraping or other internet bummers.\n          ")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        This app is \"beta\" and will become a subscription service, a pay-to-use application, or leased software. At present, however, general feedback and criticism is the order of the day.\n        ")]),_vm._v(" "),_c('v-card-text',[_vm._v("Thank you, Sebastian Noah Frank, 2017")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":""},nativeOn:{"click":function($event){_vm.Dsignin($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock_open")]),_vm._v("\n              Sign-in with e-mail\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":""},nativeOn:{"click":function($event){_vm.Dsignup($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("face")]),_vm._v("\n              Sign-up\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialog = !_vm.dialog}}},[_vm._v("Close")])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"info","dense":"","app":"","height":"40","elevation-1":""}},[_c('v-btn',{attrs:{"flat":"","to":'/schoolindex'}},[_vm._v(_vm._s(_vm.schTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"flat":"","outline":"","to":'/signin'}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock_open")]),_vm._v("\n        Sign-in with e-mail\n      ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":"","to":'/signup'}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("face")]),_vm._v("\n        Sign-up\n      ")],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-toolbar-title',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v("microDecaPodVT")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-navigation-drawer',{staticClass:"info",attrs:{"clipped":"","permanent":"","app":"","width":"60"}},[_c('v-btn',{attrs:{"small":"","fab":"","color":"deco","disabled":"","to":'/pixelpicker'}},[_vm._v("\n            "+_vm._s(_vm.setPixel)+"\n          ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"five"}},[_vm._v("\n            "+_vm._s(_vm.minute5to60[0])+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"ten"}},[_vm._v("\n            "+_vm._s(_vm.minute5to60[1])+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"fifteen"}},[_vm._v("\n            "+_vm._s(_vm.minute5to60[2])+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"twenty"}},[_vm._v("\n          "+_vm._s(_vm.minute5to60[3])+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"twentyfive"}},[_vm._v("\n            "+_vm._s(_vm.minute5to60[4])+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"thirty"}},[_vm._v("\n            "+_vm._s(_vm.minute5to60[5])+"\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":'/timepicker',"disabled":"","small":"","fab":"","color":"thirtyfive"}},[_vm._v("\n            "+_vm._s(_vm.minute5to60[6])+"\n          ")]),_vm._v(" "),_c('v-divider'),_vm._v("\n            © SNF\n            "+_vm._s(new Date().getFullYear())+"\n        ")],1)],1),_vm._v(" "),(!_vm.dialog)?_c('v-flex',{attrs:{"xs10":""}},[_c('router-view')],1):_vm._e()],1),_vm._v(" "),_c('v-footer',{staticClass:"hidden-md-and-down",attrs:{"dense":"","color":"info"}},[_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("© Sebastian Noah Frank "+_vm._s(new Date().getFullYear()))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("add/remove color")]),_vm._v(" "),_c('div',[_vm._v("Click to toggle between colorized isochronic maps or greyscale-inverted isochronic maps. The inverted-greyscale maps better highlight areas reachable in a given amount of time whereas colorized maps better highlight gradations of time and can be very aesthetically pleasing. Also, some basemaps look much better either colorized or with greyscale-inversion.")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-list',[_c('v-btn',{attrs:{"large":"","color":"grey"},on:{"click":function($event){_vm.twoTone(true)}}},[_vm._v("\n            Invert\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","color":"red"},on:{"click":function($event){_vm.twoTone(false)}}},[_vm._v("\n            Colorize\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('h6',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.cutout.title))])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"info--text"},[_vm._v(_vm._s(_vm.cutout.name)+" - "+_vm._s(_vm.cutout.town))]),_vm._v(" "),_c('div',{staticClass:"info--text"},[_vm._v(_vm._s(_vm.cutout.fancymins))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Single, Double or Triple")]),_vm._v(" "),_c('div',[_vm._v("One Ring, Two Rings or Three Rings")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v("\n          >\n          Single\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog2 = true}}},[_vm._v("\n          >\n          Double\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog3 = true}}},[_vm._v("\n          >\n          Triple\n          ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Settings")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":"","router":"","to":"/"}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((60),function(n){return _c('v-flex',{key:n,attrs:{"xs4":""}},[_c('v-btn',{attrs:{"fab":"","color":"red text--black"},on:{"click":function($event){_vm.microMinute(n)}}},[_vm._v(" "+_vm._s(n)+" ")])],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-row',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"dark":"","fab":"","color":"five"},on:{"click":_vm.soloClock5}},[_vm._v(" 5 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"ten"},on:{"click":_vm.soloClock10}},[_vm._v(" 10 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"fifteen"},on:{"click":_vm.soloClock15}},[_vm._v(" 15 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"twenty"},on:{"click":_vm.soloClock20}},[_vm._v(" 20 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"twentyfive"},on:{"click":_vm.soloClock25}},[_vm._v(" 25 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirty"},on:{"click":_vm.soloClock30}},[_vm._v(" 30 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirtyfive"},on:{"click":_vm.soloClock35}},[_vm._v(" 35 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirtyfive"},on:{"click":_vm.soloClock40}},[_vm._v(" 40 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirtyfive"},on:{"click":_vm.soloClock45}},[_vm._v(" 45 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirtyfive"},on:{"click":_vm.soloClock50}},[_vm._v(" 50 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirtyfive"},on:{"click":_vm.soloClock55}},[_vm._v(" 55 ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","fab":"","color":"thirtyfive"},on:{"click":_vm.soloClock60}},[_vm._v(" 60 ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog2 = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Settings")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":"","router":"","to":"/"}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-5-10",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock5D10}},[_vm._v("5-10")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock5D15}},[_vm._v("5-15")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock5D20}},[_vm._v("5-20")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock5D25}},[_vm._v("5-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-30",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock5D30}},[_vm._v("5-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D35}},[_vm._v("5-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D40}},[_vm._v("5-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D45}},[_vm._v("5-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock5D50}},[_vm._v("5-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock5D55}},[_vm._v("5-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock5D60}},[_vm._v("5-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-10-15",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock10D15}},[_vm._v("10-15")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-20",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock10D20}},[_vm._v("10-20")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-25",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock10D25}},[_vm._v("10-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock10D30}},[_vm._v("10-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D35}},[_vm._v("10-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D40}},[_vm._v("10-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D45}},[_vm._v("10-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock10D50}},[_vm._v("10-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock10D55}},[_vm._v("10-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock10D60}},[_vm._v("10-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-15-20",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock15D20}},[_vm._v("15-20")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-25",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock15D25}},[_vm._v("15-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-30",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock15D30}},[_vm._v("15-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock15D35}},[_vm._v("15-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock15D40}},[_vm._v("15-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock15D45}},[_vm._v("15-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock15D50}},[_vm._v("15-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock15D55}},[_vm._v("15-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock15D60}},[_vm._v("15-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-20-25",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock20D25}},[_vm._v("20-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock20D30}},[_vm._v("20-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D35}},[_vm._v("20-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D40}},[_vm._v("20-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D45}},[_vm._v("20-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock20D50}},[_vm._v("20-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock20D55}},[_vm._v("20-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock20D60}},[_vm._v("20-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-25-30",attrs:{"dark":"","fab":"","small":""},on:{"click":_vm.onClock25D30}},[_vm._v("25-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D35}},[_vm._v("25-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D40}},[_vm._v("25-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D45}},[_vm._v("25-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock25D50}},[_vm._v("25-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock25D55}},[_vm._v("25-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock25D60}},[_vm._v("25-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock30D35}},[_vm._v("30-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock30D40}},[_vm._v("30-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock30D45}},[_vm._v("30-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-30-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock30D50}},[_vm._v("30-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-30-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock30D55}},[_vm._v("30-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-30-35",attrs:{"dark":"","fab":"","large":""},on:{"click":_vm.onClock30D60}},[_vm._v("30-60")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog3),callback:function ($$v) {_vm.dialog3=$$v},expression:"dialog3"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog3 = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Settings")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":"","router":"","to":"/"}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-5-10-15",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D15}},[_vm._v("5-10-15")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-20",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D20}},[_vm._v("5-10-20")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-25",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D25}},[_vm._v("5-10-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D30}},[_vm._v("5-10-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D35}},[_vm._v("5-10-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D40}},[_vm._v("5-10-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D45}},[_vm._v("5-10-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D50}},[_vm._v("5-10-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D55}},[_vm._v("5-10-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-10-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D10D60}},[_vm._v("5-10-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-5-15-20",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D20}},[_vm._v("5-15-20")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-25",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D25}},[_vm._v("5-15-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D30}},[_vm._v("5-15-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D35}},[_vm._v("5-15-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D40}},[_vm._v("5-15-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D45}},[_vm._v("5-15-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D50}},[_vm._v("5-15-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D55}},[_vm._v("5-15-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-15-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D15D60}},[_vm._v("5-15-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-5-20-25",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D25}},[_vm._v("5-20-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D30}},[_vm._v("5-20-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D35}},[_vm._v("5-20-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D40}},[_vm._v("5-20-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D45}},[_vm._v("5-20-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D50}},[_vm._v("5-20-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D55}},[_vm._v("5-20-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-20-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D20D60}},[_vm._v("5-20-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-5-25-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D30}},[_vm._v("5-25-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D35}},[_vm._v("5-25-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D40}},[_vm._v("5-25-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D45}},[_vm._v("5-25-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D50}},[_vm._v("5-25-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D55}},[_vm._v("5-25-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-25-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D25D60}},[_vm._v("5-25-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-5-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D30D35}},[_vm._v("5-30-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D30D40}},[_vm._v("5-30-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D30D45}},[_vm._v("5-30-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D30D50}},[_vm._v("5-30-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D30D55}},[_vm._v("5-30-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-5-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock5D30D60}},[_vm._v("5-30-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-10-15-20",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D15D20}},[_vm._v("10-15-20")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-20-25",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D20D25}},[_vm._v("10-20-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-20-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D20D30}},[_vm._v("10-20-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-25-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D25D30}},[_vm._v("10-25-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D30D35}},[_vm._v("10-30-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D30D40}},[_vm._v("10-30-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D30D45}},[_vm._v("10-30-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D30D50}},[_vm._v("10-30-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D30D55}},[_vm._v("10-30-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-10-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock10D30D60}},[_vm._v("10-30-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-15-20-25",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock15D20D25}},[_vm._v("15-20-25")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-25-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock15D25D30}},[_vm._v("15-25-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-15-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock15D30D35}},[_vm._v("15-30-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-25-30",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D25D30}},[_vm._v("20-25-30")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D30D35}},[_vm._v("20-30-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D30D40}},[_vm._v("20-30-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D30D45}},[_vm._v("20-30-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D30D50}},[_vm._v("20-30-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D30D55}},[_vm._v("20-30-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-20-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock20D30D60}},[_vm._v("20-30-60")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-row',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"btn-25-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D30D35}},[_vm._v("25-30-35")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D30D40}},[_vm._v("25-30-40")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D30D45}},[_vm._v("25-30-45")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D30D50}},[_vm._v("25-30-50")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D30D55}},[_vm._v("25-30-55")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-25-30-35",attrs:{"dark":"","fab":""},on:{"click":_vm.onClock25D30D60}},[_vm._v("25-30-60")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-space-between":"","text-xs-center":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("About (micro)decaPodVT")]),_vm._v(" "),_c('div',[_vm._v("Everything you wanted to know about this app but were afraid to ask ...")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog3 = true}}},[_vm._v("\n          >\n          About\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","to":'/'}},[_vm._v("\n          Home\n          ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("CHANGELOG")]),_vm._v(" "),_c('div',[_vm._v("A record of what is the what and what was the what.")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog2 = true}}},[_vm._v("\n          CHANGELOG\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","to":'/'}},[_vm._v("\n          Home\n          ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Punch List")]),_vm._v(" "),_c('div',[_vm._v("A sketch of the remaining work.")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v("\n          >\n          Punch List\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange","to":'/'}},[_vm._v("\n          Home\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"full-width":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card')],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-card')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.userIsAuthenticated)?_c('div',[(_vm.toggleMap)?_c('v-toolbar',{staticClass:"info",attrs:{"color":"info","app":"","dense":"","elevation-6":""}},[_c('spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"info black--text"},on:{"click":function($event){$event.stopPropagation();_vm.toggleMap =!_vm.toggleMap}}},[_c('span',[_vm._v(_vm._s(_vm.shortTitle))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{staticClass:"minbut",style:("background:"+ _vm.colorA +";")},[_vm._v("\n        "+_vm._s(_vm.minuteA)+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"minbut",style:("background:"+ _vm.colorB +";")},[_vm._v("\n        "+_vm._s(_vm.minuteB)+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"minbut",style:("background:"+ _vm.colorC +";")},[_vm._v("\n        "+_vm._s(_vm.minuteC)+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"minbut",style:("background:"+ _vm.info +";")},[_vm._v("\n         from "+_vm._s(_vm.schTitle)+" || travel type: "+_vm._s(_vm.type)+"\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v("\n         "+_vm._s(_vm.setPixel)+"px "),_vm._v(" "),_c('v-divider')],1):_vm._e(),_vm._v(" "),(!_vm.toggleMap)?_c('v-toolbar',{staticClass:"info",attrs:{"color":"info","app":"","dense":"","elevation-6":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.sideNav = !_vm.sideNav}}}),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","dark":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","color":"info black--text"},on:{"click":function($event){$event.stopPropagation();_vm.toggleMap =!_vm.toggleMap}},slot:"activator"},[_vm._v("\n          decaPodVT\n        ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.longTitle))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"300"}},[_c('v-btn',{attrs:{"slot":"activator","color":"info black--text","small":"","to":'/selectorindex'},slot:"activator"},[_vm._v("\n          "+_vm._s(_vm.schTitle)+"\n        ")]),_vm._v(" "),_c('span',[_vm._v("Click to select a point of interest or school.")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info","to":'/about'},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v("About")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info","to":'/profile'},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("person")])],1),_vm._v(" "),_c('span',[_vm._v("Profile -- Coming Soon!")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info","to":'/schoolindex'},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("school")])],1),_vm._v(" "),_c('span',[_vm._v("School Index")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info","to":'/poiindex'},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("mood")])],1),_vm._v(" "),_c('span',[_vm._v("Point of Interest Index")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info","to":'/pixelpicker'},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("graphic_eq")])],1),_vm._v(" "),_c('span',[_vm._v("Pixel Equalizer")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"300"}},[(_vm.invertStatus === true)?_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"red black--text","small":"","to":'/inverter'},slot:"activator"},[_vm._v("colorize")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Click to toggle between colorized or greyscale-inverted isochronic maps.")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"300"}},[(_vm.invertStatus === false)?_c('v-btn',{attrs:{"slot":"activator","color":"grey darken-3 info--text","small":"","to":'/inverter'},slot:"activator"},[_vm._v(" make greyscale")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Click to toggle between colorized or greyscale-inverted isochronic maps.")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info","to":'/'},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("home")])],1),_vm._v(" "),_c('span',[_vm._v("home")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","color":"info"},on:{"click":_vm.onLogout},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('span',[_vm._v("Logout")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.toggleMap)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-navigation-drawer',{staticClass:"info",attrs:{"fixed":"","hide-overlay":"","enable-resize-watcher":"","temporary":"","mini-variant":"","elevation-6":""},model:{value:(_vm.sideNav),callback:function ($$v) {_vm.sideNav=$$v},expression:"sideNav"}},[_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","color":"info","to":'/pixelpicker'},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.setPixel)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Identify/select the pixel density of isochrone.\n            ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"five"},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.minute5)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming 5-minute isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"ten"},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.minute10)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming 10-minute isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"fifteen"},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.minute15)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming 15-minute isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"twenty"},slot:"activator"},[_vm._v("\n            "+_vm._s(_vm.minute20)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming 20-minute isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"twentyfive"},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.minute25)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming 25-minute isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"thirty"},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.minute30)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming 30-minute isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{attrs:{"slot":"activator","to":'/timepicker',"color":"thirtyfive"},slot:"activator"},[_vm._v("\n              "+_vm._s(_vm.minute35)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v("\n              Confirming a 35-minute or higher isochrone ring and its color; press to select the isochrone ring(s)\n            ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"black","close-delay":"100"}},[_c('v-btn',{staticClass:"typeBut",attrs:{"slot":"activator","to":'/typepicker'},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.typeIcon))])],1),_vm._v(" "),_c('span',[_vm._v("\n              Confirming travel-type; press to change\n            ")])],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-center":""}},[_c('router-view')],1)],1):_vm._e(),_vm._v(" "),(_vm.toggleMap)?_c('v-layout',{staticClass:"hundred",attrs:{"align-center":""}},[_c('map-board')],1):_vm._e()],1):_c('div',[_c('not-signedin')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("\n      Vermont Points of Interest\n      "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"search":_vm.search,"headers":_vm.headers,"items":_vm.items,"rows-per-page-items":[400, 100, 10, 5],"pagination":_vm.pagination,"item-key":"name"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){_vm.changeSort(header.value)}}},[_c('v-icon',[_vm._v("arrow_upward")]),_vm._v("\n          "+_vm._s(header.text)+"\n        ")],1)}))]}},{key:"items",fn:function(props){return [_c('td',[_c('v-btn',{attrs:{"outline":"","dark":"","color":"indigo"},nativeOn:{"click":function($event){_vm.openDetails(props.item)}}},[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.town))])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Base Picker")]),_vm._v(" "),_c('div',[_vm._v("currently available: Stamen Basemaps (more to be wired-up)")])])]),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('v-btn',{key:option,attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){_vm.basePicker(option)}}},[_vm._v("\n          >\n          "+_vm._s(option)+"\n          ")])})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"dark":"","color":"alert"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Type Picker")]),_vm._v(" "),_c('div',[_vm._v("Walking, Biking, Driving")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){_vm.travelTypePickerWalk($event)}}},[_vm._v("\n          >\n          "),_c('v-icon',{attrs:{"left":""}},[_vm._v("directions_walk")]),_vm._v("\n          Walk\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){_vm.travelTypePickerBike($event)}}},[_vm._v("\n          >\n          "),_c('v-icon',{attrs:{"left":""}},[_vm._v("directions_bike")]),_vm._v("\n          Bike\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"},nativeOn:{"click":function($event){_vm.travelTypePickerCar($event)}}},[_vm._v("\n          >\n          "),_c('v-icon',{attrs:{"left":""}},[_vm._v("directions_car")]),_vm._v("\n          Car\n          ")],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("\n      Vermont Schools\n      "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"search":_vm.search,"headers":_vm.headers,"items":_vm.items,"rows-per-page-items":[400, 100, 10, 5],"pagination":_vm.pagination,"item-key":"name"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],on:{"click":function($event){_vm.changeSort(header.value)}}},[_c('v-icon',[_vm._v("arrow_upward")]),_vm._v("\n          "+_vm._s(header.text)+"\n        ")],1)}))]}},{key:"items",fn:function(props){return [_c('td',[_c('v-btn',{attrs:{"outline":"","color":"indigo"},nativeOn:{"click":function($event){_vm.openDetails(props.item)}}},[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.townam))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.schdis))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.schcat))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.grades))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.estsiz))])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(262);
module.exports = __webpack_require__(261);


/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);





// import L from 'leaflet'

// import actions from './actions'
// import mutations from './mutations'
// import getters from './getters'

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    loadedCutouts: [{
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/4/47/New_york_times_square-terabass.jpg',
      id: 'afajfjadfaadfa323',
      title: 'Meetup in New York',
      date: new Date(),
      location: 'New York',
      description: 'New York, New York!'
    }],
    inverse: true,
    cluster: false,
    punchlist: [{ category: 'houseKeeping', done: false, title: 'ensure the login process works by limiting access to those not logged in' }, { category: 'houseKeeping', done: false, title: 'clean-up time and pixel picker pages' }, { category: 'houseKeeping', done: false, title: 'move the basemap control to left-side' }, { category: 'houseKeeping', done: false, title: 'see about a print-button' }, { category: 'houseKeeping', done: false, title: 'find missing icons for controls??' }, { category: 'houseKeeping', done: false, title: 'center the attribution beneath the time fabs' }, { category: 'houseKeeping', done: false, title: 'add an "about" page' }, { category: 'houseKeeping', done: false, title: 'add a "profile" page' }, { category: 'paywall', done: false, title: 'add gallery of selected images with purchasing option' }, { category: 'paywall', done: false, title: 'mimic above based on meetups registration' }, { category: 'paywall', done: false, title: 'stripe or paypal hookup' }, { category: 'map', done: false, title: 'add an inverse model' }, { category: 'map', done: false, title: 'add the cluster-map, e.g., global option (might be a different app)' }, { category: 'map', done: false, title: 'add geolocation' }, { category: 'map', done: false, title: 'add colorpicker, i.e., add various color-schemes to times' }, { category: 'app', done: false, title: 'finish the PWA elements' }, { category: 'timepicker', done: false, title: 'add option for single times, probably have an open dialog on time picker that splits between single and three-time options' }, { category: 'map', done: false, title: 'see about a mapbox version (maybe major)' }, { category: 'travelpicker', done: false, title: 'add  (basically already written)' }, { category: 'app', done: false, title: 'write the about and profile pages' }],
    user: 'SNF',
    loading: false,
    error: null,
    verPois: [{ name: 'Woodstock Town Crier', town: 'Woodstock', lat: 43.625158, lng: -72.518432 }, { name: 'Woodstock Inn', town: 'Woodstock', lat: 43.623253, lng: -72.518900 }, { name: 'Killington Ski Area', town: 'Killington', lat: 43.617563, lng: -72.802489 }, { name: 'Killington Grand Resort', town: 'Killington', lat: 43.626820, lng: -72.794226 }, { name: 'Stowe Mountain Resort', town: 'Stowe', lat: 44.529778, lng: -72.779285 }, { name: 'Trapp Family Lodge', town: 'Stowe', lat: 44.468267, lng: -72.745886 }, { name: 'The Equinox', town: 'Manchester', lat: 43.161947, lng: -73.072549 }, { name: 'Dartmouth College', town: 'Hanover', lat: 43.704448, lng: -72.288661 }, { name: 'Church Street', town: 'Burlington', lat: 44.478144, lng: -73.212614 }, { name: 'Jackson Gore Inn', town: 'Ludlow', lat: 43.422628, lng: -72.71654 }, { name: 'Stratton Mountain Resort', town: 'South Londonderry', lat: 43.113457, lng: -72.908119 }, { name: 'Vermont State Capital', town: 'Montpelier', lat: 44.262576, lng: -72.580463 }, { name: 'Hope Cemetery', town: 'Barre', lat: 44.210716, lng: -72.499444 }, { name: 'Burrows Trailhead, Camels Hump State Park', town: 'Duxbury', lat: 44.304873, lng: -72.907891 }, { name: 'Belmont General Store', town: 'Mount Holly', lat: 43.414961, lng: -72.821391 }],
    verSch: [{ name: 'Academy School', estsiz: '360', grades: 'K-6', lat: 42.851176, lng: -72.597994, schcat: 'Elementary School', schdis: 'Brattleboro', townam: 'Brattleboro', value: false }, { name: 'Addison Central School', estsiz: '100', grades: 'K-6', lat: 44.0879679, lng: -73.304713, schcat: 'Elementary School', schdis: 'Addison', townam: 'Addison', value: false }, { name: 'Albany Community School', estsiz: '80', grades: 'K-8', lat: 44.737995, lng: -72.376839, schcat: 'K-8', schdis: 'Albany', townam: 'Albany', value: false }, { name: 'Albert Bridge School (West Windsor)', estsiz: '70', grades: 'K-6', lat: 43.4694223, lng: -72.4714816, schcat: 'Elementary School', schdis: 'West Windsor', townam: 'Brownsville', value: false }, { name: 'Albert D Lawton School', estsiz: '340', grades: '6-8', lat: 44.4869722, lng: -73.0987693, schcat: 'Middle School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false }, { name: 'Alburgh Community Education Center', estsiz: '190', grades: 'K-8', lat: 44.979204, lng: -73.2982707, schcat: 'K-8', schdis: 'Alburgh', townam: 'Alburg', value: false }, { name: 'Arlington Memorial', estsiz: '180', grades: '6-12', lat: 43.065997, lng: -73.1508814, schcat: 'Junior-Senior High School', schdis: 'Arlington', townam: 'Arlington', value: false }, { name: 'Bakersfield School', estsiz: '180', grades: 'PK-8', lat: 44.7842811, lng: -72.8027989, schcat: 'K-8', schdis: 'Bakersfield', townam: 'Bakersfield', value: false }, { name: 'Barnard Central School', estsiz: '80', grades: 'PK-6', lat: 43.7271345, lng: -72.6195002, schcat: 'Elementary School', schdis: 'Barnard', townam: 'Barnard', value: false }, { name: 'Barnet Elementary School', estsiz: '190', grades: 'K-8', lat: 44.307334, lng: -72.080737, schcat: 'K-8', schdis: 'Barnet', townam: 'Barnet', value: false }, { name: 'Barre City Elementary-Middle School', estsiz: '880', grades: 'PK-8', lat: 44.1845142, lng: -72.5047609, schcat: 'K-8', schdis: 'Barre City', townam: 'Barre', value: false }, { name: 'Barre Town Elementary School', estsiz: '850', grades: 'PK-8', lat: 44.168403, lng: -72.486165, schcat: 'K-8', schdis: 'Barre Town', townam: 'Barre', value: false }, { name: 'Barstow Memorial Joint Contract School', estsiz: '240', grades: 'PK-8', lat: 43.7010447, lng: -72.9524235, schcat: 'K-8', schdis: 'Barstow Memorial Joint Contract School', townam: 'Chittenden', value: false }, { name: 'Barton Graded School', estsiz: '180', grades: 'K-8', lat: 44.749023, lng: -72.180092, schcat: 'K-8', schdis: 'Barton ID', townam: 'Barton', value: false }, { name: 'Beeman Elementary School', estsiz: '110', grades: 'K-6', lat: 44.125328, lng: -73.153222, schcat: 'Elementary School', schdis: 'New Haven', townam: 'New Haven', value: false }, { name: 'Bellows Falls Middle School', estsiz: '250', grades: '5-8', lat: 43.1333656, lng: -72.4462749, schcat: 'Middle School', schdis: 'Rockingham', townam: 'Bellows Falls', value: false }, { name: 'Bellows Falls UHSD No 27', estsiz: '350', grades: '9-12', lat: 43.1364725, lng: -72.4442318, schcat: 'Senior High School', schdis: 'Bellows Falls UHSD', townam: 'Bellows Falls', value: false }, { name: 'Bellows Free Academy (Fairfax)', estsiz: '590', grades: 'PK-8', lat: 44.6635996, lng: -73.0132732, schcat: 'K-8', schdis: 'Fairfax', townam: 'Fairfax', value: false }, { name: 'Bellows Free Academy High School (Fairfax)', estsiz: '340', grades: '9-12', lat: 44.8080266, lng: -73.0828117, schcat: 'Senior High School', schdis: 'Fairfax', townam: 'St Albans', value: false }, { name: 'Bellows Free Academy UHSD No 48', estsiz: '1', grades: '9-12', lat: 44.6635996, lng: -73.0132732, schcat: 'Senior High School', schdis: 'Bellows Free Academy UHSD', townam: 'Fairfax', value: false }, { name: 'Bennington Elementary School', estsiz: '270', grades: 'K-5', lat: 42.88073, lng: -73.1935139, schcat: 'Elementary School', schdis: 'Bennington ID', townam: 'Bennington', value: false }, { name: 'Benson Village School', estsiz: '140', grades: 'PK-8', lat: 43.7072408, lng: -73.302237, schcat: 'K-8', schdis: 'Benson', townam: 'Benson', value: false }, { name: 'Berkshire Elementary School', estsiz: '200', grades: 'PK-8', lat: 44.9724974, lng: -72.7662099, schcat: 'K-8', schdis: 'Berkshire', townam: 'Richford', value: false }, { name: 'Berlin Elementary School', estsiz: '220', grades: 'PK-6', lat: 44.2145063, lng: -72.5717356, schcat: 'Elementary School', schdis: 'Berlin', townam: 'Berlin', value: false }, { name: 'Bethel Elementary School', estsiz: '140', grades: 'K-6', lat: 43.833232, lng: -72.6435001, schcat: 'Elementary School', schdis: 'Bethel', townam: 'Bethel', value: false }, { name: 'Black River USD No 39', estsiz: '190', grades: '7-12', lat: 43.397114, lng: -72.688557, schcat: 'Junior-Senior High School', schdis: 'Black River UHSD', townam: 'Ludlow', value: false }, { name: 'Blue Mountain USD No 21', estsiz: '440', grades: 'PK-12', lat: 44.1553744, lng: -72.0833144, schcat: 'K-12', schdis: 'Blue Mountain USD', townam: 'Wells River', value: false }, { name: 'Bradford Elementary School', estsiz: '200', grades: 'K-6', lat: 44.0026079, lng: -72.1224734, schcat: 'Elementary School', schdis: 'Bradford ID', townam: 'Bradford', value: false }, { name: 'Braintree School', estsiz: '80', grades: 'K-6', lat: 43.955559, lng: -72.72245, schcat: 'Elementary School', schdis: 'Braintree', townam: 'Braintree', value: false }, { name: 'Bratt Area Middle School UHSD No 6', estsiz: '260', grades: '7-8', lat: 42.83564, lng: -72.561716, schcat: 'Middle School', schdis: 'Brattleboro UHSD', townam: 'Brattleboro', value: false }, { name: 'Brattleboro UHSD No 6', estsiz: '880', grades: '9-12', lat: 42.836739, lng: -72.561267, schcat: 'Senior High School', schdis: 'Brattleboro UHSD', townam: 'Brattleboro', value: false }, { name: 'Brewster Pierce School', estsiz: '150', grades: 'PK-4', lat: 44.2958862, lng: -72.9635912, schcat: 'Elementary School', schdis: 'Huntington', townam: 'Huntington', value: false }, { name: 'Bridport Central School', estsiz: '90', grades: 'PK-6', lat: 43.9809453, lng: -73.3158066, schcat: 'Elementary School', schdis: 'Bridport', townam: 'Bridport', value: false }, { name: 'Brighton Elementary School', estsiz: '100', grades: 'PK-8', lat: 44.8215785, lng: -71.8938945, schcat: 'K-8', schdis: 'Brighton', townam: 'Island Pond', value: false }, { name: 'Bristol Elementary School', estsiz: '280', grades: 'K-6', lat: 44.1379395, lng: -73.0770421, schcat: 'Elementary School', schdis: 'Bristol', townam: 'Bristol', value: false }, { name: 'Brookfield School', estsiz: '80', grades: 'K-6', lat: 44.016395, lng: -72.606683, schcat: 'Elementary School', schdis: 'Brookfield', townam: 'Brookfield', value: false }, { name: 'Brownington Central School', estsiz: '100', grades: 'K-8', lat: 44.819904, lng: -72.137688, schcat: 'K-8', schdis: 'Brownington', townam: 'Brownington', value: false }, { name: 'Browns River Middle USD No 17', estsiz: '410', grades: '5-8', lat: 44.5192478, lng: -72.9441695, schcat: 'Middle School', schdis: 'Mt. Mansfield USD', townam: 'Jericho', value: false }, { name: 'Burke Town School', estsiz: '190', grades: 'K-8', lat: 44.625084, lng: -71.960265, schcat: 'K-8', schdis: 'Burke', townam: 'West Burke', value: false }, { name: 'Burlington Senior High School', estsiz: '1', grades: '9-12', lat: 44.4963229, lng: -73.235261, schcat: 'Senior High School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'C P Smith School', estsiz: '260', grades: 'K-5', lat: 44.513102, lng: -73.243035, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Cabot School', estsiz: '230', grades: 'PK-12', lat: 44.4034302, lng: -72.3093358, schcat: 'K-12', schdis: 'Cabot', townam: 'Cabot', value: false }, { name: 'Calais Elementary School', estsiz: '140', grades: 'PK-6', lat: 44.3193948, lng: -72.4516452, schcat: 'Elementary School', schdis: 'Calais', townam: 'Plainfield', value: false }, { name: 'Cambridge Elementary School', estsiz: '370', grades: 'PK-6', lat: 44.6444743, lng: -72.8267715, schcat: 'Elementary School', schdis: 'Cambridge', townam: 'Jeffersonville', value: false }, { name: 'Camels Hump Middle USD No 17', estsiz: '380', grades: '5-8', lat: 44.4135271, lng: -72.9943127, schcat: 'Middle School', schdis: 'Mt. Mansfield USD', townam: 'Richmond', value: false }, { name: 'Canaan Schools', estsiz: '190', grades: 'K-12', lat: 44.99537, lng: -71.537662, schcat: 'K-12', schdis: 'Canaan', townam: 'Canaan', value: false }, { name: 'Castleton Hubbardton USD No 42', estsiz: '390', grades: 'PK-8', lat: 43.612408, lng: -73.178207, schcat: 'K-8', schdis: 'Castleton-Hubbardton UESD', townam: 'Castleton', value: false }, { name: 'Cavendish Town Elementary School', estsiz: '120', grades: 'PK-6', lat: 43.3836765, lng: -72.6368872, schcat: 'Elementary School', schdis: 'Cavendish', townam: 'Proctorsville', value: false }, { name: 'Chamberlin School', estsiz: '260', grades: 'K-5', lat: 44.4713727, lng: -73.1654672, schcat: 'Elementary School', schdis: 'South Burlington', townam: 'So Burlington', value: false }, { name: 'Champlain School', estsiz: '340', grades: 'K-5', lat: 44.457065, lng: -73.213221, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Champlain Valley UHSD No 15', estsiz: '1', grades: '9-12', lat: 44.3446552, lng: -73.1099525, schcat: 'Senior High School', schdis: 'Champlain Valley UHSD', townam: 'Hinesburg', value: false }, { name: 'Charleston Elementary School', estsiz: '120', grades: 'PK-8', lat: 44.843109, lng: -72.019768, schcat: 'K-8', schdis: 'Charleston', townam: 'West Charleston', value: false }, { name: 'Charlotte Central School', estsiz: '460', grades: 'PK-8', lat: 44.315086, lng: -73.226451, schcat: 'K-8', schdis: 'Charlotte', townam: 'Charlotte', value: false }, { name: 'Chelsea High School', estsiz: '160', grades: 'K-12', lat: 43.987282, lng: -72.446617, schcat: 'K-12', schdis: 'Chelsea', townam: 'Chelsea', value: false }, { name: 'Chester-Andover Elementary School', estsiz: '300', grades: 'PK-6', lat: 43.2646923, lng: -72.5954546, schcat: 'Elementary School', schdis: 'Chester-Andover UESD', townam: 'Chester', value: false }, { name: 'Clarendon Elementary School', estsiz: '210', grades: 'PK-6', lat: 43.5634, lng: -72.96786, schcat: 'Elementary School', schdis: 'Clarendon', townam: 'North Clarendon', value: false }, { name: 'Colchester High School', estsiz: '730', grades: '9-12', lat: 44.5399122, lng: -73.2138341, schcat: 'Senior High School', schdis: 'Colchester', townam: 'Colchester', value: false }, { name: 'Colchester Middle School', estsiz: '520', grades: '6-8', lat: 44.5405118, lng: -73.2097506, schcat: 'Middle School', schdis: 'Colchester', townam: 'Colchester', value: false }, { name: 'Concord School', estsiz: '190', grades: 'PK-12', lat: 44.4266783, lng: -71.8904608, schcat: 'K-12', schdis: 'Concord', townam: 'Concord', value: false }, { name: 'Cornwall Elementary School', estsiz: '90', grades: 'K-6', lat: 43.963902, lng: -73.2063979, schcat: 'Elementary School', schdis: 'Cornwall', townam: 'Cornwall', value: false }, { name: 'Coventry Village School', estsiz: '100', grades: 'K-8', lat: 44.8628287, lng: -72.2650021, schcat: 'K-8', schdis: 'Coventry', townam: 'Coventry', value: false }, { name: 'Craftsbury Schools', estsiz: '160', grades: 'K-12', lat: 44.6541939, lng: -72.381984, schcat: 'K-12', schdis: 'Craftsbury', townam: 'Craftsbury Comm', value: false }, { name: 'Crossett Brook Middle USD No 45', estsiz: '290', grades: '5-8', lat: 44.321123, lng: -72.7528363, schcat: 'Middle School', schdis: 'Duxbury-Waterbury UESD', townam: 'Duxbury', value: false }, { name: 'Currier Memorial USD No 23', estsiz: '100', grades: 'K-6', lat: 43.3497894, lng: -72.9951757, schcat: 'Elementary School', schdis: 'Currier Memorial UESD', townam: 'Danby', value: false }, { name: 'Danville School', estsiz: '340', grades: 'K-12', lat: 44.4108915, lng: -72.1437508, schcat: 'K-12', schdis: 'Danville', townam: 'Danville', value: false }, { name: 'Derby Elementary School', estsiz: '330', grades: 'K-6', lat: 45.001503, lng: -72.118345, schcat: 'Elementary School', schdis: 'Derby', townam: 'Derby Line', value: false }, { name: 'Dorset School, The', estsiz: '170', grades: 'K-8', lat: 43.2219794, lng: -73.0657074, schcat: 'K-8', schdis: 'Dorset', townam: 'Dorset', value: false }, { name: 'Dothan Brook School', estsiz: '250', grades: 'K-5', lat: 43.687628, lng: -72.3217171, schcat: 'Elementary School', schdis: 'Hartford', townam: 'White River Jct', value: false }, { name: 'Doty Memorial School', estsiz: '90', grades: 'PK-6', lat: 44.373349, lng: -72.547949, schcat: 'Elementary School', schdis: 'Worcester', townam: 'Worcester', value: false }, { name: 'Dover Elementary School', estsiz: '100', grades: 'PK-6', lat: 42.938863, lng: -72.80991, schcat: 'Elementary School', schdis: 'Dover', townam: 'East Dover', value: false }, { name: 'Dummerston Schools', estsiz: '180', grades: 'K-8', lat: 42.9336033, lng: -72.5379992, schcat: 'K-8', schdis: 'Dummerston', townam: 'East Dummerston', value: false }, { name: 'East Montpelier Elementary School', estsiz: '260', grades: 'PK-6', lat: 44.2866171, lng: -72.4953304, schcat: 'Elementary School', schdis: 'East Montpelier', townam: 'East Montpelier', value: false }, { name: 'Eden Central School', estsiz: '140', grades: 'PK-6', lat: 44.704038, lng: -72.563901, schcat: 'Elementary School', schdis: 'Eden', townam: 'Eden', value: false }, { name: 'Edmunds Elementary School', estsiz: '360', grades: 'K-5', lat: 44.475518, lng: -73.20729, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Edmunds Middle School', estsiz: '390', grades: '6-8', lat: 44.475468, lng: -73.208086, schcat: 'Middle School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Elm Hill School', estsiz: '290', grades: 'K-2', lat: 43.3061209, lng: -72.4844404, schcat: 'Elementary School', schdis: 'Springfield', townam: 'Springfield', value: false }, { name: 'Enosburg Falls Elementary School', estsiz: '250', grades: 'PK-5', lat: 44.904316, lng: -72.801033, schcat: 'Elementary School', schdis: 'Enosburgh', townam: 'Enosburg Falls', value: false }, { name: 'Enosburg Falls Junior-Senior High School', estsiz: '440', grades: '6-12', lat: 44.9053176, lng: -72.8039149, schcat: 'Junior-Senior High School', schdis: 'Enosburgh', townam: 'Enosburg Falls', value: false }, { name: 'Essex Community Education Center UHSD No 46', estsiz: '1', grades: '9-12', lat: 44.4982009, lng: -73.1100265, schcat: 'Senior High School', schdis: 'Essex Comm. Ed. Ctr. UHSD', townam: 'Essex Junction', value: false }, { name: 'Essex Elementary School', estsiz: '440', grades: 'PK-2', lat: 44.5130041, lng: -73.0555147, schcat: 'Elementary School', schdis: 'Essex Town', townam: 'Essex Junction', value: false }, { name: 'Essex Middle School', estsiz: '420', grades: '6-8', lat: 44.4992447, lng: -73.0579969, schcat: 'Middle School', schdis: 'Essex Town', townam: 'Essex Junction', value: false }, { name: 'Fair Haven Grade School', estsiz: '360', grades: 'PK-8', lat: 43.5948092, lng: -73.2644651, schcat: 'K-8', schdis: 'Fair Haven', townam: 'Fair Haven', value: false }, { name: 'Fair Haven UHSD No 16', estsiz: '430', grades: '9-12', lat: 43.6035814, lng: -73.2703625, schcat: 'Senior High School', schdis: 'Fair Haven UHSD', townam: 'Fair Haven', value: false }, { name: 'Fairfield Center School', estsiz: '220', grades: 'K-8', lat: 44.80051, lng: -72.947922, schcat: 'K-8', schdis: 'Fairfield', townam: 'Fairfield', value: false }, { name: 'Fayston Elementary School', estsiz: '110', grades: 'PK-6', lat: 44.1791977, lng: -72.8842112, schcat: 'Elementary School', schdis: 'Fayston', townam: 'Fayston', value: false }, { name: 'Ferrisburgh Central School', estsiz: '210', grades: 'K-6', lat: 44.206608, lng: -73.247734, schcat: 'Elementary School', schdis: 'Ferrisburgh', townam: 'Ferrisburgh', value: false }, { name: 'Fisher School', estsiz: '160', grades: 'PK-5', lat: 43.066169, lng: -73.153659, schcat: 'Elementary School', schdis: 'Arlington', townam: 'Arlington', value: false }, { name: 'Fletcher Elementary School', estsiz: '130', grades: 'PK-6', lat: 44.67049, lng: -72.923782, schcat: 'Elementary School', schdis: 'Fletcher', townam: 'Cambridge', value: false }, { name: 'Flood Brook USD No 20 (School)', estsiz: '300', grades: 'PK-8', lat: 43.2367859, lng: -72.8480324, schcat: 'K-8', schdis: 'Flood Brook UESD', townam: 'Londonderry', value: false }, { name: 'Folsom Education and Community Center', estsiz: '120', grades: 'K-8', lat: 44.636311, lng: -73.3022079, schcat: 'K-8', schdis: 'South Hero', townam: 'South Hero', value: false }, { name: 'Founders Memorial School', estsiz: '420', grades: '3-5', lat: 44.5004481, lng: -73.0553216, schcat: 'Elementary School', schdis: 'Essex Town', townam: 'Essex Junction', value: false }, { name: 'Franklin Central School', estsiz: '130', grades: 'K-6', lat: 44.9842389, lng: -72.9201647, schcat: 'Elementary School', schdis: 'Franklin', townam: 'Franklin', value: false }, { name: 'Frederick H Tuttle Middle School', estsiz: '550', grades: '6-8', lat: 44.4567486, lng: -73.1774257, schcat: 'Middle School', schdis: 'South Burlington', townam: 'S Burlington', value: false }, { name: 'Georgia Elementary-Middle School', estsiz: '630', grades: 'PK-8', lat: 44.7350207, lng: -73.1144163, schcat: 'K-8', schdis: 'Georgia', townam: 'St Albans', value: false }, { name: 'Glover Community School', estsiz: '130', grades: 'K-8', lat: 44.705938, lng: -72.189466, schcat: 'K-8', schdis: 'Glover', townam: 'Glover', value: false }, { name: 'Grand Isle Elementary School', estsiz: '210', grades: 'K-8', lat: 44.725599, lng: -73.2915204, schcat: 'K-8', schdis: 'Grand Isle', townam: 'Grand Isle', value: false }, { name: 'Green Mountain UHSD No 35', estsiz: '360', grades: '7-12', lat: 43.253613, lng: -72.581459, schcat: 'Junior-Senior High School', schdis: 'Green Mountain UHSD', townam: 'Chester', value: false }, { name: 'Green Street School', estsiz: '250', grades: 'K-6', lat: 42.85174, lng: -72.565, schcat: 'Elementary School', schdis: 'Brattleboro', townam: 'Brattleboro', value: false }, { name: 'Guilford Central School', estsiz: '140', grades: 'K-8', lat: 42.800709, lng: -72.6223515, schcat: 'K-8', schdis: 'Guilford', townam: 'Guilford', value: false }, { name: 'Halifax School', estsiz: '60', grades: 'K-8', lat: 42.784431, lng: -72.768503, schcat: 'K-8', schdis: 'Halifax', townam: 'West Halifax', value: false }, { name: 'Hardwick Elementary School', estsiz: '270', grades: 'K-6', lat: 44.5033274, lng: -72.3681449, schcat: 'Elementary School', schdis: 'Hardwick', townam: 'Hardwick', value: false }, { name: 'Hartford High School', estsiz: '610', grades: '9-12', lat: 43.657753, lng: -72.3188551, schcat: 'Senior High School', schdis: 'Hartford', townam: 'White River Jct', value: false }, { name: 'Hartford Memorial Middle School', estsiz: '360', grades: '6-8', lat: 43.6563504, lng: -72.3201992, schcat: 'Middle School', schdis: 'Hartford', townam: 'White River Jct', value: false }, { name: 'Hartland Elementary School', estsiz: '310', grades: 'K-8', lat: 43.5379884, lng: -72.3942648, schcat: 'K-8', schdis: 'Hartland', townam: 'Hartland', value: false }, { name: 'Harwood UHSD No 19', estsiz: '580', grades: '9-12', lat: 44.2539876, lng: -72.7867166, schcat: 'Senior High School', schdis: 'Harwood UHSD', townam: 'Duxbury', value: false }, { name: 'Harwood Union Middle UHSD No 19', estsiz: '160', grades: '7-8', lat: 44.2540115, lng: -72.7864532, schcat: 'Middle School', schdis: 'Harwood UHSD', townam: 'Duxbury', value: false }, { name: 'Hazen UHSD No 26 (School)', estsiz: '370', grades: '7-12', lat: 44.508948, lng: -72.364683, schcat: 'Junior-Senior High School', schdis: 'Hazen UHSD', townam: 'Hardwick', value: false }, { name: 'Hiawatha School', estsiz: '240', grades: 'PK-3', lat: 44.4885517, lng: -73.1269076, schcat: 'Elementary School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false }, { name: 'Highgate Schools', estsiz: '310', grades: 'K-6', lat: 44.94117, lng: -73.044022, schcat: 'Elementary School', schdis: 'Highgate', townam: 'Highgate Center', value: false }, { name: 'Hinesburg Community School', estsiz: '480', grades: 'PK-8', lat: 44.32621, lng: -73.10778, schcat: 'K-8', schdis: 'Hinesburg', townam: 'Hinesburg', value: false }, { name: 'Holland Elementary School', estsiz: '80', grades: 'PK-6', lat: 44.9730783, lng: -72.0133074, schcat: 'Elementary School', schdis: 'Holland', townam: 'Derby Line', value: false }, { name: 'Hyde Park Elementary School', estsiz: '250', grades: 'PK-6', lat: 44.591888, lng: -72.6137179, schcat: 'Elementary School', schdis: 'Hyde Park', townam: 'Hyde Park', value: false }, { name: 'Integrated Arts Academy At HO Wheeler', estsiz: '300', grades: 'PK-5', lat: 44.487972, lng: -73.213857, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Irasburg Village School', estsiz: '130', grades: 'K-8', lat: 44.8036308, lng: -72.2728506, schcat: 'K-8', schdis: 'Irasburg', townam: 'Irasburg', value: false }, { name: 'Isle La Motte Elementary School', estsiz: '40', grades: 'K-6', lat: 44.8823346, lng: -73.346067, schcat: 'Elementary School', schdis: 'Isle La Motte', townam: 'Isle Lamotte', value: false }, { name: 'J F Kennedy Elementary School', estsiz: '440', grades: 'PK-5', lat: 44.500416, lng: -73.180687, schcat: 'Elementary School', schdis: 'Winooski ID', townam: 'Winooski', value: false }, { name: 'J J Flynn School', estsiz: '360', grades: 'PK-5', lat: 44.517023, lng: -73.260002, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Jamaica Village School', estsiz: '70', grades: 'PK-6', lat: 43.103771, lng: -72.775345, schcat: 'Elementary School', schdis: 'Jamaica', townam: 'Jamaica', value: false }, { name: 'Jay-Westfield Joint Contract School', estsiz: '90', grades: 'K-6', lat: 44.952663, lng: -72.435028, schcat: 'Elementary School', schdis: 'Jay-Westfield Joint Contract School', townam: 'Jay', value: false }, { name: 'Jericho Elementary School', estsiz: '220', grades: 'K-4', lat: 44.5053714, lng: -72.9897701, schcat: 'Elementary School', schdis: 'Jericho', townam: 'Jericho', value: false }, { name: 'Johnson Elementary School', estsiz: '240', grades: 'PK-6', lat: 44.637031, lng: -72.674763, schcat: 'Elementary School', schdis: 'Johnson', townam: 'Johnson', value: false }, { name: 'Lake Region UHSD No 24', estsiz: '370', grades: '9-12', lat: 44.782603, lng: -72.2206491, schcat: 'Senior High School', schdis: 'Lake Region UHSD', townam: 'Orleans', value: false }, { name: 'Lakeview USD No 43', estsiz: '80', grades: 'K-6', lat: 44.580754, lng: -72.293904, schcat: 'Elementary School', schdis: 'Lakeview UESD', townam: 'Greensboro', value: false }, { name: 'Lamoille UHSD No 18', estsiz: '570', grades: '9-12', lat: 44.6014224, lng: -72.6308753, schcat: 'Senior High School', schdis: 'Lamoille UHSD', townam: 'Hyde Park', value: false }, { name: 'Lamoille Union Middle School No 18', estsiz: '280', grades: '7-8', lat: 44.601121, lng: -72.62991, schcat: 'Middle School', schdis: 'Lamoille UHSD', townam: 'Hyde Park', value: false }, { name: 'Leicester Central School', estsiz: '60', grades: 'PK-6', lat: 43.8667079, lng: -73.1088582, schcat: 'Elementary School', schdis: 'Leicester', townam: 'Leicester', value: false }, { name: 'Leland and Gray UHSD No 34', estsiz: '380', grades: '7-12', lat: 43.0465917, lng: -72.6670936, schcat: 'Junior-Senior High School', schdis: 'Leland & Gray UHSD', townam: 'Townshend', value: false }, { name: 'Lincoln Community School', estsiz: '120', grades: 'K-6', lat: 44.09766, lng: -72.986305, schcat: 'Elementary School', schdis: 'Lincoln', townam: 'Lincoln', value: false }, { name: 'Lothrop School', estsiz: '270', grades: 'PK-6', lat: 43.7055257, lng: -73.0190098, schcat: 'Elementary School', schdis: 'Pittsford', townam: 'Pittsford', value: false }, { name: 'Lowell Graded School', estsiz: '120', grades: 'PK-8', lat: 44.8053359, lng: -72.448708, schcat: 'K-8', schdis: 'Lowell', townam: 'Lowell', value: false }, { name: 'Ludlow Elementary School', estsiz: '130', grades: 'PK-6', lat: 44.8053359, lng: -72.448708, schcat: 'Elementary School', schdis: 'Ludlow', townam: 'Ludlow', value: false }, { name: 'Lunenburg Schools', estsiz: '120', grades: 'PK-8', lat: 44.4147729, lng: -71.714483, schcat: 'K-8', schdis: 'Lunenburg', townam: 'Gilman', value: false }, { name: 'Lyman C Hunt Middle School', estsiz: '390', grades: '6-8', lat: 44.513362, lng: -73.249199, schcat: 'Middle School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Lyndon Town School', estsiz: '460', grades: 'K-8', lat: 44.5465485, lng: -71.9853549, schcat: 'K-8', schdis: 'Lyndon', townam: 'Lyndonville', value: false }, { name: 'Main Street School', estsiz: '180', grades: '6-8', lat: 44.2629656, lng: -72.5695793, schcat: 'Middle School', schdis: 'Montpelier', townam: 'Montpelier', value: false }, { name: 'Malletts Bay School', estsiz: '480', grades: 'PK-5', lat: 44.5387028, lng: -73.2076928, schcat: 'Elementary School', schdis: 'Colchester', townam: 'Colchester', value: false }, { name: 'Manchester Elementary-Middle School', estsiz: '450', grades: 'PK-8', lat: 43.178738, lng: -73.053734, schcat: 'K-8', schdis: 'Manchester', townam: 'Manchester Ctr', value: false }, { name: 'Marion W Cross School', estsiz: '310', grades: 'K-6', lat: 43.7132317, lng: -72.3063544, schcat: 'Elementary School', schdis: 'Norwich', townam: 'Norwich', value: false }, { name: 'Marlboro Elementary School', estsiz: '100', grades: 'PK-8', lat: 42.868698, lng: -72.719688, schcat: 'K-8', schdis: 'Marlboro', townam: 'Marlboro', value: false }, { name: 'Mettawee Community School USD No 47', estsiz: '200', grades: 'PK-6', lat: 43.3857682, lng: -73.2243815, schcat: 'Elementary School', schdis: 'Mettawee Community Sch UESD', townam: 'West Pawlet', value: false }, { name: 'Middlebury ID No 4 School', estsiz: '400', grades: 'K-6', lat: 44.0105946, lng: -73.1616527, schcat: 'Elementary School', schdis: 'Middlebury ID', townam: 'Middlebury', value: false }, { name: 'Middlebury Senior UHSD No 3', estsiz: '660', grades: '9-12', lat: 44.0065835, lng: -73.1630676, schcat: 'Senior High School', schdis: 'Middlebury UHSD', townam: 'Middlebury', value: false }, { name: 'Middlebury Union Middle School No 3', estsiz: '290', grades: '7-8', lat: 43.9982614, lng: -73.1524356, schcat: 'Middle School', schdis: 'Middlebury UHSD', townam: 'Middlebury', value: false }, { name: 'Middletown Springs Elementary School', estsiz: '80', grades: 'PK-6', lat: 43.4839636, lng: -73.1203383, schcat: 'Elementary School', schdis: 'Middletown Springs', townam: 'Middletown Spr', value: false }, { name: 'Mill River USD No 40', estsiz: '570', grades: '7-12', lat: 43.547028, lng: -72.97152, schcat: 'Junior-Senior High School', schdis: 'Mill River UHSD', townam: 'North Clarendon', value: false }, { name: 'Millers Run School USD No 37', estsiz: '150', grades: 'PK-8', lat: 44.6026961, lng: -72.1192335, schcat: 'K-8', schdis: 'Millers Run UESD', townam: 'Sheffield', value: false }, { name: 'Milton Elementary School', estsiz: '920', grades: 'PK-6', lat: 44.6324836, lng: -73.1098197, schcat: 'Elementary School', schdis: 'Milton', townam: 'Milton', value: false }, { name: 'Milton Middle School', estsiz: '260', grades: '7-8', lat: 44.6280816, lng: -73.1197457, schcat: 'Middle School', schdis: 'Milton', townam: 'Milton', value: false }, { name: 'Milton Senior High School', estsiz: '540', grades: '9-12', lat: 44.6280816, lng: -73.1197457, schcat: 'Senior High School', schdis: 'Milton', townam: 'Milton', value: false }, { name: 'Missisquoi Valley UHSD No 7', estsiz: '940', grades: '7-12', lat: 44.927863, lng: -73.1018239, schcat: 'Junior-Senior High School', schdis: 'Missisquoi Valley UHSD', townam: 'Swanton', value: false }, { name: 'Molly Stark School', estsiz: '390', grades: 'K-5', lat: 42.8992571, lng: -73.2017039, schcat: 'Elementary School', schdis: 'Bennington ID', townam: 'Bennington', value: false }, { name: 'Monkton Central School', estsiz: '170', grades: 'K-6', lat: 44.2441871, lng: -73.1389253, schcat: 'Elementary School', schdis: 'Monkton', townam: 'No Ferrisburg', value: false }, { name: 'Montgomery Center School', estsiz: '130', grades: 'PK-8', lat: 44.8864293, lng: -72.6162041, schcat: 'K-8', schdis: 'Montgomery', townam: 'Montgomery Ctr', value: false }, { name: 'Montpelier High School', estsiz: '310', grades: '9-12', lat: 44.2605339, lng: -72.5869944, schcat: 'Senior High School', schdis: 'Montpelier', townam: 'Montpelier', value: false }, { name: 'Monument School', estsiz: '150', grades: 'K-5', lat: 42.8850209, lng: -73.2106215, schcat: 'Elementary School', schdis: 'Bennington ID', townam: 'Bennington', value: false }, { name: 'Moretown Elementary School', estsiz: '120', grades: 'PK-6', lat: 44.247814, lng: -72.7630619, schcat: 'Elementary School', schdis: 'Moretown', townam: 'Moretown', value: false }, { name: 'Morristown Elementary Schools', estsiz: '300', grades: 'K-4', lat: 44.5636467, lng: -72.5855112, schcat: 'Elementary School', schdis: 'Morristown', townam: 'Morrisville', value: false }, { name: 'Mt Abraham UHSD No 28', estsiz: '780', grades: '7-12', lat: 44.1354759, lng: -73.0939654, schcat: 'Junior-Senior High School', schdis: 'Mt. Abraham UHSD', townam: 'Bristol', value: false }, { name: 'Mt Anthony Senior UHSD No 14', estsiz: '1000', grades: '9-12', lat: 42.8863217, lng: -73.1913331, schcat: 'Senior High School', schdis: 'Mt. Anthony UHSD', townam: 'Bennington', value: false }, { name: 'Mt Anthony Union Middle School', estsiz: '610', grades: '6-8', lat: 42.9054159, lng: -73.1877428, schcat: 'Middle School', schdis: 'Mt. Anthony UHSD', townam: 'Bennington', value: false }, { name: 'Mt Holly School', estsiz: '110', grades: 'PK-6', lat: 43.44585, lng: -72.823055, schcat: 'Elementary School', schdis: 'Mt. Holly', townam: 'Mount Holly', value: false }, { name: 'Mt Mansfield USD No 17', estsiz: '950', grades: '9-12', lat: 44.486184, lng: -72.962048, schcat: 'Senior High School', schdis: 'Mt. Mansfield USD', townam: 'Jericho', value: false }, { name: 'Neshobe School', estsiz: '410', grades: 'PK-6', lat: 43.8264649, lng: -73.0552279, schcat: 'Elementary School', schdis: 'Brandon', townam: 'Brandon', value: false }, { name: 'Newark School', estsiz: '50', grades: 'K-8', lat: 44.690121, lng: -71.950768, schcat: 'K-8', schdis: 'Newark', townam: 'Newark', value: false }, { name: 'Newbrook Joint Contract Elementary School', estsiz: '150', grades: 'PK-6', lat: 42.9599339, lng: -72.650055, schcat: 'Elementary School', schdis: 'Newbrook Joint Contract Elementary School', townam: 'Newfane', value: false }, { name: 'Newbury Elementary School', estsiz: '120', grades: 'K-6', lat: 44.0794494, lng: -72.0603798, schcat: 'Elementary School', schdis: 'Newbury', townam: 'Newbury', value: false }, { name: 'Newport City Elementary Schools', estsiz: '310', grades: 'K-6', lat: 44.9449812, lng: -72.1921709, schcat: 'Elementary School', schdis: 'Newport City', townam: 'Newport', value: false }, { name: 'Newport Town School', estsiz: '100', grades: 'K-6', lat: 44.9509976, lng: -72.3068892, schcat: 'Elementary School', schdis: 'Newport Town', townam: 'Newport Center', value: false }, { name: 'Newton Elementary School', estsiz: '140', grades: 'PK-8', lat: 43.8350684, lng: -72.3653719, schcat: 'K-8', schdis: 'Strafford', townam: 'South Strafford', value: false }, { name: 'North Country Junior UHSD No 22', estsiz: '900', grades: '9-12', lat: 44.9493054, lng: -72.1313134, schcat: 'Senior High School', schdis: 'North Country Jr UHSD', townam: 'Derby', value: false }, { name: 'North Country Senior UHSD No 22', estsiz: '290', grades: '7-8', lat: 44.946129, lng: -72.2035371, schcat: 'Middle School', schdis: 'North Country Sr UHSD', townam: 'Newport', value: false }, { name: 'North Hero Elementary School', estsiz: '60', grades: 'PK-6', lat: 44.8508342, lng: -73.2634981, schcat: 'Elementary School', schdis: 'North Hero', townam: 'North Hero', value: false }, { name: 'Northfield Elementary School', estsiz: '330', grades: 'PK-5', lat: 44.15455, lng: -72.662072, schcat: 'Elementary School', schdis: 'Northfield', townam: 'Northfield', value: false }, { name: 'Northfield Middle-High School', estsiz: '350', grades: '6-12', lat: 44.153568, lng: -72.660537, schcat: 'Junior-Senior High School', schdis: 'Northfield', townam: 'Northfield', value: false }, { name: 'Oak Grove School', estsiz: '140', grades: 'K-6', lat: 42.8401525, lng: -72.5579901, schcat: 'Elementary School', schdis: 'Brattleboro', townam: 'Brattleboro', value: false }, { name: 'Orange Center School', estsiz: '100', grades: 'K-8', lat: 44.1490229, lng: -72.4035558, schcat: 'K-8', schdis: 'Orange', townam: 'East Barre', value: false }, { name: 'Orchard School', estsiz: '380', grades: 'K-5', lat: 44.439761, lng: -73.207682, schcat: 'Elementary School', schdis: 'South Burlington', townam: 'So Burlington', value: false }, { name: 'Orleans Elementary School', estsiz: '120', grades: 'K-8', lat: 44.810055, lng: -72.196754, schcat: 'K-8', schdis: 'Orleans ID', townam: 'Orleans', value: false }, { name: 'Orwell Village School', estsiz: '130', grades: 'K-8', lat: 43.804552, lng: -73.299154, schcat: 'K-8', schdis: 'Orwell', townam: 'Orwell', value: false }, { name: 'Ottauquechee School', estsiz: '210', grades: 'PK-5', lat: 43.6494962, lng: -72.4168673, schcat: 'Elementary School', schdis: 'Hartford', townam: 'Quechee', value: false }, { name: 'Otter Valley UHSD No 8', estsiz: '580', grades: '7-12', lat: 43.7671716, lng: -73.0515465, schcat: 'Junior-Senior High School', schdis: 'Otter Valley UHSD', townam: 'Brandon', value: false }, { name: 'Oxbow UHSD No 30', estsiz: '430', grades: '7-12', lat: 44.0078701, lng: -72.1139269, schcat: 'Junior-Senior High School', schdis: 'Oxbow UHSD', townam: 'Bradford', value: false }, { name: 'Peacham Elementary School', estsiz: '40', grades: 'K-6', lat: 44.326018, lng: -72.16652, schcat: 'Elementary School', schdis: 'Peacham', townam: 'Peacham', value: false }, { name: 'Peoples Academy', estsiz: '300', grades: '9-12', lat: 44.5626651, lng: -72.590118, schcat: 'Senior High School', schdis: 'Morristown', townam: 'Morrisville', value: false }, { name: 'Peoples Academy Middle School', estsiz: '280', grades: '5-8', lat: 44.5626651, lng: -72.590118, schcat: 'Middle School', schdis: 'Morristown', townam: 'Morrisville', value: false }, { name: 'Porters Point School', estsiz: '250', grades: 'K-2', lat: 44.5412597, lng: -73.2553252, schcat: 'Elementary School', schdis: 'Colchester', townam: 'Colchester', value: false }, { name: 'Poultney Elementary School', estsiz: '210', grades: 'PK-6', lat: 43.524576, lng: -73.237674, schcat: 'Elementary School', schdis: 'Poultney', townam: 'Poultney', value: false }, { name: 'Poultney High School', estsiz: '240', grades: '7-12', lat: 43.5165455, lng: -73.2294684, schcat: 'Junior-Senior High School', schdis: 'Poultney', townam: 'Poultney', value: false }, { name: 'Pownal Elementary School', estsiz: '270', grades: 'K-6', lat: 42.8008263, lng: -73.2179873, schcat: 'Elementary School', schdis: 'Pownal', townam: 'Pownal', value: false }, { name: 'Proctor Elementary School', estsiz: '180', grades: 'PK-6', lat: 43.6618191, lng: -73.038619, schcat: 'Elementary School', schdis: 'Proctor', townam: 'Proctor', value: false }, { name: 'Proctor Junior-Senior High School', estsiz: '160', grades: '7-12', lat: 43.6550274, lng: -73.0291312, schcat: 'Junior-Senior High School', schdis: 'Proctor', townam: 'Proctor', value: false }, { name: 'Putney Central School', estsiz: '190', grades: 'K-8', lat: 42.9858892, lng: -72.5284672, schcat: 'K-8', schdis: 'Putney', townam: 'Putney', value: false }, { name: 'Randolph Elementary School', estsiz: '300', grades: 'K-6', lat: 43.9338797, lng: -72.6604606, schcat: 'Elementary School', schdis: 'Randolph', townam: 'Randolph', value: false }, { name: 'Randolph UHSD No 2', estsiz: '460', grades: '7-12', lat: 43.931024, lng: -72.659843, schcat: 'Junior-Senior High School', schdis: 'Randolph UHSD', townam: 'Randolph', value: false }, { name: 'Reading Elementary School', estsiz: '40', grades: 'K-6', lat: 43.453125, lng: -72.536659, schcat: 'Elementary School', schdis: 'Reading', townam: 'Reading', value: false }, { name: 'Readsboro Elementary School', estsiz: '80', grades: 'PK-8', lat: 42.771786, lng: -72.940575, schcat: 'K-8', schdis: 'Readsboro', townam: 'Readsboro', value: false }, { name: 'Richford Elementary School', estsiz: '250', grades: 'PK-6', lat: 44.9859909, lng: -72.6802834, schcat: 'Elementary School', schdis: 'Richford', townam: 'Richford', value: false }, { name: 'Richford Junior-Senior High School', estsiz: '240', grades: '7-12', lat: 44.995025, lng: -72.670086, schcat: 'Junior-Senior High School', schdis: 'Richford', townam: 'Richford', value: false }, { name: 'Richmond Elementary School', estsiz: '290', grades: 'PK-4', lat: 44.4126297, lng: -72.9939169, schcat: 'Elementary School', schdis: 'Richmond', townam: 'Richmond', value: false }, { name: 'Rick Marcotte Central School', estsiz: '350', grades: 'K-5', lat: 44.467307, lng: -73.1769103, schcat: 'Elementary School', schdis: 'South Burlington', townam: 'So Burlington', value: false }, { name: 'Ripton Elementary School', estsiz: '50', grades: 'PK-6', lat: 43.9852144, lng: -73.0382352, schcat: 'Elementary School', schdis: 'Ripton', townam: 'Ripton', value: false }, { name: 'Rivendell Academy', estsiz: '230', grades: '7-12', lat: 43.899294, lng: -72.1376509, schcat: 'Junior-Senior High School', schdis: 'Rivendell Interstate USD', townam: 'Orford,  NH', value: false }, { name: 'Riverside Middle School', estsiz: '310', grades: '6-8', lat: 43.3045496, lng: -72.4971886, schcat: 'Middle School', schdis: 'Springfield', townam: 'Springfield', value: false }, { name: 'Robinson School', estsiz: '170', grades: 'K-6', lat: 44.223866, lng: -73.057693, schcat: 'Elementary School', schdis: 'Starksboro', townam: 'Starksboro', value: false }, { name: 'Rochester School', estsiz: '160', grades: 'K-12', lat: 43.8717466, lng: -72.8091872, schcat: 'K-12', schdis: 'Rochester', townam: 'Rochester', value: false }, { name: 'Roxbury Village School', estsiz: '40', grades: 'PK-6', lat: 44.092411, lng: -72.733185, schcat: 'Elementary School', schdis: 'Roxbury', townam: 'Roxbury', value: false }, { name: 'Rumney School', estsiz: '180', grades: 'PK-6', lat: 44.351158, lng: -72.602592, schcat: 'Elementary School', schdis: 'Middlesex', townam: 'Middlesex', value: false }, { name: 'Rutland High School', estsiz: '970', grades: '9-12', lat: 43.6174987, lng: -72.9546905, schcat: 'Senior High School', schdis: 'Rutland City', townam: 'Rutland', value: false }, { name: 'Rutland Intermediate School', estsiz: '600', grades: '3-6', lat: 43.6131277, lng: -72.9799112, schcat: 'Elementary School', schdis: 'Rutland City', townam: 'Rutland', value: false }, { name: 'Rutland Middle School', estsiz: '310', grades: '7-8', lat: 43.6129104, lng: -72.9809901, schcat: 'Middle School', schdis: 'Rutland City', townam: 'Rutland', value: false }, { name: 'Rutland Town Elementary School', estsiz: '350', grades: 'PK-8', lat: 43.6386836, lng: -72.9634995, schcat: 'K-8', schdis: 'Rutland Town', townam: 'Rutland Town', value: false }, { name: 'Salisbury Community School', estsiz: '90', grades: 'PK-6', lat: 43.919567, lng: -73.1188721, schcat: 'Elementary School', schdis: 'Salisbury', townam: 'Salisbury', value: false }, { name: 'Samuel Morey Elementary School', estsiz: '160', grades: 'K-6', lat: 43.9079275, lng: -72.1461984, schcat: 'Elementary School', schdis: 'Rivendell Interstate USD', townam: 'Fairlee', value: false }, { name: 'Saxtons River Elementary School', estsiz: '110', grades: 'K-5', lat: 43.140396, lng: -72.509491, schcat: 'Elementary School', schdis: 'Rockingham', townam: 'Saxtons River', value: false }, { name: 'Shaftsbury Elementary School', estsiz: '220', grades: 'K-6', lat: 42.945183, lng: -73.207977, schcat: 'Elementary School', schdis: 'Shaftsbury', townam: 'Shaftsbury', value: false }, { name: 'Sharon Elementary School', estsiz: '110', grades: 'PK-6', lat: 43.7849689, lng: -72.456039, schcat: 'Elementary School', schdis: 'Sharon', townam: 'Sharon', value: false }, { name: 'Shelburne Community School', estsiz: '750', grades: 'PK-8', lat: 44.3807539, lng: -73.2353556, schcat: 'K-8', schdis: 'Shelburne', townam: 'Shelburne', value: false }, { name: 'Sheldon Elementary School', estsiz: '240', grades: 'K-8', lat: 44.900993, lng: -72.969269, schcat: 'K-8', schdis: 'Sheldon', townam: 'Sheldon', value: false }, { name: 'Shoreham Elementary School', estsiz: '100', grades: 'PK-6', lat: 43.891708, lng: -73.316238, schcat: 'Elementary School', schdis: 'Shoreham', townam: 'Shoreham', value: false }, { name: 'Shrewsbury Mountain School', estsiz: '60', grades: 'PK-6', lat: 43.5255129, lng: -72.830734, schcat: 'Elementary School', schdis: 'Shrewsbury', townam: 'Cuttingsville', value: false }, { name: 'Smilie Memorial School', estsiz: '90', grades: 'PK-4', lat: 44.373783, lng: -72.876854, schcat: 'Elementary School', schdis: 'Bolton', townam: 'Bolton', value: false }, { name: 'South Burlington High School', estsiz: '890', grades: '9-12', lat: 44.454924, lng: -73.177891, schcat: 'Senior High School', schdis: 'South Burlington', townam: 'So Burlington', value: false }, { name: 'South Royalton Elementary-High School', estsiz: '370', grades: 'PK-12', lat: 43.819316, lng: -72.517403, schcat: 'K-12', schdis: 'Royalton', townam: 'South Royalton', value: false }, { name: 'Spaulding HSUD No 41', estsiz: '750', grades: '9-12', lat: 44.1894129, lng: -72.4935438, schcat: 'Senior High School', schdis: 'Spaulding UHSD', townam: 'Barre', value: false }, { name: 'Springfield High School', estsiz: '460', grades: '9-12', lat: 43.2811126, lng: -72.4781557, schcat: 'Senior High School', schdis: 'Springfield', townam: 'Springfield', value: false }, { name: 'St Albans City School', estsiz: '700', grades: 'K-8', lat: 44.8203212, lng: -73.0918317, schcat: 'K-8', schdis: 'St. Albans City', townam: 'St Albans', value: false }, { name: 'St Albans Town Education Center', estsiz: '720', grades: 'K-8', lat: 44.8016334, lng: -73.0860045, schcat: 'K-8', schdis: 'St. Albans Town', townam: 'St Albans', value: false }, { name: 'St Johnsbury Schools', estsiz: '660', grades: 'PK-8', lat: 44.4162817, lng: -72.0244301, schcat: 'K-8', schdis: 'St. Johnsbury', townam: 'St Johnsbury', value: false }, { name: 'Stamford Elementary School', estsiz: '80', grades: 'K-8', lat: 42.7549141, lng: -73.0672467, schcat: 'K-8', schdis: 'Stamford', townam: 'Stamford', value: false }, { name: 'Stockbridge Central School', estsiz: '60', grades: 'PK-6', lat: 43.7642684, lng: -72.7180882, schcat: 'Elementary School', schdis: 'Stockbridge', townam: 'Stockbridge', value: false }, { name: 'Stowe Elementary School', estsiz: '280', grades: 'K-5', lat: 44.4630988, lng: -72.684254, schcat: 'Elementary School', schdis: 'Stowe', townam: 'Stowe', value: false }, { name: 'Stowe Middle-High School', estsiz: '420', grades: '6-12', lat: 44.46533, lng: -72.726585, schcat: 'Junior-Senior High School', schdis: 'Stowe', townam: 'Stowe', value: false }, { name: 'Sudbury Country School', estsiz: '30', grades: 'K-6', lat: 43.822178, lng: -73.185951, schcat: 'Elementary School', schdis: 'Sudbury', townam: 'Brandon', value: false }, { name: 'Summit Street School', estsiz: '280', grades: 'PK-3', lat: 44.493408, lng: -73.11366, schcat: 'Elementary School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false }, { name: 'Sunderland Elementary School', estsiz: '70', grades: 'K-6', lat: 43.0846207, lng: -73.1277208, schcat: 'Elementary School', schdis: 'Sunderland', townam: 'Sunderland', value: false }, { name: 'Sustainability Academy At Lawrence Barnes', estsiz: '210', grades: 'K-5', lat: 44.484143, lng: -73.2167958, schcat: 'Elementary School', schdis: 'Burlington', townam: 'Burlington', value: false }, { name: 'Sutton School', estsiz: '100', grades: 'K-8', lat: 44.6335849, lng: -72.0278777, schcat: 'K-8', schdis: 'Sutton', townam: 'Sutton', value: false }, { name: 'Swanton Schools', estsiz: '590', grades: 'PK-6', lat: 44.9153692, lng: -73.1130187, schcat: 'Elementary School', schdis: 'Swanton', townam: 'Swanton', value: false }, { name: 'Thatcher Brook Primary USD No 45', estsiz: '430', grades: 'PK-4', lat: 44.339128, lng: -72.753139, schcat: 'Elementary School', schdis: 'Duxbury-Waterbury UESD', townam: 'Waterbury', value: false }, { name: 'Thetford Elementary School', estsiz: '200', grades: 'K-6', lat: 43.8195834, lng: -72.2318682, schcat: 'Elementary School', schdis: 'Thetford', townam: 'Thetford', value: false }, { name: 'Thomas Fleming School', estsiz: '220', grades: '4-5', lat: 44.49478, lng: -73.113504, schcat: 'Elementary School', schdis: 'Essex Junction ID', townam: 'Essex Junction', value: false }, { name: 'Tinmouth Elementary School', estsiz: '60', grades: 'PK-6', lat: 43.4494929, lng: -73.0510709, schcat: 'Elementary School', schdis: 'Tinmouth', townam: 'Tinmouth', value: false }, { name: 'Townshend Village School', estsiz: '90', grades: 'PK-6', lat: 43.0466625, lng: -72.6695342, schcat: 'Elementary School', schdis: 'Townshend', townam: 'Townshend', value: false }, { name: 'Troy School', estsiz: '160', grades: 'K-8', lat: 44.995964, lng: -72.405022, schcat: 'K-8', schdis: 'Troy', townam: 'North Troy', value: false }, { name: 'Tunbridge Central School', estsiz: '120', grades: 'PK-8', lat: 43.916965, lng: -72.474808, schcat: 'K-8', schdis: 'Tunbridge', townam: 'Tunbridge', value: false }, { name: 'Twin Valley Joint Contract High School', estsiz: '160', grades: '9-12', lat: 42.7879692, lng: -72.8401605, schcat: 'Senior High School', schdis: 'Twin Valley Joint Contract High School', townam: 'Whitingham', value: false }, { name: 'Twinfield USD No 33', estsiz: '430', grades: 'PK-12', lat: 44.2979795, lng: -72.3950348, schcat: 'K-12', schdis: 'Twinfield USD', townam: 'Plainfield', value: false }, { name: 'U32 High School UHSD No 32', estsiz: '800', grades: '7-12', lat: 44.244409, lng: -72.526634, schcat: 'Junior-Senior High School', schdis: 'U-32 UHSD', townam: 'Montpelier', value: false }, { name: 'Underhill Central School', estsiz: '180', grades: 'PK-4', lat: 44.5089403, lng: -72.8951245, schcat: 'Elementary School', schdis: 'Underhill Town', townam: 'Underhill Ctr', value: false }, { name: 'Underhill ID School', estsiz: '110', grades: 'K-4', lat: 44.5179951, lng: -72.9456162, schcat: 'Elementary School', schdis: 'Underhill ID', townam: 'Jericho', value: false }, { name: 'Union Elementary School', estsiz: '430', grades: 'K-5', lat: 44.2596714, lng: -72.5711386, schcat: 'Elementary School', schdis: 'Montpelier', townam: 'Montpelier', value: false }, { name: 'Union Memorial School', estsiz: '220', grades: 'K-2', lat: 44.5490086, lng: -73.1601394, schcat: 'Elementary School', schdis: 'Colchester', townam: 'Colchester', value: false }, { name: 'Union Street School', estsiz: '290', grades: '3-5', lat: 43.2955001, lng: -72.4880611, schcat: 'Elementary School', schdis: 'Springfield', townam: 'Springfield', value: false }, { name: 'Vergennes UESD No 44', estsiz: '270', grades: 'K-6', lat: 44.167163, lng: -73.248079, schcat: 'Elementary School', schdis: 'Vergennes UESD', townam: 'Vergennes', value: false }, { name: 'Vergennes UHSD No 5', estsiz: '580', grades: '7-12', lat: 44.1699484, lng: -73.2431089, schcat: 'Junior-Senior High School', schdis: 'Vergennes UHSD', townam: 'Vergennes', value: false }, { name: 'Vernon Elementary School', estsiz: '160', grades: 'K-6', lat: 42.776263, lng: -72.518569, schcat: 'Elementary School', schdis: 'Vernon', townam: 'Vernon', value: false }, { name: 'Waits River Valley USD No 36', estsiz: '210', grades: 'K-8', lat: 44.0797483, lng: -72.261316, schcat: 'K-8', schdis: 'Waits River Valley UESD', townam: 'East Corinth', value: false }, { name: 'Waitsfield Elementary School', estsiz: '150', grades: 'PK-6', lat: 44.1944527, lng: -72.8193328, schcat: 'Elementary School', schdis: 'Waitsfield', townam: 'Waitsfield', value: false }, { name: 'Walden School', estsiz: '100', grades: 'K-8', lat: 44.452801, lng: -72.219322, schcat: 'K-8', schdis: 'Walden', townam: 'West Danville', value: false }, { name: 'Wallingford Village School', estsiz: '150', grades: 'PK-6', lat: 43.470547, lng: -72.9751579, schcat: 'Elementary School', schdis: 'Wallingford', townam: 'Wallingford', value: false }, { name: 'Wardsboro Central School', estsiz: '70', grades: 'PK-6', lat: 43.0479574, lng: -72.7872992, schcat: 'Elementary School', schdis: 'Wardsboro', townam: 'Wardsboro', value: false }, { name: 'Warren Elementary School', estsiz: '180', grades: 'PK-6', lat: 44.1162276, lng: -72.851123, schcat: 'Elementary School', schdis: 'Warren', townam: 'Warren', value: false }, { name: 'Washington Village School', estsiz: '90', grades: 'PK-8', lat: 44.1078548, lng: -72.4315601, schcat: 'K-8', schdis: 'Washington', townam: 'Washington', value: false }, { name: 'Waterford Elementary School', estsiz: '180', grades: 'PK-8', lat: 44.4025729, lng: -71.927544, schcat: 'K-8', schdis: 'Waterford', townam: 'St Johnsbury', value: false }, { name: 'Waterville Elementary School', estsiz: '90', grades: 'PK-6', lat: 44.726855, lng: -72.74841, schcat: 'Elementary School', schdis: 'Waterville', townam: 'Waterville', value: false }, { name: 'Weathersfield School', estsiz: '220', grades: 'K-8', lat: 43.4112673, lng: -72.4097514, schcat: 'K-8', schdis: 'Weathersfield', townam: 'Ascutney', value: false }, { name: 'Wells Village School', estsiz: '80', grades: 'PK-6', lat: 43.417881, lng: -73.206711, schcat: 'Elementary School', schdis: 'Wells', townam: 'Wells', value: false }, { name: 'West Rutland School', estsiz: '360', grades: 'PK-12', lat: 43.5954663, lng: -73.0515556, schcat: 'K-12', schdis: 'West Rutland', townam: 'West Rutland', value: false }, { name: 'Westford Elementary School', estsiz: '220', grades: 'PK-8', lat: 44.602952, lng: -73.0189539, schcat: 'K-8', schdis: 'Westford', townam: 'Westford', value: false }, { name: 'Westminster Schools', estsiz: '230', grades: 'PK-6', lat: 43.070309, lng: -72.463478, schcat: 'Elementary School', schdis: 'Westminster', townam: 'Westminster', value: false }, { name: 'Westshire School', estsiz: '90', grades: 'K-6', lat: 43.9065664, lng: -72.2630234, schcat: 'Elementary School', schdis: 'Rivendell Interstate USD', townam: 'West Fairlee', value: false }, { name: 'Weybridge Elementary School', estsiz: '60', grades: 'K-6', lat: 44.04174, lng: -73.212502, schcat: 'Elementary School', schdis: 'Weybridge', townam: 'Middlebury', value: false }, { name: 'Whitcomb Junior-Senior High School', estsiz: '130', grades: '7-12', lat: 43.833232, lng: -72.6435001, schcat: 'Junior-Senior High School', schdis: 'Bethel', townam: 'Bethel', value: false }, { name: 'White River School', estsiz: '240', grades: 'PK-5', lat: 43.6533157, lng: -72.3181378, schcat: 'Elementary School', schdis: 'Hartford', townam: 'White River Jct', value: false }, { name: 'Whiting Village School', estsiz: '50', grades: 'PK-6', lat: 43.858121, lng: -73.2015179, schcat: 'Elementary School', schdis: 'Whiting', townam: 'Whiting', value: false }, { name: 'Williamstown Elementary School', estsiz: '240', grades: 'PK-5', lat: 44.123554, lng: -72.545708, schcat: 'Elementary School', schdis: 'Williamstown', townam: 'Williamstown', value: false }, { name: 'Williamstown Middle-High School', estsiz: '320', grades: '6-12', lat: 44.1262355, lng: -72.546661, schcat: 'Junior-Senior High School', schdis: 'Williamstown', townam: 'Williamstown', value: false }, { name: 'Williston Schools', estsiz: '1', grades: 'PK-8', lat: 44.447771, lng: -73.096256, schcat: 'K-8', schdis: 'Williston', townam: 'Williston', value: false }, { name: 'Windham Elementary School', estsiz: '20', grades: 'PK-6', lat: 43.1658297, lng: -72.7253414, schcat: 'Elementary School', schdis: 'Windham', townam: 'West Townshend', value: false }, { name: 'Windsor High School', estsiz: '240', grades: '9-12', lat: 43.479936, lng: -72.394549, schcat: 'Senior High School', schdis: 'Windsor', townam: 'Windsor', value: false }, { name: 'Windsor State Street School', estsiz: '310', grades: 'K-8', lat: 43.48093, lng: -72.394295, schcat: 'K-8', schdis: 'Windsor', townam: 'Windsor', value: false }, { name: 'Winooski High School', estsiz: '270', grades: '9-12', lat: 44.501157, lng: -73.18101, schcat: 'Senior High School', schdis: 'Winooski ID', townam: 'Winooski', value: false }, { name: 'Winooski Middle School', estsiz: '', grades: '', lat: 44.501157, lng: -73.18101, schcat: 'Middle School', schdis: 'Winooski ID', townam: 'Winooski', value: false }, { name: 'Wolcott Elementary School', estsiz: '120', grades: 'K-6', lat: 44.538219, lng: -72.453148, schcat: 'Elementary School', schdis: 'Wolcott', townam: 'Wolcott', value: false }, { name: 'Woodbury Elementary School', estsiz: '40', grades: 'K-6', lat: 44.440035, lng: -72.416224, schcat: 'Elementary School', schdis: 'Woodbury', townam: 'Woodbury', value: false }, { name: 'Woodford Hollow School', estsiz: '30', grades: 'K-6', lat: 42.8939304, lng: -73.136866, schcat: 'Elementary School', schdis: 'Woodford', townam: 'Bennington', value: false }, { name: 'Woodstock Elementary School', estsiz: '180', grades: 'K-6', lat: 43.622024, lng: -72.519711, schcat: 'Elementary School', schdis: 'Woodstock', townam: 'Woodstock', value: false }, { name: 'Woodstock Senior UHSD No 4', estsiz: '180', grades: '9-12', lat: 43.613313, lng: -72.54568, schcat: 'Senior High School', schdis: 'Woodstock UHSD', townam: 'Woodstock', value: false }, { name: 'Woodstock Union Middle School', estsiz: '180', grades: '7-8', lat: 43.613056, lng: -72.545857, schcat: 'Middle School', schdis: 'Woodstock UHSD', townam: 'Woodstock', value: false }],
    verLat: [],
    deSiTe: [{
      name: '', //     0
      estsiz: '', //   1
      grades: '', //   2
      lat: 0, //       3
      lng: 0, //       4
      schcat: '', //   5
      schdis: '', //   6
      townam: '', //   7
      creatorId: '',
      value: false
    }],
    estsiz: '',
    grades: '',
    schcat: '',
    schdis: '',
    townam: '',
    // removeUpdate: false,
    pixel: 8,
    schoolName: 'Mt Holly School',
    lat: 43.44585,
    lng: -72.823055,
    latlng: [43.44585, -72.823055],
    lnglat: [-72.823055, 43.44585],
    zoom: 12,
    types: ['car', 'directions_car', 'bike', 'directions_bike', 'walk', 'directions_walk'],
    typeIcon: 'directions_car',
    type: 'car',
    secondsSingle: [],
    seconds: [900, 0, 0],
    minutes: ['', '', 15, '', '', '', '', '', '', '', '', ''],
    fancyMinutes: [10, 20, 30],
    minuteA: '15 minutes',
    minuteB: '0 minutes',
    minuteC: '0 minutes',
    colorA: '#96c79d',
    colorB: '#e2ba8b',
    colorC: '#cc8f91',
    theColors: { five: '#7fa995', ten: '#96c79d', fifteen: '#b7ce98', twenty: '#e2ba8b', twentyfive: '#dfa38d', thirty: '#cc8f91', thirtyfive: '#7f7f7f', info: '#d3d3d3', deco: '#3388ff' },
    secondA: 900,
    secondB: 0,
    secondC: 0,
    singleTimes: [{ minsb: 5, name: '5 min', secs: [300, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { minsb: 10, name: '10 min', secs: [0, 600, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { minsb: 15, name: '15 min', secs: [0, 0, 900, 0, 0, 0, 0, 0, 0, 0, 0, 0] }, { minsb: 20, name: '20 min', secs: [0, 0, 0, 1200, 0, 0, 0, 0, 0, 0, 0, 0] }, { minsb: 25, name: '25 min', secs: [0, 0, 0, 0, 1500, 0, 0, 0, 0, 0, 0, 0] }, { minsb: 30, name: '30 min', secs: [0, 0, 0, 0, 0, 1800, 0, 0, 0, 0, 0, 0] }, { minsb: 35, name: '35 min', secs: [0, 0, 0, 0, 0, 0, 2100, 0, 0, 0, 0, 0] }, { minsb: 40, name: '40 min', secs: [0, 0, 0, 0, 0, 0, 0, 2400, 0, 0, 0, 0] }, { minsb: 45, name: '45 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 2700, 0, 0, 0] }, { minsb: 50, name: '50 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 3000, 0, 0] }, { minsb: 55, name: '55 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3300, 0] }, { minsb: 60, name: '60 min', secs: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3600] }],
    travelTimes: [{ minsb: [5, 10, 15], name: '5 min, 10 min, 15 min', secs: [300, 600, 900] }, { minsb: [10, 15, 20], name: '10 min, 15 min, 20 min', secs: [600, 900, 1200] }, { minsb: [15, 20, 25], name: '15 min, 20 min, 25 min', secs: [900, 1200, 1500] }, { minsb: [20, 25, 30], name: '20 min, 25 min, 30 min', secs: [1200, 1500, 1800] }, { minsb: [25, 30, 35], name: '25 min, 30 min, 35 min', secs: [1500, 1800, 2100] }, { minsb: [30, 35, 40], name: '30 min, 35 min, 40 min', secs: [1800, 2100, 2400] }, { minsb: [5, 15, 25], name: '5 min, 15 min, 25 min', secs: [300, 900, 1500] }, { minsb: [10, 20, 30], name: '10 min, 20 min, 30 min', secs: [600, 1200, 1800] }, { minsb: [15, 25, 35], name: '15 min, 25 min, 35 min', secs: [900, 1500, 2100] }, { minsb: [20, 30, 40], name: '20 min, 30 min, 40 min', secs: [1200, 1800, 2400] }, { minsb: [25, 35, 45], name: '25 min, 35 min, 45 min', secs: [1500, 2100, 2700] }, { minsb: [30, 40, 50], name: '30 min, 40 min, 50 min', secs: [1800, 2400, 3000] }, { minsb: [5, 20, 35], name: '5 min, 20 min, 35 min', secs: [300, 1200, 2100] }, { minsb: [10, 25, 40], name: '10 min, 25 min, 40 min', secs: [600, 1500, 2400] }, { minsb: [15, 30, 45], name: '15 min, 30 min, 45 min', secs: [900, 1800, 2700] }, { minsb: [20, 35, 50], name: '20 min, 35 min, 50 min', secs: [1200, 2100, 3000] }, { minsb: [25, 40, 55], name: '25 min, 40 min, 55 min', secs: [1500, 2400, 3300] }, { minsb: [30, 45, 60], name: '30 min, 45 min, 60 min', secs: [1800, 2700, 3600] }, { minsb: [5, 25, 45], name: '5 min, 25 min, 45 min', secs: [300, 1500, 2700] }, { minsb: [10, 30, 50], name: '10 min, 30 min, 50 min', secs: [600, 1800, 3000] }, { minsb: [15, 35, 55], name: '15 min, 35 min, 55 min', secs: [900, 2100, 3300] }, { minsb: [20, 40, 60], name: '20 min, 40 min, 60 min', secs: [1200, 2400, 3600] }],
    secMin: [300, 5, 600, 10, 900, 15, 1200, 20, 1500, 25, 1800, 30, 2100, 35, 2400, 40, 2700, 45, 3000, 50, 3300, 55, 3600, 60],
    baseOption: 'watercolor',
    stamenBaseOptions: ['toner', 'toner-hybrid', 'toner-labels', 'toner-lines', 'toner-background', 'toner-lite', 'terrain', 'terrain-background', 'terrain-lines', 'terrain-labels', 'terrain-classic', 'watercolor', 'trees-cabs-crime'],
    idFrom: 'mb3'
    // baseOptionStyle: 'mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'
  },
  getters: {
    //
    // ------------------------------- CUTOUT LOGIC
    loadedCutout: function loadedCutout(state) {
      return function (cutoutId) {
        return state.loadedCutouts.find(function (cutout) {
          return cutout.id === cutoutId;
        });
      };
    },
    loadedCutouts: function loadedCutouts(state) {
      return state.loadedCutouts.sort(function (cutoutA, cutoutB) {
        return cutoutA.id > cutoutB.id;
      });
    },

    //
    // ------------------------------- APP LOGIC
    user: function user(state) {
      return state.user;
    },
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },

    //
    // ------------------------------- INFO AND PICKERS
    schoolName: function schoolName(state) {
      return state.schoolName;
    },
    pixel: function pixel(state) {
      return state.pixel;
    },
    lat: function lat(state) {
      return state.deSiTe.lat;
    },
    lng: function lng(state) {
      return state.deSiTe.lng;
    },
    latlng: function latlng(state) {
      return state.latlng;
    },
    lnglat: function lnglat(state) {
      return state.lnglat;
    },
    zoom: function zoom(state) {
      return state.zoom;
    },
    type: function type(state) {
      return state.type;
    },
    inverse: function inverse(state) {
      return state.inverse;
    },
    cluster: function cluster(state) {
      return state.cluster;
    },

    //
    // -------------------------------  POI DATA TABLE
    verPois: function verPois(state) {
      return state.verPois;
    },

    // -------------------------------  SCHOOL DATA TABLE
    verLat: function verLat(state) {
      return state.verLat;
    },
    verSch: function verSch(state) {
      return state.verSch;
    },
    deSiTe: function deSiTe(state) {
      return state.deSiTe;
    },
    estsiz: function estsiz(state) {
      return state.estsiz;
    },
    grades: function grades(state) {
      return state.grades;
    },
    schcat: function schcat(state) {
      return state.schcat;
    },
    schdis: function schdis(state) {
      return state.schdis;
    },
    townam: function townam(state) {
      return state.townam;
    },

    //
    // -------------------------------  TIME LOGIC
    travelTimes: function travelTimes(state) {
      return state.travelTimes;
    },
    singleTimes: function singleTimes(state) {
      return state.singleTimes;
    },
    seconds: function seconds(state) {
      return state.seconds;
    },
    minutes: function minutes(state) {
      return state.minutes;
    },
    secMin: function secMin(state) {
      return state.secMin;
    },

    //
    // -------------------------------  FANCY DOM ELEMENTS
    allTheColors: function allTheColors(state) {
      return state.theColors;
    },
    fancyMinutes: function fancyMinutes(state) {
      return state.fancyMinutes;
    },
    fancyMinuteZero: function fancyMinuteZero(state) {
      return state.fancyMinutes[0];
    },
    fancyMinuteOne: function fancyMinuteOne(state) {
      return state.fancyMinutes[1];
    },
    fancyMinuteTwo: function fancyMinuteTwo(state) {
      return state.fancyMinutes[2];
    },
    colorA: function colorA(state) {
      return state.colorA;
    },
    colorB: function colorB(state) {
      return state.colorB;
    },
    colorC: function colorC(state) {
      return state.colorC;
    },
    minuteA: function minuteA(state) {
      return state.minuteA;
    },
    minuteB: function minuteB(state) {
      return state.minuteB;
    },
    minuteC: function minuteC(state) {
      return state.minuteC;
    },
    typeIcon: function typeIcon(state) {
      return state.typeIcon;
    },
    baseOption: function baseOption(state) {
      return state.baseOption;
    },
    baseOptionStyle: function baseOptionStyle(state) {
      return state.baseOptionStyle;
    },
    stamenBaseOptions: function stamenBaseOptions(state) {
      return state.stamenBaseOptions;
    },
    knowIdFrom: function knowIdFrom(state) {
      return state.idFrom;
    }
    /*  ------------------------------- CHUFF
    punchlist (state) {
      return state.punchlist
    },
    mapping (state) {
      return state.mapping
    }
    */

  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },

    /*
    setMapping (state, payload) {
      state.mapping = payload
    },
    */
    setSchoolName: function setSchoolName(state, payload) {
      state.schoolName = payload;
    },
    registerUserForCutout: function registerUserForCutout(state, payload) {
      var id = payload.id;
      if (state.user.registeredCutouts.findIndex(function (cutout) {
        return cutout.id === id;
      }) >= 0) {
        return;
      }
      state.user.registeredCutouts.push(id);
      state.user.fbKeys[id] = payload.fbKey;
    },
    unregisterUserFromCutout: function unregisterUserFromCutout(state, payload) {
      var registeredCutouts = state.user.registeredCutouts;
      registeredCutouts.splice(registeredCutouts.findIndex(function (cutout) {
        return cutout.id === payload;
      }), 1);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default()(state.user.fbKeys, payload);
    },
    setLoadedCutouts: function setLoadedCutouts(state, payload) {
      state.loadedCutouts = payload;
    },
    createCutout: function createCutout(state, payload) {
      state.loadedCutouts.push(payload);
    },
    updateCutout: function updateCutout(state, payload) {
      var cutout = state.loadedCutouts.find(function (cutout) {
        return cutout.id === payload.id;
      });
      if (payload.title) {
        cutout.title = payload.title;
      }
      if (payload.description) {
        cutout.description = payload.description;
      }
      if (payload.date) {
        cutout.date = payload.date;
      }
    },
    createIsochron: function createIsochron(state, payload) {
      state.deSiTe = payload;
    },
    setLat: function setLat(state, payload) {
      state.lat = payload;
      state.latlng[0] = payload;
      state.lnglat[1] = payload;
    },
    setLng: function setLng(state, payload) {
      state.lng = payload;
      state.latlng[1] = payload;
      state.lnglat[0] = payload;
    },
    setPixel: function setPixel(state, payload) {
      state.pixel = payload;
    },
    setMins: function setMins(state, payload) {
      state.minutes = payload;
    },
    setFancyMins: function setFancyMins(state, payload) {
      state.fancyMinutes = payload;
    },
    setSecs: function setSecs(state, payload) {
      state.seconds = payload;
    },
    setTwoTone: function setTwoTone(state, payload) {
      state.inverse = payload;
    },
    setColorA: function setColorA(state, payload) {
      state.colorA = payload;
    },
    setColorB: function setColorB(state, payload) {
      state.colorB = payload;
    },
    setColorC: function setColorC(state, payload) {
      state.colorC = payload;
    },
    setMinuteA: function setMinuteA(state, payload) {
      state.minuteA = payload;
    },
    setMinuteB: function setMinuteB(state, payload) {
      state.minuteB = payload;
    },
    setMinuteC: function setMinuteC(state, payload) {
      state.minuteC = payload;
    },
    setTypeIcon: function setTypeIcon(state, payload) {
      state.typeIcon = payload;
    },
    setType: function setType(state, payload) {
      state.type = payload;
    },
    setBase: function setBase(state, payload) {
      state.baseOption = payload;
    },
    setBaseStyle: function setBaseStyle(state, payload) {
      state.baseOptionStyle = payload;
    },
    setIdFrom: function setIdFrom(state, payload) {
      state.idFrom = payload;
    }
  },
  actions: {
    signUserUp: function signUserUp(_ref, payload) {
      var commit = _ref.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_4_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          registeredCutouts: [],
          fbKeys: {}
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_4_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          registeredCutouts: [],
          fbKeys: {}
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setUser', {
        id: payload.uid,
        registeredCutouts: [],
        fbKeys: {}
      });
    },
    logout: function logout(_ref4) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_4_firebase__["auth"]().signOut();
      commit('setUser', null);
    },
    pickPoi: function pickPoi(_ref5, payload) {
      var commit = _ref5.commit;

      var nps = {
        name: payload.name,
        lat: payload.lat,
        lng: payload.lng,
        townam: payload.town
        // creatorId: getters.user.id
      };
      var nsm = nps.name;
      var nlat = nps.lat;
      var nlng = nps.lng;
      commit('createIsochron', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nps));
      commit('setSchoolName', nsm);
      commit('setLat', nlat);
      commit('setLng', nlng);
    },
    pickSchool: function pickSchool(_ref6, payload) {
      var commit = _ref6.commit;

      var nps = {
        name: payload.name,
        estsiz: payload.estsiz,
        grades: payload.grades,
        lat: payload.lat,
        lng: payload.lng,
        schcat: payload.schcat,
        schdis: payload.schdis,
        townam: payload.townam
        // creatorId: getters.user.id
      };
      var nsm = nps.name;
      var nlat = nps.lat;
      var nlng = nps.lng;
      commit('createIsochron', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, nps));
      commit('setSchoolName', nsm);
      commit('setLat', nlat);
      commit('setLng', nlng);
    },
    pickPixels: function pickPixels(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setPixel', payload);
    },
    pickMins: function pickMins(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setMins', payload);
    },
    soloM: function soloM(_ref9, payload) {
      var commit = _ref9.commit,
          getters = _ref9.getters;

      commit('setFancyMins', payload);
    },
    pickType: function pickType(_ref10, payload) {
      var commit = _ref10.commit;

      var mode = payload;
      var modeIcon = 'directions_car';
      //, 'bike', 'directions_bike', 'walk', 'directions_walk''
      if (mode === 'walk') {
        var _modeIcon = 'directions_walk';
        commit('setTypeIcon', _modeIcon);
        commit('setType', mode);
      }
      if (mode === 'bike') {
        var _modeIcon2 = 'directions_bike';
        commit('setTypeIcon', _modeIcon2);
        commit('setType', mode);
      }
      if (mode === 'car') {
        var _modeIcon3 = 'directions_car';
        commit('setTypeIcon', _modeIcon3);
        commit('setType', mode);
      }
    },
    pickSecs: function pickSecs(_ref11, payload) {
      var commit = _ref11.commit;

      var secA = payload[0];
      var secB = payload[1];
      var secC = payload[2];
      var colorfiv = '#7fa995';
      var colorten = '#96c79d';
      var colorfif = '#b7ce98';
      var colortwy = '#e2ba8b';
      var colortwf = '#dfa38d';
      var colorthy = '#cc8f91';
      var colorthf = '#7f7f7f';
      var colornul = '#F0E9D8';
      var colorA = '';
      var colorB = '';
      var colorC = '';
      var minuteA = '';
      var minuteB = '';
      var minuteC = '';
      if (secA === 300) {
        var _colorA = colorfiv;
        var _minuteA = '5 minutes';
        commit('setColorA', _colorA);
        commit('setMinuteA', _minuteA);
      }
      if (secA === 600) {
        var _colorA2 = colorten;
        var _minuteA2 = '10 minutes';
        commit('setColorA', _colorA2);
        commit('setMinuteA', _minuteA2);
      }
      if (secA === 900) {
        var _colorA3 = colorfif;
        var _minuteA3 = '15 minutes';
        commit('setColorA', _colorA3);
        commit('setMinuteA', _minuteA3);
      }
      if (secA === 1200) {
        var _colorA4 = colortwy;
        var _minuteA4 = '20 minutes';
        commit('setColorA', _colorA4);
        commit('setMinuteA', _minuteA4);
      }
      if (secA === 1500) {
        var _colorA5 = colortwf;
        var _minuteA5 = '25 minutes';
        commit('setColorA', _colorA5);
        commit('setMinuteA', _minuteA5);
      }
      if (secA === 1800) {
        var _colorA6 = colorthy;
        var _minuteA6 = '30 minutes';
        commit('setColorA', _colorA6);
        commit('setMinuteA', _minuteA6);
      }
      if (secA === 2100) {
        var _colorA7 = colorthf;
        var _minuteA7 = '35 minutes';
        commit('setColorA', _colorA7);
        commit('setMinuteA', _minuteA7);
      }
      if (secA === 2400) {
        var _colorA8 = colorthf;
        var _minuteA8 = '40 minutes';
        commit('setColorA', _colorA8);
        commit('setMinuteA', _minuteA8);
      }
      if (secA === 2700) {
        var _colorA9 = colorthf;
        var _minuteA9 = '45 minutes';
        commit('setColorA', _colorA9);
        commit('setMinuteA', _minuteA9);
      }
      if (secA === 3000) {
        var _colorA10 = colorthf;
        var _minuteA10 = '50 minutes';
        commit('setColorA', _colorA10);
        commit('setMinuteA', _minuteA10);
      }
      if (secA === 3300) {
        var _colorA11 = colorthf;
        var _minuteA11 = '55 minutes';
        commit('setColorA', _colorA11);
        commit('setMinuteA', _minuteA11);
      }
      if (secA === 3600) {
        var _colorA12 = colorthf;
        var _minuteA12 = '60 minutes';
        commit('setColorA', _colorA12);
        commit('setMinuteA', _minuteA12);
      }
      if (secB === 600) {
        var _colorB = colorten;
        var _minuteB = '10 minutes';
        commit('setMinuteB', _minuteB);
        commit('setColorB', _colorB);
      }
      if (secB === 900) {
        var _colorB2 = colorfif;
        var _minuteB2 = '15 minutes';
        commit('setMinuteB', _minuteB2);
        commit('setColorB', _colorB2);
      }
      if (secB === 1200) {
        var _colorB3 = colortwy;
        var _minuteB3 = '20 minutes';
        commit('setMinuteB', _minuteB3);
        commit('setColorB', _colorB3);
      }
      if (secB === 1500) {
        var _colorB4 = colortwf;
        var _minuteB4 = '25 minutes';
        commit('setMinuteB', _minuteB4);
        commit('setColorB', _colorB4);
      }
      if (secB === 1800) {
        var _colorB5 = colorthy;
        var _minuteB5 = '30 minutes';
        commit('setMinuteB', _minuteB5);
        commit('setColorB', _colorB5);
      }
      if (secB === 2100) {
        var _colorB6 = colorthf;
        var _minuteB6 = '35 minutes';
        commit('setMinuteB', _minuteB6);
        commit('setColorB', _colorB6);
      }
      if (secB === 2400) {
        var _colorB7 = colorthf;
        var _minuteB7 = '40 minutes';
        commit('setMinuteB', _minuteB7);
        commit('setColorB', _colorB7);
      }
      if (secB === 2700) {
        var _colorB8 = colorthf;
        var _minuteB8 = '45 minutes';
        commit('setMinuteB', _minuteB8);
        commit('setColorB', _colorB8);
      }
      if (secB === 3000) {
        var _colorB9 = colorthf;
        var _minuteB9 = '50 minutes';
        commit('setMinuteB', _minuteB9);
        commit('setColorB', _colorB9);
      }
      if (secB === 3300) {
        var _colorB10 = colorthf;
        var _minuteB10 = '55 minutes';
        commit('setMinuteB', _minuteB10);
        commit('setColorB', _colorB10);
      }
      if (secB === 3600) {
        var _colorB11 = colorthf;
        var _minuteB11 = '60 minutes';
        commit('setMinuteB', _minuteB11);
        commit('setColorB', _colorB11);
      }
      if (secC === 900) {
        var _colorC = colorfif;
        var _minuteC = '15 minutes';
        commit('setColorC', _colorC);
        commit('setMinuteC', _minuteC);
      }
      if (secC === 1200) {
        var _colorC2 = colortwy;
        var _minuteC2 = '20 minutes';
        commit('setColorC', _colorC2);
        commit('setMinuteC', _minuteC2);
      }
      if (secC === 1500) {
        var _colorC3 = colortwf;
        var _minuteC3 = '25 minutes';
        commit('setColorC', _colorC3);
        commit('setMinuteC', _minuteC3);
      }
      if (secC === 1800) {
        var _colorC4 = colorthy;
        var _minuteC4 = '30 minutes';
        commit('setColorC', _colorC4);
        commit('setMinuteC', _minuteC4);
      }
      if (secC === 2100) {
        var _colorC5 = colorthf;
        var _minuteC5 = '35 minutes';
        commit('setColorC', _colorC5);
        commit('setMinuteC', _minuteC5);
      }
      if (secC === 2400) {
        var _colorC6 = colorthf;
        var _minuteC6 = '40 minutes';
        commit('setColorC', _colorC6);
        commit('setMinuteC', _minuteC6);
      }
      if (secC === 2700) {
        var _colorC7 = colorthf;
        var _minuteC7 = '45 minutes';
        commit('setColorC', _colorC7);
        commit('setMinuteC', _minuteC7);
      }
      if (secC === 3000) {
        var _colorC8 = colorthf;
        var _minuteC8 = '50 minutes';
        commit('setColorC', _colorC8);
        commit('setMinuteC', _minuteC8);
      }
      if (secC === 3300) {
        var _colorC9 = colorthf;
        var _minuteC9 = '55 minutes';
        commit('setColorC', _colorC9);
        commit('setMinuteC', _minuteC9);
      }
      if (secC === 3600) {
        var _colorC10 = colorthf;
        var _minuteC10 = '60 minutes';
        commit('setColorC', _colorC10);
        commit('setMinuteC', _minuteC10);
      }
      if (secB === 0 || secB === undefined || secB === null) {
        var _colorB12 = colornul;
        var _colorC11 = colornul;
        var _minuteB12 = '';
        var _minuteC11 = '';
        commit('setMinuteB', _minuteB12);
        commit('setColorB', _colorB12);
        commit('setColorC', _colorC11);
        commit('setMinuteC', _minuteC11);
      }
      if (secC === 0 || secC === undefined || secC === null) {
        var _colorC12 = colornul;
        var _minuteC12 = '';
        commit('setColorC', _colorC12);
        commit('setMinuteC', _minuteC12);
      }
      commit('setSecs', payload);
    },
    clearError: function clearError(_ref12) {
      var commit = _ref12.commit;

      commit('clearError');
    },
    twoTone: function twoTone(_ref13, payload) {
      var commit = _ref13.commit,
          getters = _ref13.getters;

      commit('setTwoTone', payload);
    },
    pickBase: function pickBase(_ref14, payload) {
      var commit = _ref14.commit;

      commit('setBase', payload);
    },
    idFrom: function idFrom(_ref15, payload) {
      var commit = _ref15.commit;

      commit('setIdFrom', payload);
    }
    /*
      let pB = payload
      let bOs = ''
      if (pB === 'Vintage') {
        let bOs = 'mapbox://styles/altophoto/cjabw6nax3sgf2sntkany1okv'
        L.mapbox.styleLayer.clearLayers().addLayer(bOs)
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Decimal') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Terminal') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'VT Town Boundaries') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Red Pins') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Basic Vector') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Scenic') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Town and Country') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'North Star') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Ice Cream') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Desert planet') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'whaam!') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Satellite Vector') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Satellite Streets Vector') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Outdoors') {
        // L.mapbox.styleLayer
        let bOs = 'mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
    }
    /*
      if (pB === 'OpenStreetMap Default') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.Mapnik'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'OpenStreetMap German Style') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.DE'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'OpenStreetMap Black and White') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.BlackAndWhite'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'OpenStreetMap H.O.T.') {
        // L.tileLayer.provider
        let bOs = 'OpenStreetMap.HOT'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Red Pins-Raster') {
        // L.tileLayer.provider
        let bOs = 'RedPins'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'VT Town Boundaries-Raster') {
        // L.tileLayer.provider
        let bOs = 'TownBoundaries'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Town and Country-Raster') {
        // L.tileLayer.provider
        let bOs = 'TownAndCountry'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Outdoors-Raster') {
        // L.tileLayer.provider
        let bOs = 'Outdoors'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Raster Satellite') {
        // L.tileLayer.provider
        let bOs = 'Satellite'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Satellite Streets') {
        // L.tileLayer.provider
        let bOs = 'SatelliteStreets'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Hydda') {
        // L.tileLayer.provider
        let bOs = 'Hydda.Full'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Basic') {
        // L.tileLayer.provider
        let bOs = 'BasicMapbox'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
       if (pB === 'Toner') {
        // L.tileLayer.provider
        let bOs = .tileLayer.provid
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === ('Toner')) {
        // L.tileLayer.provider
        let bOs = ''
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === ('Watercolor')) {
        // L.tileLayer.provider
        let bOs = ''
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
       if (pB === 'Terrain') {
        // L.tileLayer.provider
        let bOs = 'Stamen.Terrain'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
       if (pB === 'Esri WorldStreetMap') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldStreetMap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri DeLorme') {
        // L.tileLayer.provider
        let bOs = 'Esri.DeLorme'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldTopoMap') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldTopoMap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldImagery') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldImagery'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldTerrain') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldTerrain'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldShadedRelief') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldShadedRelief'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldPhysical') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldPhysical'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri OceanBasemap') {
        // L.tileLayer.provider
        let bOs = 'Esri.OceanBasemap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri NatGeoWorldMap') {
        // L.tileLayer.provider
        let bOs = 'Esri.NatGeoWorldMap'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
      if (pB === 'Esri WorldGrayCanvas') {
        // L.tileLayer.provider
        let bOs = 'Esri.WorldGrayCanvas'
        commit('setBase', payload)
        commit('setBaseStyle', bOs)
      }
       'Decimal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'),
      'Terminal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'),
      // Vermont
      'VT Town Boundaries': L.mapbox.styleLayer('mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'),
      'Red Pins': L.mapbox.styleLayer('mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'),
      // Open Street Map
      'OpenStreetMap Default': L.tileLayer.provider('OpenStreetMap.Mapnik'),
      'OpenStreetMap German Style': L.tileLayer.provider('OpenStreetMap.DE'),
      'OpenStreetMap Black and White': L.tileLayer.provider('OpenStreetMap.BlackAndWhite'),
      'OpenStreetMap H.O.T.': L.tileLayer.provider('OpenStreetMap.HOT'),
      // Raster
      'Red Pins-Raster': L.tileLayer.provider('RedPins'),
      'VT Town Boundaries-Raster': L.tileLayer.provider('TownBoundaries'),
      'Town and Country-Raster': L.tileLayer.provider('TownAndCountry'),
      'Outdoors-Raster': L.tileLayer.provider('Outdoors'),
      'Raster Satellite': L.tileLayer.provider('Satellite'),
      'Satellite Streets': L.tileLayer.provider('SatelliteStreets'),
      // Slick
      'Hydda': L.tileLayer.provider('Hydda.Full'),
      'Basic Mapbox': L.tileLayer.provider('BasicMapbox'),
      'Basic Vector': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'),
      'Scenic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'),
      'Town and Country': L.mapbox.styleLayer('mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'),
      'Standard': defaultLayer,
      'North Star': L.mapbox.styleLayer ('mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'),
      // Funky
      'Toner': L.tileLayer.provider('Stamen.Toner'),
      'Watercolor': L.tileLayer.provider('Stamen.Watercolor'),
      'Vintage': L.mapbox.styleLayer(),
      'Ice Cream': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'),
      'Desert planet': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'),
      'whaam!': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'),
      // Outdoors
      'Terrain': L.tileLayer.provider('Stamen.Terrain'),
      '(vector) Satellite': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'),
      '(vector) Satellite Streets': L.mapbox.styleLayer('mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'),
      'Outdoors': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'),
      // Esri
      'Esri WorldStreetMap': L.tileLayer.provider('Esri.WorldStreetMap'),
      'Esri DeLorme': L.tileLayer.provider('Esri.DeLorme'),
      'Esri WorldTopoMap': L.tileLayer.provider('Esri.WorldTopoMap'),
      'Esri WorldImagery': L.tileLayer.provider('Esri.WorldImagery'),
      'Esri WorldTerrain': L.tileLayer.provider('Esri.WorldTerrain'),
      'Esri WorldShadedRelief': L.tileLayer.provider('Esri.WorldShadedRelief'),
      'Esri WorldPhysical': L.tileLayer.provider('Esri.WorldPhysical'),
      'Esri OceanBasemap': L.tileLayer.provider('Esri.OceanBasemap'),
      'Esri NatGeoWorldMap': L.tileLayer.provider('Esri.NatGeoWorldMap'),
      'Esri WorldGrayCanvas': L.tileLayer.provider('Esri.WorldGrayCanvas')
    */

  }
});
'filehash fybwqyqG4DcX6g0TPxCKHI+KA2k=';

/***/ })

},[668]);


// WEBPACK FOOTER //
// static/js/app.9b89ec0f0eace7eadcdd.js